/* PVI Product Page JavaScript
   Lightbox, Sticky Bar, Video Embed, AI Chatbot
   Loaded defer — runs after DOM ready */

(function() {
  'use strict';

  var API_BASE = 'https://pvi-ai-assistant.silent-voice-b4f1.workers.dev';
  var product = window.__pviProduct || {};
  // Page context: prefer what the Liquid gives us, but if it's missing (e.g. the
  // theme didn't inject __pviPageContext), derive it from the URL so the greeting
  // always follows the page — especially collection pages.
  function pviHumanize(h) {
    var s = String(h || '').replace(/[-_]+/g, ' ').trim();
    s = s.replace(/\b([a-z])/g, function(m, c) { return c.toUpperCase(); });
    // Fix common acronyms so the AI doesn't say "Iptv" / "Rf"
    s = s.replace(/\b(Iptv|Rf|Hdmi|Sdi|Av|Hd|Ndi|Srt|Catv|Qam|Atsc|Dvbt|Dvbc|Isdbt|Vumatrix|Infinium|Vecoax|Vecaster|Vecoder|Veplayer)\b/g, function(w) {
      var map = { Iptv: 'IPTV', Rf: 'RF', Hdmi: 'HDMI', Sdi: 'SDI', Av: 'AV', Hd: 'HD', Ndi: 'NDI', Srt: 'SRT', Catv: 'CATV', Qam: 'QAM', Atsc: 'ATSC', Dvbt: 'DVB-T', Dvbc: 'DVB-C', Isdbt: 'ISDB-T', Vumatrix: 'VuMATRIX', Infinium: 'INFINIUM', Vecoax: 'VeCOAX', Vecaster: 'VeCASTER', Vecoder: 'VeCODER', Veplayer: 'VePLAYER' };
      return map[w] || w;
    });
    s = s.replace(/\b4k\b/gi, '4K');
    return s;
  }
  function pviCollectionName(handle) {
    var map = {
      'rf-modulators-catv-hdmi': 'RF Modulators', 'rf-modulators': 'RF Modulators',
      'hdmi-rf-modulators': 'RF Modulators', 'modulators': 'RF Modulators',
      'iptv-encoders': 'IPTV Encoders', 'encoders': 'IPTV Encoders',
      'iptv-decoders': 'IPTV Decoders', 'decoders': 'IPTV Decoders',
      'vumatrix-4k-video-wall-kits': 'VuMATRIX Video Wall Kits',
      'vumatrix': 'VuMATRIX HDMI-over-IP', 'hdmi-over-ip': 'VuMATRIX HDMI-over-IP',
      'av-over-ip': 'VuMATRIX HDMI-over-IP',
      '4k-over-everything-iptv-rf': 'INFINIUM 4K System', 'infinium': 'INFINIUM Modular System'
    };
    return map[handle] || pviHumanize(handle);
  }
  function pviResolvePageContext() {
    var ctx = window.__pviPageContext || {};
    if (ctx && ctx.page_type) return ctx; // trust the Liquid if it provided it
    var path = (location.pathname || '').toLowerCase();
    path = path.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/, ''); // strip locale prefix
    var out = { page_type: '', page_title: '', collection_handle: '', page_handle: '' };
    var m;
    if ((m = path.match(/\/products\/([^\/?#]+)/))) {
      out.page_type = 'product'; out.page_handle = m[1];
    } else if ((m = path.match(/\/collections\/([^\/?#]+)/))) {
      out.page_type = 'collection'; out.collection_handle = m[1];
      out.page_title = pviCollectionName(m[1]);
    } else if ((m = path.match(/\/pages\/([^\/?#]+)/))) {
      out.page_type = 'page'; out.page_handle = m[1]; out.page_title = pviHumanize(m[1]);
    } else if (path === '' || path === '/') {
      out.page_type = 'index';
    }
    // Let any non-empty Liquid values win over the URL-derived ones
    if (ctx) {
      out.page_title = ctx.page_title || out.page_title;
      out.collection_handle = ctx.collection_handle || out.collection_handle;
      out.page_handle = ctx.page_handle || out.page_handle;
    }
    return out;
  }
  var pageCtx = pviResolvePageContext();
  // Fallback: if on a product page but Liquid didn't inject __pviProduct,
  // derive handle and title from the URL so the AI still knows the page
  if (!product.handle || !product.title) {
    var _pm = (location.pathname || '').match(/\/products\/([^\/?#]+)/);
    if (_pm) {
      if (!product.handle) product.handle = _pm[1];
      if (!product.title) product.title = pviHumanize(_pm[1]);
    }
  }
  // Session continuity: persist across page navigation so the chat remembers
  // the whole customer visit (all questions/answers). Uses localStorage so it
  // works across tabs too, with a 3-hour sliding expiry so a later visit is fresh.
  var PVI_SESSION_KEY = 'pvi-chat-session';
  var PVI_SESSION_TTL = 3 * 60 * 60 * 1000; // 3 hours
  var pviRestored = (function() {
    try {
      var raw = localStorage.getItem(PVI_SESSION_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ts || (Date.now() - obj.ts) > PVI_SESSION_TTL) {
        localStorage.removeItem(PVI_SESSION_KEY);
        return null;
      }
      return obj;
    } catch (_) { return null; }
  })();
  var sessionId = (pviRestored && pviRestored.id) || ('pvi-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8));
  var chatHistory = (pviRestored && pviRestored.history && pviRestored.history.length) ? pviRestored.history : [];
  // Mode tracking: 'info' or 'support' once chosen, null if not yet asked
  var chosenPersona = (pviRestored && pviRestored.chosenPersona) || null;
  // UNIFIED DEPARTMENTS (Jul 30 2026) — the web now mirrors the phone office:
  // Dana (reception) answers NEUTRAL pages and routes; Lisa (sales), John
  // (tech support), Mary (customer service) take over via mode_update events.
  // pviActivePersona drives the chat name labels and web-voice persona restarts.
  var PVI_PERSONA_LABELS = { reception: 'Dana \u00b7 Reception', sales: 'Lisa \u00b7 Sales', support: 'John \u00b7 Tech Support', service: 'Mary \u00b7 Customer Service' };
  var pviLastLabeledPersona = null;
  var pviActivePersona = (pviRestored && pviRestored.activePersona) || null;
  // Dana is PHONE-ONLY (Jul 30 2026): sessions saved before the change may
  // still carry 'reception' — remap so Lisa answers instead.
  if (pviActivePersona === 'reception') pviActivePersona = null;
  // One-shot department hint from a quick-action chip click (Aug 5 2026):
  // set by the chip handler, sent with exactly one /api/chat request.
  var pviChipPersonaHint = '';
  var supportProduct = (pviRestored && pviRestored.supportProduct) || null;
  // When a TEXT mode switch navigates to another page, remember it so the
  // destination page can post a product-confirming greeting + reopen the panel
  // (otherwise the reload drops the conversation into silence). Consumed once.
  var pviPendingSwitch = (pviRestored && pviRestored.pendingSwitch) || null;
  var hasInteracted = !!(pviRestored && pviRestored.history && pviRestored.history.length > 0);
  // Link dedupe — CONSECUTIVE ONLY. A link is skipped ONLY if it was in the
  // MOST RECENT link print. Printing a DIFFERENT link clears the block, so
  // the same link can be printed again later. Exactly:
  //   print #1 → OK · print #1 → skip · print #2 → OK · print #1 → OK
  //   print #1 → skip · print #2 → OK · print #2 → skip
  // Persisted across page navigations (same session).
  var pviShownLinks = (pviRestored && pviRestored.shownLinks) || {};
  function pviLinkShown(url) { return !!pviShownLinks[url]; }
  function pviMarkLinkBatch(urls) {
    pviShownLinks = {};
    for (var i = 0; i < urls.length; i++) pviShownLinks[urls[i]] = 1;
    pviSaveSession();
  }
  function pviMarkLinkShown(url) { pviMarkLinkBatch([url]); }
  function pviSaveSession() {
    try {
      var panel = document.getElementById('pviChatPanel');
      localStorage.setItem(PVI_SESSION_KEY, JSON.stringify({
        id: sessionId,
        history: chatHistory.slice(-40),
        open: (panel && panel.classList.contains('open')) ? 1 : 0,
        mode: currentMode,
        chosenPersona: chosenPersona,
        activePersona: pviActivePersona,
        supportProduct: supportProduct,
        pendingSwitch: pviPendingSwitch,
        shownLinks: pviShownLinks,
        ts: Date.now()
      }));
    } catch (_) {}
  }
  function pviEscapeHtml(x) { return String(x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  // ════════════════════════════════════════════════════════
  // Universal form submission — used for quotes, callbacks, support tickets, etc.
  // Sends to: (1) worker /api/lead for KV backup
  //           (2) hidden Shopify page form for email delivery to sales@
  // The Shopify form lives on a standalone hidden page (not in any menu).
  // ════════════════════════════════════════════════════════
  function pviSubmitForm(data) {
    var payload = {
      type: data.type || 'quote_request',
      name: data.name || '',
      email: data.email || '',
      phone: data.phone || '',
      product: data.product || (product && product.title) || '',
      quantity: data.quantity || '',
      message: data.message || '',
      source: currentMode === 'voice' ? 'voice_chat' : 'text_chat',
      page_url: window.location.pathname
    };

    // 1) Send to worker for KV backup
    fetch(API_BASE + '/api/lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(r) {
      console.log('[PVI Form] Worker lead saved:', r.ok);
    }).catch(function(e) {
      console.error('[PVI Form] Worker lead error:', e);
    });

    // Email is sent by the worker via Web3Forms — no frontend form needed.
  }

  // Listen for lead data from the AI's streamed response (hidden tag extraction)
  function pviCheckForLeadTag(fullText) {
    var match = fullText.match(/<!--PVI_LEAD:(.*?)-->/);
    if (!match) return;
    try {
      var data = JSON.parse(match[1]);
      pviSubmitForm(data);
    } catch (_) {}
  }

  // Voice quote confirmation — extract lead from conversation history when the AI
  // confirms sending a quote (voice can't emit hidden HTML tags, so we parse the chat)
  var pviVoiceQuoteSubmitted = false;

  // Convert spoken email ("john at gmail dot com") to standard format
  function pviNormalizeSpokenEmail(text) {
    var t = text.toLowerCase()
      .replace(/\s+dot\s+/gi, '.')
      .replace(/\s+at\s+/gi, '@')
      .replace(/\s+underscore\s+/gi, '_')
      .replace(/\s+dash\s+/gi, '-')
      .replace(/\s+hyphen\s+/gi, '-');
    var em = t.match(/[\w.+-]+@[\w.-]+\.\w{2,}/);
    return em ? em[0] : null;
  }

  // Extract lead info (name, email, phone, product) from conversation history
  function pviExtractLeadFromHistory() {
    var name = '', email = '', phone = '', qty = '', prod = '';
    for (var i = chatHistory.length - 1; i >= 0; i--) {
      var msg = chatHistory[i].content || '';
      if (!email) {
        var em = msg.match(/[\w.+-]+@[\w.-]+\.\w{2,}/);
        if (em) { email = em[0]; }
        else {
          var spoken = pviNormalizeSpokenEmail(msg);
          if (spoken) email = spoken;
        }
      }
      if (!phone) {
        var ph = msg.match(/\b(\+?\d[\d\s\-().]{7,}\d)\b/);
        if (ph) phone = ph[1];
      }
      if (!name) {
        var nameMatch = msg.match(/(?:(?:my name is|i'm|i am|this is|name:?|call me)\s+)([A-Z][a-z]+(?:\s+[A-Z][a-z]+)?)/i);
        if (nameMatch) { name = nameMatch[1]; }
        else if (chatHistory[i].role === 'assistant') {
          var aiName = msg.match(/(?:for|to)\s+([A-Z][a-z]+(?:\s+[A-Z][a-z]+)?)\s+(?:at|@)/i);
          if (aiName) name = aiName[1];
        }
      }
      if (!qty) {
        var qm = msg.match(/(\d+)\s*(?:unit|piece|qty|quantity|of them|of those|modules?|modulators?|encoders?|channels?)/i);
        if (qm) qty = qm[1];
      }
    }
    prod = (product && product.title) || '';
    return { name: name, email: email, phone: phone, quantity: qty, product: prod };
  }

  function pviVoiceCheckQuoteConfirm(aiText) {
    if (pviVoiceQuoteSubmitted) return;
    var lower = aiText.toLowerCase();

    // Detect quote confirmation
    var isQuoteConfirm = /(\bsend\b.*\bquote\b|\bquote\b.*\bshortly\b|\bquote\b.*\bsent\b|\bquote\b.*\bsubmit|\bsales team\b.*\bget back|\bsales team\b.*\bsend|\bperfect.*\bquote\b|\bwe('|.wi)ll send|\bsend (you|it) (over|right|shortly)|got (it|that).*\bquote\b)/i.test(lower);

    // Detect support ticket confirmation
    var isTicketConfirm = /(\bticket\b.*\breceived\b|\bticket\b.*\bsubmit|\bticket\b.*\bopen|\bopened.*\bticket\b|\bticket\b.*\bcreated|\bcontact you\b.*\bsoon\b.*\bpossible\b|\blabs are open\b|\bengineers?\b.*\bget back\b|\bengineers?\b.*\brespond\b|\burgency\b)/i.test(lower);

    if (!isQuoteConfirm && !isTicketConfirm) return;

    var info = pviExtractLeadFromHistory();

    if (!info.email) {
      console.log('[PVI Voice] Confirmation detected but no email found in conversation');
      return;
    }

    pviVoiceQuoteSubmitted = true;

    if (isTicketConfirm) {
      // Build detailed message from recent conversation
      var issueDetails = '';
      for (var i = Math.max(0, chatHistory.length - 10); i < chatHistory.length; i++) {
        if (chatHistory[i].role === 'user') {
          issueDetails += chatHistory[i].content + ' | ';
        }
      }
      pviSubmitForm({
        type: 'support_ticket',
        name: info.name,
        email: info.email,
        phone: info.phone,
        product: info.product,
        quantity: '',
        message: 'Voice support ticket. Customer issue: ' + issueDetails.substring(0, 500)
      });
      console.log('[PVI Voice] Support ticket auto-submitted for', info.email);
    } else {
      var aiRecap = aiText.match(/(\d+)\s*(?:unit|×|x)\s+(\w[\w\s-]+)/i);
      if (aiRecap) {
        if (!info.quantity) info.quantity = aiRecap[1];
        if (!info.product) info.product = aiRecap[2].trim();
      }
      pviSubmitForm({
        type: 'quote_request',
        name: info.name,
        email: info.email,
        phone: info.phone,
        product: info.product,
        quantity: info.quantity,
        message: 'Voice quote request. Last AI: ' + aiText.substring(0, 200)
      });
      console.log('[PVI Voice] Quote auto-submitted for', info.email);
    }
  }
  var isStreaming = false;
  var chatGeneration = 0;
  var currentMode = 'text';

  // ════════════════════════════════════════════════════════
  // i18n — UI strings + auto-detect from subdomain
  // ════════════════════════════════════════════════════════
  var SUPPORTED_LANGS = ['en','es','it','fr','de','pt','ja','zh','ko','ru','ar','nl'];

  var I18N = {
    en: {
      name: 'English',
      voiceHint: 'Click <strong>Voice</strong> to switch to voice mode.',
      welcome: 'Hi! How can I help you today?',
      welcomeProduct: 'Hi! You are on the <strong>{product}</strong> page. Would you like any information on this product, or anything else?',
      welcomeReturn: 'I see you\'re now looking at <strong>{product}</strong>. What would you like to know?',
      welcomeReception: 'Hi, this is <strong>Dana</strong>! Are you looking at a new purchase, need tech support on a unit you own, or checking on an existing order?',
      chips: ['Tell me about this product', 'Help me choose', 'How do I set it up?', 'Get a quote'],
      chipsNoProduct: ['Customer Service', 'Login Reset', 'Check an Order', 'Technical Support', 'Get a Quote', 'Help Me Choose a Product'],
      chipPrompts: ['Tell me about the {product}', 'Help me choose the right modulator for my needs', 'How do I set up the {product}?', 'I need a quote for a bulk order'],
      chipPromptsNoProduct: ['I need customer service', 'I forgot my store account login, can you help me reset it?', 'I want to check the status of my order', 'I need technical support with my PVI product', 'I need a quote for a bulk order', 'Help me choose the right product for my needs'],
      placeholder: 'Type your question...',
      listening: 'Listening... Speak naturally',
      voiceMode: 'AI Voice Mode',
      textMode: 'Text Chat Mode',
      talkHuman: 'Talk to a specialist',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    },
    es: {
      name: 'Espa\u00f1ol',
      voiceHint: 'Haz clic en <strong>Voz</strong> para cambiar al modo de voz.',
      welcome: '\u00a1Hola! \u00bfEn qu\u00e9 puedo ayudarte hoy?',
      welcomeProduct: '\u00a1Hola! Est\u00e1s en la p\u00e1gina del <strong>{product}</strong>. \u00bfTe gustar\u00eda informaci\u00f3n sobre este producto, o cualquier otra cosa?',
      welcomeReturn: 'Veo que ahora est\u00e1s mirando <strong>{product}</strong>. \u00bfQu\u00e9 te gustar\u00eda saber?',
      welcomeReception: '\u00a1Hola, soy <strong>Dana</strong>! \u00bfBuscas una nueva compra, necesitas soporte t\u00e9cnico para un equipo que ya tienes, o quieres consultar un pedido existente?',
      chips: ['Cu\u00e9ntame sobre este producto', 'Ay\u00fadame a elegir', '\u00bfC\u00f3mo lo configuro?', 'Solicitar cotizaci\u00f3n'],
      chipsNoProduct: ['Atenci\u00f3n al Cliente', 'Restablecer Acceso', 'Consultar un Pedido', 'Soporte T\u00e9cnico', 'Solicitar Cotizaci\u00f3n', 'Ay\u00fadame a Elegir un Producto'],
      chipPrompts: ['H\u00e1blame sobre el {product}', 'Ay\u00fadame a elegir el modulador adecuado', '\u00bfC\u00f3mo configuro el {product}?', 'Necesito una cotizaci\u00f3n para un pedido grande'],
      chipPromptsNoProduct: ['Necesito atenci\u00f3n al cliente', 'Olvid\u00e9 mi contrase\u00f1a de acceso a la tienda, \u00bfpuedes ayudarme a restablecerla?', 'Quiero consultar el estado de mi pedido', 'Necesito soporte t\u00e9cnico para mi producto PVI', 'Necesito una cotizaci\u00f3n para un pedido grande', 'Ay\u00fadame a elegir el producto correcto'],
      placeholder: 'Escribe tu pregunta...',
      listening: 'Escuchando... Habla con naturalidad',
      voiceMode: 'Modo Voz IA',
      textMode: 'Modo Chat de Texto',
      talkHuman: 'Hablar con un especialista',
      langSwitch: 'in English',
      langSwitchTo: 'en'
    },
    it: {
      name: 'Italiano',
      voiceHint: 'Clicca <strong>Voce</strong> per passare alla modalit\u00e0 vocale.',
      welcome: 'Ciao! Come posso aiutarti oggi?',
      welcomeProduct: 'Ciao! Sei sulla pagina del <strong>{product}</strong>. Vuoi informazioni su questo prodotto, o qualsiasi altra cosa?',
      welcomeReturn: 'Vedo che stai guardando <strong>{product}</strong>. Cosa vorresti sapere?',
      welcomeReception: 'Ciao, sono <strong>Dana</strong>! Stai valutando un nuovo acquisto, ti serve assistenza tecnica per un\u2019unit\u00e0 che possiedi, o vuoi controllare un ordine esistente?',
      chips: ['Parlami di questo prodotto', 'Aiutami a scegliere', 'Come lo configuro?', 'Richiedi un preventivo'],
      chipsNoProduct: ['Servizio Clienti', 'Reset Password', 'Controlla un Ordine', 'Supporto Tecnico', 'Richiedi un Preventivo', 'Aiutami a Scegliere un Prodotto'],
      chipPrompts: ['Parlami del {product}', 'Aiutami a scegliere il modulatore giusto', 'Come configuro il {product}?', 'Vorrei un preventivo per un ordine grande'],
      chipPromptsNoProduct: ['Ho bisogno del servizio clienti', 'Ho dimenticato la password di accesso al negozio, puoi aiutarmi a reimpostarla?', 'Vorrei controllare lo stato del mio ordine', 'Ho bisogno di supporto tecnico per il mio prodotto PVI', 'Vorrei un preventivo per un ordine grande', 'Aiutami a scegliere il prodotto giusto'],
      placeholder: 'Scrivi la tua domanda...',
      listening: 'In ascolto... Parla normalmente',
      voiceMode: 'Modalit\u00e0 Voce IA',
      textMode: 'Chat Testuale',
      talkHuman: 'Parla con uno specialista',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    },
    fr: {
      name: 'Fran\u00e7ais',
      voiceHint: 'Cliquez sur <strong>Voix</strong> pour passer au mode vocal.',
      welcome: 'Bonjour ! Comment puis-je vous aider aujourd\'hui ?',
      welcomeProduct: 'Bonjour ! Vous \u00eates sur la page <strong>{product}</strong>. Souhaitez-vous des informations sur ce produit, ou autre chose ?',
      welcomeReturn: 'Je vois que vous regardez maintenant <strong>{product}</strong>. Que souhaitez-vous savoir ?',
      welcomeReception: 'Bonjour, c\u2019est <strong>Dana</strong> ! Vous envisagez un nouvel achat, avez besoin d\u2019assistance technique pour un appareil que vous poss\u00e9dez, ou souhaitez v\u00e9rifier une commande existante ?',
      chips: ['Parlez-moi de ce produit', 'Aidez-moi \u00e0 choisir', 'Comment le configurer ?', 'Demander un devis'],
      chipsNoProduct: ['Service Client', 'R\u00e9initialiser Mon Acc\u00e8s', 'Suivre une Commande', 'Support Technique', 'Demander un Devis', 'Aidez-moi \u00e0 Choisir un Produit'],
      chipPrompts: ['Parlez-moi du {product}', 'Aidez-moi \u00e0 choisir le bon modulateur', 'Comment configurer le {product} ?', 'J\'ai besoin d\'un devis pour une grosse commande'],
      chipPromptsNoProduct: ['J\'ai besoin du service client', 'J\'ai oubli\u00e9 mon mot de passe de connexion \u00e0 la boutique, pouvez-vous m\'aider \u00e0 le r\u00e9initialiser ?', 'Je veux v\u00e9rifier le statut de ma commande', 'J\'ai besoin de support technique pour mon produit PVI', 'J\'ai besoin d\'un devis pour une grosse commande', 'Aidez-moi \u00e0 choisir le bon produit'],
      placeholder: 'Tapez votre question...',
      listening: 'J\'\u00e9coute... Parlez naturellement',
      voiceMode: 'Mode Voix IA',
      textMode: 'Mode Chat Texte',
      talkHuman: 'Parler \u00e0 un sp\u00e9cialiste',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    },
    de: {
      name: 'Deutsch',
      voiceHint: 'Klicken Sie auf <strong>Stimme</strong>, um in den Sprachmodus zu wechseln.',
      welcome: 'Hallo! Wie kann ich Ihnen heute helfen?',
      welcomeProduct: 'Hallo! Sie sind auf der Seite <strong>{product}</strong>. M\u00f6chten Sie Informationen zu diesem Produkt oder etwas anderem?',
      welcomeReturn: 'Ich sehe, Sie schauen sich jetzt <strong>{product}</strong> an. Was m\u00f6chten Sie wissen?',
      welcomeReception: 'Hallo, hier ist <strong>Dana</strong>! M\u00f6chten Sie etwas Neues kaufen, brauchen Sie technischen Support f\u00fcr ein Ger\u00e4t, das Sie besitzen, oder m\u00f6chten Sie eine bestehende Bestellung pr\u00fcfen?',
      chips: ['Erz\u00e4hlen Sie mir vom Produkt', 'Helfen Sie mir bei der Auswahl', 'Wie installiere ich es?', 'Angebot anfordern'],
      chipsNoProduct: ['Kundenservice', 'Login zur\u00fccksetzen', 'Bestellung pr\u00fcfen', 'Technischer Support', 'Angebot anfordern', 'Hilfe bei der Produktwahl'],
      chipPrompts: ['Erz\u00e4hlen Sie mir \u00fcber den {product}', 'Helfen Sie mir, den richtigen Modulator zu w\u00e4hlen', 'Wie richte ich den {product} ein?', 'Ich brauche ein Angebot f\u00fcr eine Gro\u00dfbestellung'],
      chipPromptsNoProduct: ['Ich brauche den Kundenservice', 'Ich habe mein Shop-Passwort vergessen, k\u00f6nnen Sie mir helfen, es zur\u00fcckzusetzen?', 'Ich m\u00f6chte den Status meiner Bestellung pr\u00fcfen', 'Ich brauche technischen Support f\u00fcr mein PVI-Produkt', 'Ich brauche ein Angebot f\u00fcr eine Gro\u00dfbestellung', 'Helfen Sie mir, das richtige Produkt zu w\u00e4hlen'],
      placeholder: 'Geben Sie Ihre Frage ein...',
      listening: 'H\u00f6re zu... Sprechen Sie nat\u00fcrlich',
      voiceMode: 'KI-Sprachmodus',
      textMode: 'Text-Chat-Modus',
      talkHuman: 'Mit einem Spezialisten sprechen',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    },
    pt: {
      name: 'Portugu\u00eas',
      voiceHint: 'Clique em <strong>Voz</strong> para mudar para o modo de voz.',
      welcome: 'Ol\u00e1! Como posso ajudar hoje?',
      welcomeProduct: 'Ol\u00e1! Voc\u00ea est\u00e1 na p\u00e1gina do <strong>{product}</strong>. Gostaria de informa\u00e7\u00f5es sobre este produto, ou algo mais?',
      welcomeReturn: 'Vejo que voc\u00ea est\u00e1 olhando <strong>{product}</strong>. O que gostaria de saber?',
      welcomeReception: 'Ol\u00e1, aqui \u00e9 a <strong>Dana</strong>! Est\u00e1 pensando em uma nova compra, precisa de suporte t\u00e9cnico para um equipamento que j\u00e1 possui, ou quer verificar um pedido existente?',
      chips: ['Fale-me sobre este produto', 'Ajude-me a escolher', 'Como configurar?', 'Pedir or\u00e7amento'],
      chipsNoProduct: ['Atendimento ao Cliente', 'Redefinir Acesso', 'Consultar um Pedido', 'Suporte T\u00e9cnico', 'Pedir Or\u00e7amento', 'Ajude-me a Escolher um Produto'],
      chipPrompts: ['Fale-me sobre o {product}', 'Ajude-me a escolher o modulador certo', 'Como configurar o {product}?', 'Preciso de um or\u00e7amento para um pedido grande'],
      chipPromptsNoProduct: ['Preciso de atendimento ao cliente', 'Esqueci minha senha de acesso \u00e0 loja, pode me ajudar a redefinir?', 'Quero verificar o status do meu pedido', 'Preciso de suporte t\u00e9cnico para meu produto PVI', 'Preciso de um or\u00e7amento para um pedido grande', 'Ajude-me a escolher o produto certo'],
      placeholder: 'Digite sua pergunta...',
      listening: 'Ouvindo... Fale naturalmente',
      voiceMode: 'Modo Voz IA',
      textMode: 'Modo Chat de Texto',
      talkHuman: 'Falar com um especialista',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    },
    ja: {
      name: '\u65e5\u672c\u8a9e',
      voiceHint: '<strong>\u97f3\u58f0</strong>\u3092\u30af\u30ea\u30c3\u30af\u3057\u3066\u97f3\u58f0\u30e2\u30fc\u30c9\u306b\u5207\u308a\u66ff\u3048\u3066\u304f\u3060\u3055\u3044\u3002',
      welcome: '\u3053\u3093\u306b\u3061\u306f\uff01\u4f55\u304a\u624b\u4f1d\u3044\u3057\u307e\u3057\u3087\u3046\u304b\uff1f',
      welcomeProduct: '\u3053\u3093\u306b\u3061\u306f\uff01<strong>{product}</strong>\u306e\u30da\u30fc\u30b8\u3092\u3054\u89a7\u3044\u305f\u3060\u3044\u3066\u3044\u307e\u3059\u3002\u3053\u306e\u88fd\u54c1\u3084\u305d\u306e\u4ed6\u306e\u3054\u8cea\u554f\u306f\u3042\u308a\u307e\u3059\u304b\uff1f',
      chips: ['\u3053\u306e\u88fd\u54c1\u306b\u3064\u3044\u3066', '\u9078\u3073\u65b9\u3092\u6559\u3048\u3066', '\u8a2d\u5b9a\u65b9\u6cd5\u306f\uff1f', '\u898b\u7a4d\u3092\u4f9d\u983c'],
      chipsNoProduct: ['\u30ab\u30b9\u30bf\u30de\u30fc\u30b5\u30fc\u30d3\u30b9', '\u30ed\u30b0\u30a4\u30f3\u30ea\u30bb\u30c3\u30c8', '\u6ce8\u6587\u306e\u78ba\u8a8d', '\u30c6\u30af\u30cb\u30ab\u30eb\u30b5\u30dd\u30fc\u30c8', '\u898b\u7a4d\u3092\u4f9d\u983c', '\u88fd\u54c1\u9078\u3073\u306e\u304a\u624b\u4f1d\u3044'],
      chipPrompts: ['{product}\u306b\u3064\u3044\u3066\u6559\u3048\u3066', '\u9069\u5207\u306a\u30e2\u30b8\u30e5\u30ec\u30fc\u30bf\u30fc\u3092\u9078\u3076\u306e\u3092\u624b\u4f1d\u3063\u3066', '{product}\u306e\u8a2d\u5b9a\u65b9\u6cd5\u306f\uff1f', '\u5927\u91cf\u6ce8\u6587\u306e\u898b\u7a4d\u308a\u304c\u6b32\u3057\u3044'],
      chipPromptsNoProduct: ['\u30ab\u30b9\u30bf\u30de\u30fc\u30b5\u30fc\u30d3\u30b9\u3092\u304a\u9858\u3044\u3057\u307e\u3059', '\u30b9\u30c8\u30a2\u306e\u30ed\u30b0\u30a4\u30f3\u30d1\u30b9\u30ef\u30fc\u30c9\u3092\u5fd8\u308c\u305f\u306e\u3067\u30ea\u30bb\u30c3\u30c8\u3092\u624b\u4f1d\u3063\u3066\u304f\u3060\u3055\u3044', '\u6ce8\u6587\u306e\u72b6\u6cc1\u3092\u78ba\u8a8d\u3057\u305f\u3044', 'PVI\u88fd\u54c1\u306e\u30c6\u30af\u30cb\u30ab\u30eb\u30b5\u30dd\u30fc\u30c8\u304c\u5fc5\u8981', '\u5927\u91cf\u6ce8\u6587\u306e\u898b\u7a4d\u308a\u304c\u6b32\u3057\u3044', '\u9069\u5207\u306a\u88fd\u54c1\u3092\u9078\u3076\u306e\u3092\u624b\u4f1d\u3063\u3066'],
      placeholder: '\u8cea\u554f\u3092\u5165\u529b...',
      listening: '\u8074\u3044\u3066\u3044\u307e\u3059...\u81ea\u7136\u306b\u8a71\u3057\u3066\u304f\u3060\u3055\u3044',
      voiceMode: 'AI\u97f3\u58f0\u30e2\u30fc\u30c9',
      textMode: '\u30c6\u30ad\u30b9\u30c8\u30c1\u30e3\u30c3\u30c8\u30e2\u30fc\u30c9',
      talkHuman: '\u5c02\u9580\u5bb6\u3068\u8a71\u3059',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    },
    zh: {
      name: '\u4e2d\u6587',
      voiceHint: '\u70b9\u51fb<strong>\u8bed\u97f3</strong>\u5207\u6362\u5230\u8bed\u97f3\u6a21\u5f0f\u3002',
      welcome: '\u4f60\u597d\uff01\u4eca\u5929\u6709\u4ec0\u4e48\u53ef\u4ee5\u5e2e\u4f60\u7684\uff1f',
      welcomeProduct: '\u4f60\u597d\uff01\u4f60\u6b63\u5728\u6d4f\u89c8<strong>{product}</strong>\u9875\u9762\u3002\u4f60\u60f3\u4e86\u89e3\u8fd9\u4e2a\u4ea7\u54c1\u6216\u5176\u4ed6\u4ec0\u4e48\u5417\uff1f',
      chips: ['\u4ecb\u7ecd\u8fd9\u4e2a\u4ea7\u54c1', '\u5e2e\u6211\u9009\u62e9', '\u5982\u4f55\u8bbe\u7f6e\uff1f', '\u83b7\u53d6\u62a5\u4ef7'],
      chipsNoProduct: ['\u5ba2\u6237\u670d\u52a1', '\u91cd\u7f6e\u767b\u5f55', '\u67e5\u8be2\u8ba2\u5355', '\u6280\u672f\u652f\u6301', '\u83b7\u53d6\u62a5\u4ef7', '\u5e2e\u6211\u9009\u62e9\u4ea7\u54c1'],
      chipPrompts: ['\u544a\u8bc9\u6211\u5173\u4e8e{product}\u7684\u4fe1\u606f', '\u5e2e\u6211\u9009\u62e9\u5408\u9002\u7684\u8c03\u5236\u5668', '\u5982\u4f55\u8bbe\u7f6e{product}\uff1f', '\u6211\u9700\u8981\u5927\u8ba2\u5355\u62a5\u4ef7'],
      chipPromptsNoProduct: ['\u6211\u9700\u8981\u5ba2\u6237\u670d\u52a1', '\u6211\u5fd8\u8bb0\u4e86\u5546\u5e97\u767b\u5f55\u5bc6\u7801\uff0c\u8bf7\u5e2e\u6211\u91cd\u7f6e', '\u6211\u60f3\u67e5\u8be2\u8ba2\u5355\u72b6\u6001', '\u6211\u7684PVI\u4ea7\u54c1\u9700\u8981\u6280\u672f\u652f\u6301', '\u6211\u9700\u8981\u5927\u8ba2\u5355\u62a5\u4ef7', '\u5e2e\u6211\u9009\u62e9\u5408\u9002\u7684\u4ea7\u54c1'],
      placeholder: '\u8f93\u5165\u95ee\u9898...',
      listening: '\u6b63\u5728\u542c... \u8bf7\u81ea\u7136\u8bf4\u8bdd',
      voiceMode: 'AI\u8bed\u97f3\u6a21\u5f0f',
      textMode: '\u6587\u5b57\u804a\u5929\u6a21\u5f0f',
      talkHuman: '\u4e0e\u4e13\u5bb6\u4ea4\u8c08',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    },
    ko: {
      name: '\ud55c\uad6d\uc5b4',
      voiceHint: '<strong>\uc74c\uc131</strong>\uc744 \ud074\ub9ad\ud574 \uc74c\uc131 \ubaa8\ub4dc\ub85c \uc804\ud658\ud558\uc138\uc694.',
      welcome: '\uc548\ub155\ud558\uc138\uc694! \ubb34\uc5c7\uc744 \ub3c4\uc640\ub4dc\ub9b4\uae4c\uc694?',
      welcomeProduct: '\uc548\ub155\ud558\uc138\uc694! <strong>{product}</strong> \ud398\uc774\uc9c0\uc5d0 \uacc4\uc2dc\ub124\uc694. \uc774 \uc81c\ud488\uc774\ub098 \ub2e4\ub978 \uac83\uc5d0 \ub300\ud574 \uad81\uae08\ud55c \uc810\uc774 \uc788\uc73c\uc138\uc694?',
      chips: ['\uc774 \uc81c\ud488\uc5d0 \ub300\ud574', '\uc120\ud0dd \ub3c4\uc6c0', '\uc124\uc815 \ubc29\ubc95\uc740?', '\uacac\uc801 \uc694\uccad'],
      chipsNoProduct: ['\uace0\uac1d \uc11c\ube44\uc2a4', '\ub85c\uadf8\uc778 \uc7ac\uc124\uc815', '\uc8fc\ubb38 \uc870\ud68c', '\uae30\uc220 \uc9c0\uc6d0', '\uacac\uc801 \uc694\uccad', '\uc81c\ud488 \uc120\ud0dd \ub3c4\uc6c0'],
      chipPrompts: ['{product}\uc5d0 \ub300\ud574 \uc54c\ub824\uc8fc\uc138\uc694', '\uc801\ud569\ud55c \ubcc0\uc870\uae30 \uc120\ud0dd\uc744 \ub3c4\uc640\uc8fc\uc138\uc694', '{product} \uc124\uc815 \ubc29\ubc95\uc740?', '\ub300\ub7c9 \uc8fc\ubb38 \uacac\uc801\uc774 \ud544\uc694\ud569\ub2c8\ub2e4'],
      chipPromptsNoProduct: ['\uace0\uac1d \uc11c\ube44\uc2a4\uac00 \ud544\uc694\ud569\ub2c8\ub2e4', '\uc2a4\ud1a0\uc5b4 \ub85c\uadf8\uc778 \ube44\ubc00\ubc88\ud638\ub97c \uc78a\uc5b4\ubc84\ub838\uc5b4\uc694. \uc7ac\uc124\uc815\uc744 \ub3c4\uc640\uc8fc\uc138\uc694', '\uc8fc\ubb38 \uc0c1\ud0dc\ub97c \ud655\uc778\ud558\uace0 \uc2f6\uc2b5\ub2c8\ub2e4', 'PVI \uc81c\ud488 \uae30\uc220 \uc9c0\uc6d0\uc774 \ud544\uc694\ud569\ub2c8\ub2e4', '\ub300\ub7c9 \uc8fc\ubb38 \uacac\uc801\uc774 \ud544\uc694\ud569\ub2c8\ub2e4', '\uc801\ud569\ud55c \uc81c\ud488 \uc120\ud0dd\uc744 \ub3c4\uc640\uc8fc\uc138\uc694'],
      placeholder: '\uc9c8\ubb38\uc744 \uc785\ub825\ud558\uc138\uc694...',
      listening: '\ub4e3\ub294 \uc911... \uc790\uc5f0\uc2a4\ub7fd\uac8c \ub9d0\uc500\ud558\uc138\uc694',
      voiceMode: 'AI \uc74c\uc131 \ubaa8\ub4dc',
      textMode: '\ud14d\uc2a4\ud2b8 \ucc44\ud305 \ubaa8\ub4dc',
      talkHuman: '\uc804\ubb38\uac00\uc640 \ub300\ud654',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    },
    ru: {
      name: '\u0420\u0443\u0441\u0441\u043a\u0438\u0439',
      voiceHint: '\u041d\u0430\u0436\u043c\u0438\u0442\u0435 <strong>\u0413\u043e\u043b\u043e\u0441</strong>, \u0447\u0442\u043e\u0431\u044b \u043f\u0435\u0440\u0435\u043a\u043b\u044e\u0447\u0438\u0442\u044c\u0441\u044f \u0432 \u0433\u043e\u043b\u043e\u0441\u043e\u0432\u043e\u0439 \u0440\u0435\u0436\u0438\u043c.',
      welcome: '\u041f\u0440\u0438\u0432\u0435\u0442! \u0427\u0435\u043c \u044f \u043c\u043e\u0433\u0443 \u043f\u043e\u043c\u043e\u0447\u044c?',
      welcomeProduct: '\u041f\u0440\u0438\u0432\u0435\u0442! \u0412\u044b \u043d\u0430 \u0441\u0442\u0440\u0430\u043d\u0438\u0446\u0435 <strong>{product}</strong>. \u0425\u043e\u0442\u0438\u0442\u0435 \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044e \u043e \u044d\u0442\u043e\u043c \u043f\u0440\u043e\u0434\u0443\u043a\u0442\u0435 \u0438\u043b\u0438 \u043e \u0447\u0451\u043c-\u0442\u043e \u0435\u0449\u0451?',
      chips: ['\u0420\u0430\u0441\u0441\u043a\u0430\u0436\u0438 \u043e \u043f\u0440\u043e\u0434\u0443\u043a\u0442\u0435', '\u041f\u043e\u043c\u043e\u0433\u0438 \u0432\u044b\u0431\u0440\u0430\u0442\u044c', '\u041a\u0430\u043a \u043d\u0430\u0441\u0442\u0440\u043e\u0438\u0442\u044c?', '\u0417\u0430\u043f\u0440\u043e\u0441\u0438\u0442\u044c \u0446\u0435\u043d\u0443'],
      chipsNoProduct: ['\u041a\u043b\u0438\u0435\u043d\u0442\u0441\u043a\u0438\u0439 \u0441\u0435\u0440\u0432\u0438\u0441', '\u0421\u0431\u0440\u043e\u0441 \u043f\u0430\u0440\u043e\u043b\u044f', '\u041f\u0440\u043e\u0432\u0435\u0440\u0438\u0442\u044c \u0437\u0430\u043a\u0430\u0437', '\u0422\u0435\u0445\u043f\u043e\u0434\u0434\u0435\u0440\u0436\u043a\u0430', '\u0417\u0430\u043f\u0440\u043e\u0441\u0438\u0442\u044c \u0446\u0435\u043d\u0443', '\u041f\u043e\u043c\u043e\u0433\u0438 \u0432\u044b\u0431\u0440\u0430\u0442\u044c \u043f\u0440\u043e\u0434\u0443\u043a\u0442'],
      chipPrompts: ['\u0420\u0430\u0441\u0441\u043a\u0430\u0436\u0438 \u043e {product}', '\u041f\u043e\u043c\u043e\u0433\u0438 \u0432\u044b\u0431\u0440\u0430\u0442\u044c \u043f\u043e\u0434\u0445\u043e\u0434\u044f\u0449\u0438\u0439 \u043c\u043e\u0434\u0443\u043b\u044f\u0442\u043e\u0440', '\u041a\u0430\u043a \u043d\u0430\u0441\u0442\u0440\u043e\u0438\u0442\u044c {product}?', '\u041d\u0443\u0436\u0435\u043d \u0440\u0430\u0441\u0447\u0435\u0442 \u0434\u043b\u044f \u043e\u043f\u0442\u043e\u0432\u043e\u0433\u043e \u0437\u0430\u043a\u0430\u0437\u0430'],
      chipPromptsNoProduct: ['\u041c\u043d\u0435 \u043d\u0443\u0436\u0435\u043d \u043a\u043b\u0438\u0435\u043d\u0442\u0441\u043a\u0438\u0439 \u0441\u0435\u0440\u0432\u0438\u0441', '\u042f \u0437\u0430\u0431\u044b\u043b \u043f\u0430\u0440\u043e\u043b\u044c \u043e\u0442 \u043c\u0430\u0433\u0430\u0437\u0438\u043d\u0430, \u043f\u043e\u043c\u043e\u0433\u0438\u0442\u0435 \u0435\u0433\u043e \u0441\u0431\u0440\u043e\u0441\u0438\u0442\u044c', '\u0425\u043e\u0447\u0443 \u043f\u0440\u043e\u0432\u0435\u0440\u0438\u0442\u044c \u0441\u0442\u0430\u0442\u0443\u0441 \u043c\u043e\u0435\u0433\u043e \u0437\u0430\u043a\u0430\u0437\u0430', '\u041d\u0443\u0436\u043d\u0430 \u0442\u0435\u0445\u043f\u043e\u0434\u0434\u0435\u0440\u0436\u043a\u0430 \u043f\u043e PVI', '\u041d\u0443\u0436\u0435\u043d \u0440\u0430\u0441\u0447\u0435\u0442 \u0434\u043b\u044f \u043e\u043f\u0442\u043e\u0432\u043e\u0433\u043e \u0437\u0430\u043a\u0430\u0437\u0430', '\u041f\u043e\u043c\u043e\u0433\u0438 \u0432\u044b\u0431\u0440\u0430\u0442\u044c \u043f\u043e\u0434\u0445\u043e\u0434\u044f\u0449\u0438\u0439 \u043f\u0440\u043e\u0434\u0443\u043a\u0442'],
      placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u043e\u043f\u0440\u043e\u0441...',
      listening: '\u0421\u043b\u0443\u0448\u0430\u044e... \u0413\u043e\u0432\u043e\u0440\u0438\u0442\u0435 \u0435\u0441\u0442\u0435\u0441\u0442\u0432\u0435\u043d\u043d\u043e',
      voiceMode: '\u0413\u043e\u043b\u043e\u0441\u043e\u0432\u043e\u0439 \u0440\u0435\u0436\u0438\u043c \u0418\u0418',
      textMode: '\u0422\u0435\u043a\u0441\u0442\u043e\u0432\u044b\u0439 \u0447\u0430\u0442',
      talkHuman: '\u0421\u0432\u044f\u0437\u0430\u0442\u044c\u0441\u044f \u0441\u043e \u0441\u043f\u0435\u0446\u0438\u0430\u043b\u0438\u0441\u0442\u043e\u043c',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    },
    ar: {
      name: '\u0627\u0644\u0639\u0631\u0628\u064a\u0629',
      voiceHint: '\u0627\u0646\u0642\u0631 \u0639\u0644\u0649 <strong>\u0635\u0648\u062a</strong> \u0644\u0644\u062a\u0628\u062f\u064a\u0644 \u0625\u0644\u0649 \u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062a.',
      welcome: '\u0645\u0631\u062d\u0628\u0627\u064b! \u0643\u064a\u0641 \u064a\u0645\u0643\u0646\u0646\u064a \u0645\u0633\u0627\u0639\u062f\u062a\u0643 \u0627\u0644\u064a\u0648\u0645\u061f',
      welcomeProduct: '\u0645\u0631\u062d\u0628\u0627\u064b! \u0623\u0646\u062a \u0639\u0644\u0649 \u0635\u0641\u062d\u0629 <strong>{product}</strong>. \u0647\u0644 \u062a\u0631\u063a\u0628 \u0641\u064a \u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0646\u062a\u062c \u0623\u0648 \u0623\u064a \u0634\u064a\u0621 \u0622\u062e\u0631\u061f',
      chips: ['\u0623\u062e\u0628\u0631\u0646\u064a \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0646\u062a\u062c', '\u0633\u0627\u0639\u062f\u0646\u064a \u0641\u064a \u0627\u0644\u0627\u062e\u062a\u064a\u0627\u0631', '\u0643\u064a\u0641 \u0623\u0642\u0648\u0645 \u0628\u0625\u0639\u062f\u0627\u062f\u0647\u061f', '\u0627\u0637\u0644\u0628 \u0639\u0631\u0636 \u0633\u0639\u0631'],
      chipsNoProduct: ['\u062e\u062f\u0645\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621', '\u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u064a\u0646 \u0627\u0644\u062f\u062e\u0648\u0644', '\u062a\u062a\u0628\u0651\u0639 \u0637\u0644\u0628', '\u0627\u0644\u062f\u0639\u0645 \u0627\u0644\u0641\u0646\u064a', '\u0627\u0637\u0644\u0628 \u0639\u0631\u0636 \u0633\u0639\u0631', '\u0633\u0627\u0639\u062f\u0646\u064a \u0641\u064a \u0627\u062e\u062a\u064a\u0627\u0631 \u0645\u0646\u062a\u062c'],
      chipPrompts: ['\u0623\u062e\u0628\u0631\u0646\u064a \u0639\u0646 {product}', '\u0633\u0627\u0639\u062f\u0646\u064a \u0641\u064a \u0627\u062e\u062a\u064a\u0627\u0631 \u0627\u0644\u0645\u0639\u062f\u0651\u0644 \u0627\u0644\u0645\u0646\u0627\u0633\u0628', '\u0643\u064a\u0641 \u0623\u0639\u062f\u0651 {product}\u061f', '\u0623\u062d\u062a\u0627\u062c \u0639\u0631\u0636 \u0633\u0639\u0631 \u0644\u0637\u0644\u0628\u064a\u0651\u0629 \u0643\u0628\u064a\u0631\u0629'],
      chipPromptsNoProduct: ['\u0623\u062d\u062a\u0627\u062c \u0625\u0644\u0649 \u062e\u062f\u0645\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621', '\u0646\u0633\u064a\u062a \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u062d\u0633\u0627\u0628\u064a \u0641\u064a \u0627\u0644\u0645\u062a\u062c\u0631\u060c \u0633\u0627\u0639\u062f\u0646\u064a \u0641\u064a \u0625\u0639\u0627\u062f\u0629 \u062a\u0639\u064a\u064a\u0646\u0647\u0627', '\u0623\u0631\u064a\u062f \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u062d\u0627\u0644\u0629 \u0637\u0644\u0628\u064a', '\u0623\u062d\u062a\u0627\u062c \u062f\u0639\u0645\u064b\u0627 \u0641\u0646\u064a\u064b\u0627 \u0644\u0645\u0646\u062a\u062c PVI', '\u0623\u062d\u062a\u0627\u062c \u0639\u0631\u0636 \u0633\u0639\u0631 \u0644\u0637\u0644\u0628\u064a\u0651\u0629 \u0643\u0628\u064a\u0631\u0629', '\u0633\u0627\u0639\u062f\u0646\u064a \u0641\u064a \u0627\u062e\u062a\u064a\u0627\u0631 \u0627\u0644\u0645\u0646\u062a\u062c \u0627\u0644\u0645\u0646\u0627\u0633\u0628'],
      placeholder: '\u0627\u0643\u062a\u0628 \u0633\u0624\u0627\u0644\u0643...',
      listening: '\u0623\u0633\u062a\u0645\u0639... \u062a\u062d\u062f\u0651\u062b \u0628\u0637\u0628\u064a\u0639\u064a\u0651\u0629',
      voiceMode: '\u0648\u0636\u0639 \u0627\u0644\u0635\u0648\u062a \u0644\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a',
      textMode: '\u0648\u0636\u0639 \u0627\u0644\u062f\u0631\u062f\u0634\u0629 \u0627\u0644\u0646\u0635\u064a\u0629',
      talkHuman: '\u062a\u062d\u062f\u0651\u062b \u0625\u0644\u0649 \u0623\u062e\u0635\u0627\u0626\u064a',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    },
    nl: {
      name: 'Nederlands',
      voiceHint: 'Klik op <strong>Stem</strong> om naar de stemmodus te schakelen.',
      welcome: 'Hallo! Hoe kan ik je vandaag helpen?',
      welcomeProduct: 'Hallo! Je bent op de <strong>{product}</strong>-pagina. Wil je informatie over dit product, of iets anders?',
      chips: ['Vertel me over dit product', 'Help me kiezen', 'Hoe stel ik het in?', 'Offerte aanvragen'],
      chipsNoProduct: ['Klantenservice', 'Login Resetten', 'Bestelling Controleren', 'Technische Ondersteuning', 'Offerte Aanvragen', 'Help Me een Product Kiezen'],
      chipPrompts: ['Vertel me over de {product}', 'Help me de juiste modulator te kiezen', 'Hoe stel ik de {product} in?', 'Ik heb een offerte nodig voor een grote bestelling'],
      chipPromptsNoProduct: ['Ik heb klantenservice nodig', 'Ik ben mijn winkelwachtwoord vergeten, kun je helpen het te resetten?', 'Ik wil de status van mijn bestelling controleren', 'Ik heb technische ondersteuning nodig voor mijn PVI-product', 'Ik heb een offerte nodig voor een grote bestelling', 'Help me het juiste product te kiezen'],
      placeholder: 'Typ je vraag...',
      listening: 'Luistert... Spreek natuurlijk',
      voiceMode: 'AI Spraakmodus',
      textMode: 'Tekstchatmodus',
      talkHuman: 'Spreek met een specialist',
      langSwitch: 'in Espa\u00f1ol',
      langSwitchTo: 'es'
    }
  };

  function detectLanguage() {
    var cfg = window.__pviChatbot || {};
    if (cfg.forcedLanguage && I18N[cfg.forcedLanguage]) return cfg.forcedLanguage;
    try {
      var stored = localStorage.getItem('pvi-lang');
      if (stored && I18N[stored]) return stored;
    } catch(_) {}
    var host = (location.hostname || '').toLowerCase();
    var prefix = host.split('.')[0];
    if (I18N[prefix]) return prefix;
    var nav = (navigator.language || 'en').toLowerCase().split('-')[0];
    if (I18N[nav]) return nav;
    return 'en';
  }

  var currentLang = detectLanguage();
  function t() { return I18N[currentLang] || I18N.en; }

  // ── Lightbox ─────────────────────────────────────────
  var overlay = null;
  function openLB(src, alt) {
    overlay = document.createElement('div');
    overlay.className = 'pvi-lb-overlay';
    var img = document.createElement('img');
    img.src = src; img.alt = alt || '';
    overlay.appendChild(img);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function() { overlay.classList.add('active'); });
    overlay.addEventListener('click', closeLB);
  }
  function closeLB() {
    if (!overlay) return;
    overlay.classList.remove('active');
    setTimeout(function() {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      overlay = null; document.body.style.overflow = '';
    }, 300);
  }
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('pvi-zoomable')) { e.preventDefault(); openLB(e.target.src, e.target.alt); }
  });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeLB(); });

  // ── Sticky Bar ───────────────────────────────────────
  var stickyBar = document.getElementById('pviStickyBar');
  var mainSubmit = document.querySelector('.product-form__submit');
  if (stickyBar && mainSubmit) {
    var io = new IntersectionObserver(function(entries) {
      stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(mainSubmit);
  }

  // ── Scroll Reveal (Apple-style fade-in) ────────────────
  (function initScrollReveal() {
    var revealEls = document.querySelectorAll('.pvi-section-label, .pvi-section-title, .pvi-section-subtitle, .pvi-section-body-text, .pvi-split-media, .pvi-full-section-image, .pvi-feat-card, .pvi-stat-card, .pvi-app-card, .pvi-accessory-card, .pvi-comparison-grid, .pvi-video-container');
    revealEls = Array.prototype.filter.call(revealEls, function(el) {
      if (el.classList.contains('pvi-cinematic-zoom')) return false;
      if (el.closest('[data-pvi-cinematic="1"]')) return false;
      return true;
    });
    if (!revealEls.length) return;
    revealEls.forEach(function(el) { el.classList.add('pvi-reveal'); });
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pvi-visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function(el) { revealObs.observe(el); });
  })();

  // ── DOM Elements ─────────────────────────────────────
  var chatToggle = document.getElementById('pviChatToggle');
  var chatPanel = document.getElementById('pviChatPanel');
  var chatClose = document.getElementById('pviChatClose');
  var chatBody = document.getElementById('pviChatBody');
  var chatMessages = document.getElementById('pviChatMessages');
  var chatTextarea = document.getElementById('pviChatTextarea');
  var chatSend = document.getElementById('pviChatSend');
  var micBtn = document.getElementById('pviMicBtn');
  var suggestions = document.getElementById('pviSuggestions');
  var modeToggle = document.getElementById('pviModeToggle');
  var modeToggleLabel = document.getElementById('pviModeToggleLabel');
  var voiceSelect = document.getElementById('pviVoiceSelect');
  var speedSelect = document.getElementById('pviSpeedSelect');
  var langSelect = document.getElementById('pviLangSelect');
  var welcomeBubble = document.getElementById('pviWelcomeBubble');
  var hintBubble = document.getElementById('pviHintBubble');
  var pviCfg = window.__pviChatbot || {};
  var selectedVoice = (voiceSelect && voiceSelect.value) || pviCfg.defaultVoice || 'alloy';
  var selectedSpeed = (speedSelect && parseFloat(speedSelect.value)) || pviCfg.defaultSpeed || 1.0;
  if (langSelect) langSelect.value = currentLang;

  // Human-readable label for the CURRENT page — product, collection, or page.
  // Used so a returning customer is greeted with "I see you're now checking
  // <page>" on ANY page type, never the first-visit hello again.
  // SEO "G" page variants (G1/G2/G3...) are the SAME product listed on multiple
  // pages for SEO — strip the suffix so the customer never sees "Minimod 2 G3"
  // and asks what the difference is vs the "regular" one.
  function pviStripSeoG(tl) {
    var c = String(tl || '').replace(/[\s\-–—(]*\bG\d+\)?\s*$/i, '').replace(/\s+$/, '');
    return c || tl;
  }

  function pviCurrentPageLabel() {
    if (product.title) return pviStripSeoG(product.title);
    if (pageCtx.page_type === 'collection') return (pageCtx.page_title || pviCollectionName(pageCtx.collection_handle)) + ' collection';
    if (pageCtx.page_type === 'page' && pageCtx.page_title) return pageCtx.page_title + ' page';
    if (pageCtx.page_type === 'index') return 'Homepage';
    return '';
  }

  // Default persona from the page context (only when nothing was restored):
  // support page → John, EVERYTHING else → Lisa. NO Dana on the web chat
  // (user decree Jul 30 2026 evening) — Dana is phone-only; Lisa answers
  // neutral pages directly and transfers to John/Mary when needed.
  if (!pviActivePersona) {
    var _pviSup = (pageCtx.page_handle || '').indexOf('tech-support') !== -1 || /tech-support/i.test(location.pathname);
    pviActivePersona = _pviSup ? 'support' : 'sales';
  }

  function renderWelcomeAndChips() {
    var s = t();
    if (hintBubble) hintBubble.innerHTML = s.voiceHint;
    if (welcomeBubble) {
      var pageLabel = pviCurrentPageLabel();
      if (hasInteracted) {
        // Returning session: NEVER repeat the first-visit hello. Acknowledge
        // the new page (product, collection, or any page) and ask what they need.
        if (pageLabel) {
          welcomeBubble.innerHTML = s.welcomeReturn
            ? s.welcomeReturn.replace('{product}', pageLabel)
            : ('I see you\'re now checking <strong>' + pageLabel + '</strong>. Any specific question I can help you with?');
        } else {
          // Rare page types (blog/cart/search) — no label, just keep helping
          welcomeBubble.innerHTML = s.welcomeBack || 'What else can I help you with?';
        }
      } else if (product.title) {
        welcomeBubble.innerHTML = s.welcomeProduct.replace('{product}', pviStripSeoG(product.title));
      } else {
        welcomeBubble.innerHTML = s.welcome;
      }
    }
    var sugg = document.getElementById('pviSuggestions');
    if (sugg) {
      sugg.innerHTML = '';
      var labels = product.title ? s.chips : s.chipsNoProduct;
      var prompts = product.title ? s.chipPrompts : s.chipPromptsNoProduct;
      // Department each no-product chip PROMISES, index-aligned across ALL
      // languages: Customer Service / Login Reset / Check an Order → Mary,
      // Technical Support → John, Get a Quote / Help Me Choose → Lisa.
      // Sent as a one-shot persona_hint so routing never depends on the
      // worker regex-guessing localized chip text (Aug 5 incident: the Login
      // Reset chip landed on John, who submitted it as a quote request).
      var chipPersonas = product.title ? [] : ['service', 'service', 'service', 'support', 'sales', 'sales'];
      for (var i = 0; i < labels.length; i++) {
        var btn = document.createElement('button');
        btn.className = 'pvi-chat-chip';
        btn.setAttribute('data-prompt', (prompts[i] || labels[i]).replace('{product}', product.title || ''));
        if (chipPersonas[i]) btn.setAttribute('data-persona', chipPersonas[i]);
        btn.textContent = labels[i];
        sugg.appendChild(btn);
      }
      // "Talk to a specialist" phone chip REMOVED (user request Aug 5 2026):
      // the shortcut list now covers all departments; pviCheckHours() safely
      // no-ops when the #pviTalkHuman element is absent.

      // Large language-switch pill at the bottom (toggles current ↔ Spanish, or back to English when in Spanish)
      if (s.langSwitchTo && s.langSwitchTo !== currentLang) {
        var langPill = document.createElement('button');
        langPill.className = 'pvi-chat-chip pvi-chat-chip-lang';
        langPill.setAttribute('data-lang', s.langSwitchTo);
        langPill.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg> ' + s.langSwitch;
        sugg.appendChild(langPill);
      }
    }
    if (chatTextarea) chatTextarea.placeholder = currentMode === 'voice' ? t().listening : t().placeholder;
    var label = document.getElementById('pviModeToggleLabel');
    if (label) label.textContent = currentMode === 'voice' ? t().textMode : t().voiceMode;
    document.documentElement.setAttribute('data-pvi-lang', currentLang);
  }
  renderWelcomeAndChips();

  // Show tech support page link when landing on a support page (especially after
  // auto-navigate). Deferred via setTimeout so voiceSupportPages (declared later
  // in this file) is initialized, and deduped so the same link never repeats.
  if (hasInteracted && chosenPersona === 'support' && /tech-support/i.test(location.pathname)) {
    setTimeout(function() {
      var supportPageMatch = null;
      var pathLower = location.pathname.toLowerCase();
      for (var spl = 0; spl < voiceSupportPages.length; spl++) {
        if (pathLower.indexOf(voiceSupportPages[spl].url.replace('/pages/', '').toLowerCase()) !== -1) {
          supportPageMatch = voiceSupportPages[spl];
          break;
        }
      }
      if (supportPageMatch && !pviLinkShown(supportPageMatch.url)) {
        pviMarkLinkShown(supportPageMatch.url);
        appendMessage('ai', '<div style="font-size:0.9em;margin-top:6px;padding:8px 12px;background:#f0f7ff;border-left:3px solid #0071E3;border-radius:4px">' +
          '<strong>\uD83D\uDEE0\uFE0F Tech Support Page</strong> \u2014 manuals, quick start guides & software updates:<br>' +
          '<a href="' + supportPageMatch.url + '" style="color:#0071E3;text-decoration:underline;font-weight:600">' + supportPageMatch.label + '</a></div>');
        scrollToBottom();
      }
    }, 500);
  }

  // ── Panel Toggle ─────────────────────────────────────
  if (chatToggle && chatPanel) {
    chatToggle.addEventListener('click', function() {
      chatPanel.classList.toggle('open');
      pviCheckHours();
      pviSaveSession();
      if (chatPanel.classList.contains('open') && chatTextarea) {
        setTimeout(function() { chatTextarea.focus(); }, 300);
      }
    });
  }
  if (chatClose && chatPanel) {
    chatClose.addEventListener('click', function() {
      chatPanel.classList.remove('open');
      // Close (X) = conversation ended → email the complete transcript NOW.
      // Flush before setMode('text') so the VOICE/TEXT channel label stays correct.
      if (chatHistory.length >= 2) { try { pviPushTranscript(true, true); } catch (_) {} }
      if (currentMode === 'voice') setMode('text');
      pviSaveSession();
    });
  }

  // ── Hide (keep chat + voice alive) ───────────────────
  // The "–" button simply HIDES the whole panel without closing the chat or
  // stopping the voice call. To bring it back, the customer taps the same ASK AI
  // button they already use to open it — no extra bars or controls. The voice
  // call keeps running in the background while the panel is hidden.
  var chatMinimize = document.getElementById('pviChatMinimize');
  if (chatMinimize && chatPanel) {
    chatMinimize.addEventListener('click', function(e) {
      e.stopPropagation();
      chatPanel.classList.remove('open');
      pviSaveSession();
    });
  }

  // ── Restore prior conversation + reopen the chat on the new page ────
  // The chat "follows" the customer: if it was open when they navigated, it
  // reopens here, re-renders the whole conversation, and if they were in a
  // voice call it auto-resumes voice (which speaks the new page's greeting).
  (function pviRestoreConversation() {
    if (!chatMessages) return;
    if (chatHistory && chatHistory.length) {
      chatHistory.forEach(function(m) {
        if (m && m.role === 'user') appendMessage('user', pviEscapeHtml(m.content));
        else if (m && m.content) appendMessage('ai', formatMessage(m.content));
      });
      if (suggestions) suggestions.style.display = 'none';
    }
    // NOTE: Do NOT add chatPanel.classList.add('open') here.
    // The panel stays hidden on page navigation so customers can browse while voice continues.
    // Customer taps the "Ask AI" button to re-show it. (Shopify project requirement, Jun 2026)
    //
    // VOICE RESUME is driven by the voice call state, NOT the panel state:
    // an active call must survive navigation even if the panel was hidden
    // (minimized) when the page changed.
    if (pviRestored && pviRestored.mode === 'voice') {
      pviCheckHours();
      // Resume the call on this page. Desktop browsers (esp. Windows) can briefly
      // hold the mic device through a navigation, so the first getUserMedia may
      // throw NotReadableError — retry a few times instead of dropping to text.
      // Mobile releases the device fast and succeeds on the first try (unchanged).
      setTimeout(function() { pviResumeVoiceAfterNav(0); }, 800);
    } else if (pviRestored && pviRestored.open) {
      pviCheckHours();
    }
  })();

  // Voice resume across page navigation, with retry. Keeps voice ON (matching the
  // iPhone behavior) on PC by surviving the brief post-navigation "mic busy"
  // window instead of falling straight back to text on the first failure.
  // On mobile the first attempt succeeds, so the retry branch never runs.
  function pviResumeVoiceAfterNav(attempt) {
    currentMode = 'voice';
    if (typeof updateModeToggleUI === 'function') updateModeToggleUI();
    if (micBtn) micBtn.style.display = 'flex';
    if (suggestions) suggestions.style.display = 'none';
    try { stopAudio(); } catch (_) {}
    pviSaveSession();
    if (rtPC) return; // call already up — nothing to do
    startRealtimeVoice().catch(function() {
      if (attempt < 3) {
        console.log('[PVI Voice] Resume attempt ' + (attempt + 1) + ' failed — retrying');
        setTimeout(function() { pviResumeVoiceAfterNav(attempt + 1); }, 700 + attempt * 800);
      } else {
        console.log('[PVI Voice] Resume failed after retries — falling back to text');
        setMode('text');
      }
    });
  }

  // ── Destination greeting after a deliberate mode switch (TEXT) ──────────
  // Unifies text with voice + phone: when the AI switched the customer to a
  // tech-support page, the reload used to leave the thread silent and the panel
  // hidden. Now we reopen the panel and post a product-confirming greeting so
  // the conversation continues ("Here is the <product> tech support page — how
  // can I help you with it?"). Localized; falls back to English.
  var PVI_SWITCH_GREETINGS = {
    en: { support: 'Here is the <strong>{product}</strong> tech support page \u2014 I\u2019ve got the manuals loaded. How can I help you with it?', sales: 'Here is the <strong>{product}</strong> page. What would you like to know about it?' },
    es: { support: 'Aqu\u00ed tienes la p\u00e1gina de soporte t\u00e9cnico de <strong>{product}</strong> \u2014 ya tengo los manuales cargados. \u00bfEn qu\u00e9 puedo ayudarte con este?', sales: 'Aqu\u00ed tienes la p\u00e1gina de <strong>{product}</strong>. \u00bfQu\u00e9 te gustar\u00eda saber sobre este?' },
    it: { support: 'Ecco la pagina di assistenza tecnica di <strong>{product}</strong> \u2014 ho gi\u00e0 caricato i manuali. Come posso aiutarti con questo?', sales: 'Ecco la pagina di <strong>{product}</strong>. Cosa vuoi sapere su questo prodotto?' },
    fr: { support: 'Voici la page d\u2019assistance technique du <strong>{product}</strong> \u2014 j\u2019ai les manuels charg\u00e9s. Comment puis-je vous aider avec celui-ci ?', sales: 'Voici la page du <strong>{product}</strong>. Que souhaitez-vous savoir \u00e0 son sujet ?' },
    de: { support: 'Hier ist die technische Support-Seite f\u00fcr <strong>{product}</strong> \u2014 die Handb\u00fccher sind geladen. Wie kann ich Ihnen damit helfen?', sales: 'Hier ist die Seite zu <strong>{product}</strong>. Was m\u00f6chten Sie dar\u00fcber wissen?' },
    pt: { support: 'Aqui est\u00e1 a p\u00e1gina de suporte t\u00e9cnico do <strong>{product}</strong> \u2014 j\u00e1 carreguei os manuais. Como posso ajudar com ele?', sales: 'Aqui est\u00e1 a p\u00e1gina do <strong>{product}</strong>. O que gostaria de saber sobre ele?' },
    ja: { support: '<strong>{product}</strong> \u306e\u30c6\u30af\u30cb\u30ab\u30eb\u30b5\u30dd\u30fc\u30c8\u30da\u30fc\u30b8\u3067\u3059\u3002\u30de\u30cb\u30e5\u30a2\u30eb\u3082\u8aad\u307f\u8fbc\u307f\u6e08\u307f\u3067\u3059\u3002\u3069\u306e\u3088\u3046\u306b\u304a\u624b\u4f1d\u3044\u3057\u307e\u3057\u3087\u3046\u304b\uff1f', sales: '<strong>{product}</strong> \u306e\u30da\u30fc\u30b8\u3067\u3059\u3002\u4f55\u304c\u3054\u8cea\u554f\u3067\u3057\u3087\u3046\u304b\uff1f' },
    zh: { support: '\u8fd9\u662f <strong>{product}</strong> \u7684\u6280\u672f\u652f\u6301\u9875\u9762\uff0c\u624b\u518c\u5df2\u52a0\u8f7d\u3002\u6211\u80fd\u5e2e\u4f60\u505a\u4ec0\u4e48\uff1f', sales: '\u8fd9\u662f <strong>{product}</strong> \u9875\u9762\u3002\u4f60\u60f3\u4e86\u89e3\u4ec0\u4e48\uff1f' },
    ko: { support: '<strong>{product}</strong> \uae30\uc220 \uc9c0\uc6d0 \ud398\uc774\uc9c0\uc785\ub2c8\ub2e4. \uba54\ub274\uc5bc\uc744 \ubd88\ub7ec\uc654\uc2b5\ub2c8\ub2e4. \ubb34\uc5c7\uc744 \ub3c4\uc640\ub4dc\ub9b4\uae4c\uc694?', sales: '<strong>{product}</strong> \ud398\uc774\uc9c0\uc785\ub2c8\ub2e4. \ubb34\uc5c7\uc774 \uad81\uae08\ud558\uc138\uc694?' },
    ru: { support: '\u042d\u0442\u043e \u0441\u0442\u0440\u0430\u043d\u0438\u0446\u0430 \u0442\u0435\u0445\u043f\u043e\u0434\u0434\u0435\u0440\u0436\u043a\u0438 <strong>{product}</strong> \u2014 \u0440\u0443\u043a\u043e\u0432\u043e\u0434\u0441\u0442\u0432\u0430 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043d\u044b. \u0427\u0435\u043c \u043f\u043e\u043c\u043e\u0447\u044c?', sales: '\u042d\u0442\u043e \u0441\u0442\u0440\u0430\u043d\u0438\u0446\u0430 <strong>{product}</strong>. \u0427\u0442\u043e \u0432\u044b \u0445\u043e\u0442\u0438\u0442\u0435 \u0443\u0437\u043d\u0430\u0442\u044c?' },
    ar: { support: '\u0647\u0630\u0647 \u0635\u0641\u062d\u0629 \u0627\u0644\u062f\u0639\u0645 \u0627\u0644\u0641\u0646\u064a \u0644\u0640 <strong>{product}</strong> \u2014 \u0627\u0644\u0623\u062f\u0644\u0629 \u062c\u0627\u0647\u0632\u0629. \u0643\u064a\u0641 \u064a\u0645\u0643\u0646\u0646\u064a \u0645\u0633\u0627\u0639\u062f\u062a\u0643\u061f', sales: '\u0647\u0630\u0647 \u0635\u0641\u062d\u0629 <strong>{product}</strong>. \u0645\u0627\u0630\u0627 \u062a\u0648\u062f \u0623\u0646 \u062a\u0639\u0631\u0641 \u0639\u0646\u0647\u061f' },
    nl: { support: 'Hier is de technische-supportpagina van <strong>{product}</strong> \u2014 de handleidingen staan klaar. Waarmee kan ik je helpen?', sales: 'Hier is de pagina van <strong>{product}</strong>. Wat wil je erover weten?' }
  };
  (function pviSwitchGreeting() {
    if (!pviPendingSwitch) return;
    var ps = pviPendingSwitch;
    pviPendingSwitch = null; // consume once
    pviSaveSession();
    if (!ps.ts || (Date.now() - ps.ts) > 60000) return; // stale guard
    // Only greet once we actually landed on the intended page.
    if (ps.url) {
      var slug = ps.url.replace('/pages/', '').toLowerCase();
      if (location.pathname.toLowerCase().indexOf(slug) === -1) return;
    }
    var pack = PVI_SWITCH_GREETINGS[currentLang] || PVI_SWITCH_GREETINGS.en;
    var tmpl = (ps.persona === 'support') ? pack.support : pack.sales;
    var prod = pviEscapeHtml(ps.product || 'this product');
    var msg = tmpl.replace('{product}', prod);
    // Reopen the panel — a deliberate switch is the exception to the
    // stay-hidden-on-navigation rule.
    if (chatPanel) { chatPanel.classList.add('open'); pviCheckHours(); }
    setTimeout(function() {
      appendMessage('ai', msg);
      chatHistory.push({ role: 'assistant', content: msg.replace(/<[^>]+>/g, '') });
      hasInteracted = true;
      pviSaveSession();
      scrollToBottom();
    }, 350);
  })();

  // Save right before navigation (same-tab links, nav menu, reload, tab close)
  window.addEventListener('beforeunload', function() {
    pviSaveSession();
    // The conversation is ending (tab/widget close). Flush a FINAL transcript
    // now (keepalive) so the worker emails the complete chat immediately — for
    // BOTH voice and text. Guarded to a real exchange so we never email stubs.
    if (chatHistory.length >= 2) { try { pviPushTranscript(true, true); } catch (_) {} }
  });
  window.addEventListener('pagehide', pviSaveSession);
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') pviSaveSession();
  });

  // ════════════════════════════════════════════════════════
  // AUDIO — persistent element, ordered slots, play token
  // ════════════════════════════════════════════════════════
  var persistentAudio = null;
  var audioPlaying = false;
  var playToken = 0;
  // Ordered slot system: TTS fetches happen in parallel, play in order
  var ttsSlots = [];      // index → 'pending' | Blob | 'failed' | null (consumed)
  var nextSlotIdx = 0;    // next slot to allocate
  var nextPlaySlot = 0;   // next slot to play

  function ensureAudio() {
    if (persistentAudio) return;
    persistentAudio = new Audio();
    persistentAudio.volume = 1.0;
    persistentAudio.preload = 'auto';
    // iOS unlock: play silently inside user gesture
    persistentAudio.muted = true;
    persistentAudio.src = 'data:audio/mpeg;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4LjI5LjEwMAAAAAAAAAAAAAAA//tQwAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAACAAACcQCAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgP////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjU0AAAAAAAAAAAAAAAAJAQAAAAAAAAAAnGTPq3MAAAAAAAAAAAAAAAAAAAA//sQwAADwAABpAAAACAAADSAAAAETEFNRTMuMTAwVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV';
    persistentAudio.play().then(function() {
      persistentAudio.pause();
      persistentAudio.currentTime = 0;
      persistentAudio.muted = false;
    }).catch(function() { persistentAudio.muted = false; });
  }

  function stopAudio() {
    playToken++;
    ttsSlots = [];
    nextSlotIdx = 0;
    nextPlaySlot = 0;
    audioPlaying = false;
    if (persistentAudio) {
      try { persistentAudio.pause(); persistentAudio.currentTime = 0; } catch(e) {}
    }
    if (chatTextarea && currentMode === 'voice') chatTextarea.value = '';
  }

  function drainSlots() {
    if (audioPlaying || !persistentAudio) return;
    // Walk from nextPlaySlot, skip failed, stop at pending
    while (nextPlaySlot < nextSlotIdx) {
      var s = ttsSlots[nextPlaySlot];
      if (s === 'pending') return; // wait for it
      if (s === 'failed' || s === null) { nextPlaySlot++; continue; }
      // Found a blob — play it
      ttsSlots[nextPlaySlot] = null;
      nextPlaySlot++;
      playClip(s);
      return;
    }
    // Queue empty AND not playing → restart mic if voice mode
    if (!audioPlaying && currentMode === 'voice' && !micUserStopped) {
      setTimeout(function() {
        if (!audioPlaying && currentMode === 'voice' && !micUserStopped) {
          if (chatTextarea) chatTextarea.value = '';
          startMic();
        }
      }, 250);
    }
  }

  function playClip(blob) {
    audioPlaying = true;
    var myToken = playToken;

    // Always stop mic while TTS plays — prevents speaker audio feeding back
    // into recognition and causing a barge-in loop. User can tap mic to barge in.
    if (recognition && micActive) {
      try { recognition.stop(); } catch(e) {}
    }

    var url = URL.createObjectURL(blob);
    persistentAudio.volume = 1.0;
    persistentAudio.muted = false;
    persistentAudio.src = url;

    var done = false;
    function finishClip() {
      if (done) return;
      done = true;
      URL.revokeObjectURL(url);
      if (myToken !== playToken) { audioPlaying = false; return; }
      audioPlaying = false;
      drainSlots();
    }

    // Safety: if audio doesn't fire ended/error within 30s, unstick
    var clipTimer = setTimeout(function() { finishClip(); }, 30000);
    persistentAudio.onended = function() { clearTimeout(clipTimer); finishClip(); };
    persistentAudio.onerror = function() { clearTimeout(clipTimer); finishClip(); };
    persistentAudio.play().catch(function() { clearTimeout(clipTimer); finishClip(); });
  }

  function queueTTS(text) {
    var clean = text.replace(/<[^>]+>/g, '').replace(/<!--.*?-->/g, '').trim();
    if (!clean) return;
    var slot = nextSlotIdx++;
    ttsSlots[slot] = 'pending';
    var myToken = playToken;

    fetch(API_BASE + '/api/tts', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: clean })
    }).then(function(r) {
      if (!r.ok) throw new Error('tts');
      return r.blob();
    }).then(function(blob) {
      if (myToken !== playToken) return; // stopAudio called, discard
      ttsSlots[slot] = blob;
      drainSlots();
    }).catch(function() {
      if (myToken === playToken) {
        ttsSlots[slot] = 'failed';
        drainSlots();
      }
    });
  }

  function speakText(text, onDone) {
    queueTTS(text);
    if (onDone) {
      var iv = setInterval(function() {
        if (!audioPlaying && nextPlaySlot >= nextSlotIdx) { clearInterval(iv); onDone(); }
      }, 300);
    }
  }

  // ════════════════════════════════════════════════════════
  // SPEECH RECOGNITION — continuous, never stops in voice mode
  // ════════════════════════════════════════════════════════
  var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  var recognition = null;
  var micActive = false;
  var micUserStopped = false; // user intentionally stopped mic

  function hasMic() { return !!SpeechRecognition; }

  function initRecognition() {
    if (!SpeechRecognition) return;
    recognition = new SpeechRecognition();
    // iOS Safari has known issues with continuous=true; use false + auto-restart
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    recognition.continuous = !isIOS;
    recognition.interimResults = true;
    recognition.lang = navigator.language || 'en-US';
    recognition.maxAlternatives = 1;

    recognition.onstart = function() {
      micActive = true;
      if (micBtn) micBtn.classList.add('pvi-mic-active');
      if (chatTextarea) chatTextarea.placeholder = 'Speak now...';
    };

    recognition.onresult = function(event) {
      var final = '';
      var interim = '';
      for (var i = event.resultIndex; i < event.results.length; i++) {
        if (event.results[i].isFinal) {
          final += event.results[i][0].transcript;
        } else {
          interim += event.results[i][0].transcript;
        }
      }

      if (chatTextarea) chatTextarea.value = final || interim;

      // Barge-in: stop audio as soon as 2+ words detected
      var wordCount = (interim || final).trim().split(/\s+/).length;
      if (wordCount >= 2 && audioPlaying) {
        stopAudio();
      }

      if (final) {
        var text = final.trim();
        if (text.length > 0) {
          stopAudio();
          if (chatTextarea) chatTextarea.value = '';
          setTimeout(function() { sendMessage(text); }, 100);
        }
      }
    };

    recognition.onerror = function(e) {
      if (e.error === 'no-speech' || e.error === 'aborted') return;
      console.warn('Speech error:', e.error);
    };

    recognition.onend = function() {
      micActive = false;
      if (micBtn) micBtn.classList.remove('pvi-mic-active');
      // Only auto-restart if: voice mode, user didn't stop it, AI isn't talking
      var queueDone = nextPlaySlot >= nextSlotIdx;
      if (currentMode === 'voice' && !micUserStopped && !audioPlaying && queueDone) {
        setTimeout(function() {
          if (currentMode === 'voice' && !micUserStopped && !audioPlaying) startMic();
        }, 300);
      }
    };
  }

  function requestMicEarly() { return Promise.resolve(); }

  function startMic() {
    if (!recognition) initRecognition();
    if (!recognition) return;
    if (micActive) return;
    micUserStopped = false;
    try { recognition.start(); } catch(e) {
      // Already running — that's fine
    }
  }

  function stopMic() {
    micUserStopped = true;
    if (recognition && micActive) {
      try { recognition.stop(); } catch(e) {}
    }
    micActive = false;
    if (micBtn) micBtn.classList.remove('pvi-mic-active');
  }

  function releaseMic() {
    stopMic();
  }

  // ════════════════════════════════════════════════════════
  // REALTIME VOICE (OpenAI WebRTC Realtime API)
  // ════════════════════════════════════════════════════════
  var rtPC = null;            // RTCPeerConnection
  var rtMicStream = null;     // local mic MediaStream
  var rtAudioEl = null;       // <audio> for AI voice playback
  var rtDataChannel = null;   // events channel
  var rtConnected = false;
  var rtPendingGreeting = null; // greeting function to call on session.created
  var rtAISpeaking = false;     // true while AI is GENERATING (false at response.done)
  // TRUE while audio is actually PLAYING through the speaker. response.done fires
  // when GENERATION finishes — the audio keeps playing for seconds after. Deferred
  // actions (persona restart, page navigation) must check THIS, not rtAISpeaking,
  // or they cut the AI mid-sentence (Jul 30: John truncated on the transfer to Mary).
  var rtAudioPlaying = false;
  var rtMicHoldUntilDone = false; // keep mic MUTED for a programmatic greeting/
  // confirmation the customer did NOT prompt (initial greeting, mode-switch
  // confirmation, doc-loaded greeting). Right after a (re)connect the browser's
  // echo canceller hasn't locked on yet, so a live mic hears the AI's own
  // greeting, the server VAD fires, interrupt_response truncates it, and
  // create_response starts the SAME greeting over — the "Hi… Hi…" self-interrupt.
  // For real answers (which the customer DID prompt) the mic stays live so
  // barge-in keeps working.
  var rtLastResponseDone = 0;   // timestamp of last response.done (cooldown guard)
  var rtLastLinksInjected = '';  // (legacy) last transcript we injected links for
  var rtLastLinkKey = '';        // dedup: last SET of link URLs injected (no sequential dupes)
  var rtResponseCount = 0;      // count AI responses — skip link injection on greeting (first response)
  var rtDocModelLoaded = null;   // model key for which docs are already loaded (avoid redundant fetches)
  var rtDocLoading = false;      // true while a doc fetch is in flight
  var rtStarting = false;        // true while startRealtimeVoice() is in flight (prevents double-start)
  var rtStartedAt = 0;           // timestamp when voice session started (prevents early reconnect)

  // ── ECHO-SAFE MODE (car Bluetooth / speakerphone self-barge-in guard) ──
  // On car BT and speakerphones the browser's echo canceller often FAILS
  // (high-latency audio path, car does its own bad AEC), so the AI's own voice
  // re-enters the mic, trips the server VAD, and interrupt_response truncates
  // the AI mid-sentence — over and over ("speaks, stops, restarts"). We detect
  // that loop: a REAL barge-in is followed by a real user transcript within a
  // few seconds; an ECHO barge-in produces nothing (or a 1-word Whisper
  // hallucination like "you"). Three phantom barge-ins = echo-safe mode ON for
  // the rest of the session: the mic is muted while the AI speaks (no barge-in)
  // and re-opens when the audio playback actually finishes.
  var rtEchoSafe = false;        // true → mute mic during AI speech (no barge-in)
  var rtEchoStrikes = 0;         // phantom barge-ins seen so far
  var rtLastBargeAt = 0;         // timestamp of the last barge-in while AI spoke
  var rtBargeGotTranscript = true; // did a real transcript follow the last barge-in?

  function pviEchoStrike() {
    // Called 4s after a barge-in if no real user transcript arrived — that
    // interruption was the AI's own echo, not the customer.
    if (rtBargeGotTranscript) return;
    rtEchoStrikes++;
    console.log('[PVI Voice] Phantom barge-in (no user speech followed) — strike ' + rtEchoStrikes + '/3');
    if (rtEchoStrikes >= 3 && !rtEchoSafe) {
      rtEchoSafe = true;
      console.log('[PVI Voice] ECHO-SAFE MODE ON — speaker echo is self-interrupting the AI (car BT/speakerphone). Mic now mutes while the AI speaks; it reopens after each answer.');
      // If the AI is speaking right now, mute immediately.
      if (rtAISpeaking && rtMicStream) {
        rtMicStream.getAudioTracks().forEach(function(track) { track.enabled = false; });
      }
    }
  }
  

  // Product links to auto-inject in voice mode when the AI mentions them
  // URLs are relative so they work on any domain (new., www., bare)
  var voiceAutoLinks = [
    // RF Modulators
    { keywords: ['minimod 2', 'minimod-2', 'mini mod 2', 'minimod 2 plus', 'minimod-2+', 'minimod two'],
      label: 'VeCOAX MINIMOD-2+', url: '/products/vecoax-minimod-2-plus' },
    { keywords: ['minimod 4k', 'minimod-4k', 'mini mod 4k', '4k modulator', '4k model', '4k version', '4k ultra'],
      label: 'VeCOAX MINIMOD-4K', url: '/products/vecoax-minimod-4k' },
    { keywords: ['ultra plus', 'ultra+', 'vecoax ultra', '4 channel modulator', '8 channel modulator', '4-channel modulator', '8-channel modulator'],
      label: 'VeCOAX ULTRA+', url: '/products/vecoax-ultra' },
    { keywords: ['micromod', 'micro mod', 'micromod 3', 'sdi modulator'],
      label: 'VeCOAX MICROMOD-3 SDI', url: '/products/vecoax-micromod-3-sdi' },
    { keywords: ['blade', 'miniblade', 'mini blade', 'blade kit', 'blade rack', '10 unit', 'ten unit'],
      label: 'VeCOAX MINI BLADE', url: '/products/vecoax-mini-blade' },
    { keywords: ['rack panel', 'rack mount', '19 inch', '19-inch', '1ru', '1 ru', 'rack space', 'panel alone'],
      label: '1RU Rack Panel', url: '/products/1ru-rack-panel-hdmi-modulator' },
    { keywords: ['ip mod', 'ipmod', 'ip modulator', 'ip to coax', 'ip to rf'],
      label: 'IP-MOD 4X IP to Coax RF Modulator', url: '/products/ip-mod-4x-ip-to-coax-rf-modulator' },
    { keywords: ['rack 2', 'rack-2', 'bundle with 2', 'two channel bundle', '2 channel bundle'],
      label: 'VeCOAX RACK-2', url: '/products/vecoax-rack-2' },
    { keywords: ['rack 4', 'rack-4', 'bundle with 4', 'four channel bundle', '4 channel bundle'],
      label: 'VeCOAX RACK-4', url: '/products/vecoax-rack-4' },
    { keywords: ['3 pack', '3-pack', 'three pack'],
      label: 'MINIMOD-2+ 3-Pack', url: '/products/vecoax-minimod-2-plus-3-pack' },
    { keywords: ['4 pack', '4-pack', 'four pack'],
      label: 'MINIMOD-2+ 4-Pack', url: '/products/vecoax-minimod-2-plus-4-pack' },
    // IPTV Encoders
    { keywords: ['vecaster hd h.264', 'vecaster hd h264', 'vecaster hd encoder', 'hd h264 encoder', 'hd h.264 encoder'],
      label: 'VeCASTER HD H.264', url: '/products/vecaster-hd-h264-hdmi-iptv-encoder' },
    { keywords: ['vecaster hd hevc', 'vecaster hd h.265', 'hd hevc encoder'],
      label: 'VeCASTER HD HEVC', url: '/products/vecaster-hd-hevc-hdmi-iptv-encoder' },
    { keywords: ['vecaster 4k hevc', 'vecaster 4k encoder', '4k hevc encoder', '4k iptv encoder'],
      label: 'VeCASTER 4K HEVC', url: '/products/vecaster-4k-hevc-hdmi-iptv-encoder' },
    { keywords: ['vecaster 4k pro', '4k pro encoder', '12g sdi', '4k60 encoder'],
      label: 'VeCASTER 4K-PRO', url: '/products/vecaster-4k-pro-12g-sdi-hdmi-iptv-encoder' },
    { keywords: ['vecaster sdi hevc', 'vecaster hd sdi', 'sdi hevc encoder', 'sdi encoder'],
      label: 'VeCASTER HD SDI HEVC', url: '/products/vecaster-hd-sdi-hevc-iptv-encoder' },
    { keywords: ['vecaster pro hdmi', 'ndi encoder hdmi', 'srt encoder hdmi', 'vecaster pro encoder'],
      label: 'VeCASTER PRO HDMI', url: '/products/vecaster-pro-hdmi-ndi-srt-iptv-encoder' },
    { keywords: ['vecaster pro sdi', 'ndi encoder sdi', 'srt encoder sdi'],
      label: 'VeCASTER PRO SDI', url: '/products/vecaster-pro-sdi-ndi-srt-iptv-encoder' },
    // Multichannel Encoders
    { keywords: ['vecoder hd h264', 'vecoder hd h.264', 'vecoder hd encoder', 'multichannel encoder hd'],
      label: 'VeCODER HD H.264', url: '/products/vecoder-hd-h264-multichannel-iptv-encoder' },
    { keywords: ['vecoder hd hevc', 'vecoder hd h.265', 'multichannel hevc'],
      label: 'VeCODER HD HEVC', url: '/products/vecoder-hd-hevc-multichannel-iptv-encoder' },
    { keywords: ['vecoder 4k', 'multichannel 4k encoder'],
      label: 'VeCODER 4K', url: '/products/vecoder-4k-h264-multichannel-iptv-encoder' },
    { keywords: ['vecoder sdi', 'multichannel sdi encoder'],
      label: 'VeCODER SDI', url: '/products/vecoder-sdi-multichannel-iptv-encoder' },
    // IPTV Decoders
    { keywords: ['ipdecoder', 'ip decoder', 'budget decoder', 'cheap decoder'],
      label: 'IPdecoder HD 4K', url: '/products/ipdecoder-hd-4k-ip-to-hdmi-decoder' },
    { keywords: ['veplayer 4k', 'veplayer decoder', 'iptv decoder'],
      label: 'VePLAYER 4K', url: '/products/veplayer-professional-hd-4k-iptv-decoder-hevc-h-265-h-264-api-telnet-remote-control' },
    { keywords: ['veplayer pro', 'ndi decoder', 'srt decoder'],
      label: 'VePLAYER PRO', url: '/products/veplayer-pro-ip-video-decoder-ndi' },
    { keywords: ['veplayer quad', 'quad decoder', '4 stream decoder', 'four stream decoder'],
      label: 'VePLAYER-HDMI-QUAD', url: '/products/veplayer-hdmi-quad-professional-hd-4k-iptv-decode-4-streams' },
    { keywords: ['veplayer sdi', 'broadcast decoder'],
      label: 'VePLAYER-SDI', url: '/products/veplayer-sdi-broadcast-professional-3g-hd-sdi-video-decoder' },
    { keywords: ['veplayer ultra', 'ultra 4 rack', 'rack decoder'],
      label: 'VePLAYER ULTRA-4 RACK', url: '/products/veplayer-ultra-4-rack-ip-video-decoder' },
    // INFINIUM Modular System
    { keywords: ['infinium chassis', 'infinium 4k chassis', 'infinium headend', 'modular chassis', 'infinium system', 'infinium 4k'],
      label: 'INFINIUM 4K Chassis', url: '/products/infinium-4k-hd-video-distribution-chassis' },
    { keywords: ['infinium h.264', 'infinium h264', 'infinium 1080p h.264', '1080p h.264 card', '1080 h264 card'],
      label: 'INFINIUM 1080p H.264 Card', url: '/products/infinium-encoder-card-1080p-h264-hdmi' },
    { keywords: ['infinium hevc card', 'infinium 1080p hevc', 'infinium 1080 hevc', '1080p hevc card'],
      label: 'INFINIUM 1080p HEVC Card', url: '/products/infinium-encoder-card-1080p-h265-hdmi' },
    { keywords: ['infinium 4k30', 'infinium 4k hevc', '4k30 card', '4k encoder card'],
      label: 'INFINIUM 4K30 HEVC Card', url: '/products/infinium-encoder-card-4k-hevc-hdmi' },
    { keywords: ['infinium 4k60', 'infinium broadcast', 'infinium 12g', 'infinium flagship', '4k60 card', '4k60 broadcast'],
      label: 'INFINIUM 4K60 Broadcast Card', url: '/products/infinium-encoder-card-4k-60-hevc-hdmi' },
    { keywords: ['infinium sdi', 'infinium 3g-sdi', 'infinium 3g sdi', 'sdi hevc card', '3g-sdi card'],
      label: 'INFINIUM 3G-SDI HEVC Card', url: '/products/infinium-encoder-card-3g-sdi-hevc' },
    { keywords: ['infinium coax', 'infinium rf', 'infinium modulator', '4k over coax module', '4k-over-coax', 'rf module', 'coax module', 'infinium rf module'],
      label: 'INFINIUM 4K-Over-Coax RF Module', url: '/products/infinium-4k-over-coax-out-rf-modulator-card' },
    // AV over IP (VuMATRIX). TX and RX BOTH carry the generic terms, so any
    // mention of "vumatrix" surfaces BOTH the transmitter and the receiver
    // (the system needs both). Specific terms still work too.
    { keywords: ['vumatrix', 'vu matrix', 'video matrix', 'hdmi matrix', 'av over ip', 'hdmi over ip', 'vumatrix transmitter', 'vumatrix tx', 'vumatrix fx tx'],
      label: 'VuMATRIX FX Transmitter', url: '/products/vumatrix-fx-transmitter-4k-hdmi-over-ip-extender' },
    { keywords: ['vumatrix', 'vu matrix', 'video matrix', 'hdmi matrix', 'av over ip', 'hdmi over ip', 'vumatrix receiver', 'vumatrix rx', 'vumatrix fx rx'],
      label: 'VuMATRIX FX Receiver', url: '/products/vumatrix-fx-receiver-4k-hdmi-over-ip-extender' },
    { keywords: ['2x2', '2 x 2', '2 by 2', 'two by two'],
      label: 'VuMATRIX 4K Video Wall 2\u00d72 Kit', url: '/products/vumatrix-4k-video-wall-2x2' },
    { keywords: ['3x3', '3 x 3', '3 by 3', 'three by three'],
      label: 'VuMATRIX 4K Video Wall 3\u00d73 Kit', url: '/products/vumatrix-4k-video-wall-3x3' },
    { keywords: ['4x4', '4 x 4', '4 by 4', 'four by four'],
      label: 'VuMATRIX 4K Video Wall 4\u00d74 Kit', url: '/products/vumatrix-4k-video-wall-4x4' },
    { keywords: ['video wall', 'videowall', 'video walls'],
      label: 'VuMATRIX Video Wall Kits', url: '/collections/vumatrix-4k-video-wall-kits' },
    // Modular
    { keywords: ['infinium', 'modular system', 'modular chassis', 'headend chassis'],
      label: 'INFINIUM 4K Chassis', url: '/products/infinium-4k-hd-video-distribution-chassis' },
    // Accessories
    { keywords: ['splitter', 'combiner', 'coax splitter', 'coaxial splitter', '13 port', '13-port', 'coax mixer'],
      label: 'Coax Combiner/Splitter', url: '/products/coax-combiner-splitter' }
  ];

  // Tech support page links — injected when AI discusses setup/troubleshooting
  var voiceSupportPages = [
    { keywords: ['minimod 2', 'minimod-2', 'mini mod 2', 'minimod 2 plus', 'minimod-2+', 'minimod two'],
      label: 'MINIMOD-2+ Tech Support', url: '/pages/tech-support-page-vecoax-minimod-2-plus' },
    { keywords: ['minimod 4k', 'minimod-4k', 'mini mod 4k'],
      label: 'MINIMOD-4K Tech Support', url: '/pages/tech-support-page-vecoax-minimod-4k' },
    { keywords: ['rack 2', 'rack-2', 'rack 4', 'rack-4'],
      label: 'RACK-2/4 Tech Support', url: '/pages/tech-support-for-vecoax-rack-2-rack-4-multi-channel-hdmi-rf-modulators-qam-atsc-isdbt-dvbt-dvbc-for-hdmi-over-coaxial-tv-channels-distribution-extenders' },
    { keywords: ['blade', 'miniblade', 'mini blade'],
      label: 'BLADE Tech Support', url: '/pages/tech-support-for-vecoax-blade-multi-channel-hdmi-rf-modulators-qam-atsc-isdbt-dvbt-dvbc-for-hdmi-over-coaxial-tv-channels-distribution-extenders' },
    { keywords: ['ultra plus', 'ultra+', 'vecoax ultra'],
      label: 'ULTRA+ Tech Support', url: '/pages/tech-support-for-vecoax-ultra-plus-hdmi-sdi-qam-atsc-dvbt-isdbt-dvbc-digital-television-broadcast-hdtv-rf-encoders-modulators' },
    { keywords: ['micromod 3 plus', 'micromod-3+', 'micromod 3+', 'micromod three plus'],
      label: 'MICROMOD-3+ Tech Support', url: '/pages/tech-support-page-vecoax-micromod-3-plus' },
    { keywords: ['micromod 3 sdi', 'micromod-3 sdi', 'micromod sdi', 'micromod-3+ sdi'],
      label: 'MICROMOD-3+ SDI Tech Support', url: '/pages/tech-support-page-vecoax-micromod-3-plus-sdi' },
    { keywords: ['infinium', 'modular chassis', 'headend chassis'],
      label: 'INFINIUM Tech Support', url: '/pages/tech-support-for-infinium-hd-4k-8k-encoder-modulator-iptv-streaming-video-broadcast-distribution-headend-platform-for-qam-atsc-isdbt-dvbt-dvbc-isdbt-iptv' },
    { keywords: ['vecaster', 'vecaster hd', 'vecaster 4k', 'vecaster pro', 'vecaster sdi'],
      label: 'VeCASTER Tech Support', url: '/pages/tech-support-for-vecaster-hdmi-sdi-encoder-for-iptv-live-streaming-hdmi-sdi-h264-h265-hevc-srt-ndi-rtmp-rtsp-m3u' },
    { keywords: ['vecoder 4k', 'vecoder ultra 4k'],
      label: 'VeCODER 4K Tech Support', url: '/pages/tech-support-for-vecoder-4k-hdmi-sdi-encoder-for-iptv-live-streaming-hdmi-sdi-h264-h265-hevc-srt-ndi-rtmp-rtsp-m3u' },
    { keywords: ['vecoder', 'multichannel encoder'],
      label: 'VeCODER HD Tech Support', url: '/pages/tech-support-for-vecoder-hdmi-sdi-encoder-for-iptv-live-streaming-hdmi-sdi-h264-h265-hevc-srt-ndi-rtmp-rtsp-m3u' },
    { keywords: ['veplayer', 'veplayer 4k', 'veplayer pro', 'veplayer quad', 'veplayer sdi', 'iptv decoder'],
      label: 'VePLAYER Tech Support', url: '/pages/tech-support-for-veplayer-hd-4k-iptv-ip-streaming-decoder-for-professional-live-streaming-decoding-of-any-format-including-h264-h265-hevc-ac3-rtmp-rtsp-udp-rtp-rtsp-srt-ndi-and-more' },
    { keywords: ['veplayer ultra', 'ultra 4 rack', 'veplayer rack'],
      label: 'VePLAYER ULTRA-4 Tech Support', url: '/pages/tech-support-for-veplayer-4-rack-multi-channel-hd-4k-iptv-ip-streaming-decoder' },
    { keywords: ['vumatrix', 'vu matrix', 'video matrix', 'hdmi over ip', 'av over ip'],
      label: 'VuMATRIX Tech Support', url: '/pages/tech-support-for-vumatrix-av-over-ip-4k-hdmi-video-matrix-system-with-video-wall-features' },
    // IP-MOD 4X has no dedicated support page yet — the product page (with the
    // manuals) is the worker's official support destination for it too.
    { keywords: ['ip mod', 'ipmod', 'ip modulator', 'ip to coax', 'ip to rf'],
      label: 'IP-MOD 4X Tech Support', url: '/products/ip-mod-4x-ip-to-coax-rf-modulator' }
  ];

  var SUPPORT_CONTEXT_RE = /\b(set ?up|setting up|install|configur|troubleshoot|firmware|update|upgrade|factory reset|default ip|ip address|static ip|web interface|login|log ?in|password|credential|no signal|not work|won't|doesn't|broken|channel scan|rescan|vlc|m3u8|rtmp|rtsp|hls|srt|ndi|igmp|multicast|jumbo frame|dhcp|subnet|quick start|manual|documentation|how to connect|how do i|help with my|support)\b/i;
  var rtLastSupportLinkUrl = '';
  var rtLastSalesNavUrl = '';    // last sales page-follow destination (no repeat nav)

  // ── Product suggestion "offer" cards (shop.provideoinstruments.com widget) ──
  // When we suggest a product we show an EXPLICIT offer — "Click here to see
  // this solution:" — with the product link and, when the category is clear,
  // a "See all …" collection link. BOTH open in a NEW TAB on the new www.
  // website, so the chat stays open and the customer can come back and click
  // any other link. Nothing ever navigates on its own.
  var PVI_WWW_BASE = 'https://www.provideoinstruments.com';
  var PVI_CATEGORY_LINKS = [
    { label: 'See all HDMI RF Modulators',
      url: PVI_WWW_BASE + '/collections/hdmi-rf-modulators',
      urlRe: /minimod|micromod|vecoax-rack|vecoax-ultra|mini-blade|1ru-rack-panel|coax-combiner/i,
      textRe: /modulator|over coax|coax channel|rf channel|hdmi to coax/i },
    { label: 'See all IPTV Encoders & Decoders',
      url: PVI_WWW_BASE + '/collections/video-streaming-encoders-decoders',
      urlRe: /vecaster|vecoder|veplayer|ipdecoder/i,
      textRe: /encoder|decoder|iptv|streaming/i },
    { label: 'See all AV over IP / VuMATRIX',
      url: PVI_WWW_BASE + '/collections/av-over-ip-vumatrix',
      urlRe: /vumatrix|video-wall/i,
      textRe: /\bmatrix\b|av over ip|hdmi over ip|video wall/i }
  ];

  function pviProductAbsUrl(u) {
    if (!u) return u;
    if (/^https?:\/\//i.test(u)) return u;      // already absolute — leave as-is
    if (u.charAt(0) === '/') return PVI_WWW_BASE + u;
    return u;
  }
  // Pick the "See all" collection: by the offered product's URL first (most
  // reliable), then by what the conversation text talks about.
  function pviCategoryFor(url, text) {
    var i;
    for (i = 0; i < PVI_CATEGORY_LINKS.length; i++) {
      if (PVI_CATEGORY_LINKS[i].urlRe.test(url || '')) return PVI_CATEGORY_LINKS[i];
    }
    for (i = 0; i < PVI_CATEGORY_LINKS.length; i++) {
      if (PVI_CATEGORY_LINKS[i].textRe.test(text || '')) return PVI_CATEGORY_LINKS[i];
    }
    return null;
  }
  // Render the offer card: product link + optional category "See all" link.
  // Both new-tab. Deduped (consecutive) so the same product isn't re-offered.
  // In TEXT mode the card also offers a FREE QUOTE — and that question is
  // appended to chatHistory as an assistant message, so when the customer
  // replies "yes" the worker AI sees its own question and runs the normal
  // quote flow (name, email, quantity, configuration). Voice is excluded:
  // the realtime AI never saw the injected text and would be confused; it
  // offers quotes by itself in conversation.
  var PVI_QUOTE_OFFER_TEXT = 'Good news — this product is in stock, and you can get it as soon as tomorrow if needed. Would you like a free quote for your reference?';
  // Aug 19 transcript audit — the injected offer card misfired three ways:
  // 1. During SUPPORT TRIAGE ("are you looking for technical support for a unit
  //    you already own?") the appended quote question hijacked the customer's
  //    "yes" into the quote-collection flow (Samsung-TVs MINIMOD chat).
  // 2. After "that product is discontinued / no catalog match" the card said
  //    "Good news — this product is in stock!" (VeCOAX 4K-12 chats).
  // 3. Right after a quote was already emailed, the nudge created a DUPLICATE
  //    quote when the customer answered "Yes please" (UK VeCASTER chat).
  // Suppress the whole card when the reply is support triage / a denial, and
  // suppress the quote line whenever the reply already talks about a quote.
  var PVI_OFFER_SUPPRESS_REPLY_RE = /technical support|tech support|troubleshoot|support ticket|already own|discontinu|no longer (?:available|offered|carr)|not (?:part|one) of our|no catalog match|couldn'?t find a match|not a product we/i;
  var PVI_OFFER_SUPPRESS_PROBLEM_RE = /not (?:work|display|show|stream|power|respond)|no (?:signal|video|audio|data|picture|power)|\berror\b|issue with|problem with|defective|broken|repair|\brma\b|firmware|blinking|frozen|stopped/i;
  function pviShowProductOffer(label, url, contextText) {
    if (!label || !url) return false;
    var abs = pviProductAbsUrl(url);
    if (pviLinkShown(abs)) return false;
    pviMarkLinkShown(abs);
    var isVoice = (currentMode === 'voice');
    // DEDUPE: the AI's own reply now (mandatorily) ends with the free-quote
    // offer. If it already asked, do NOT ask again in the card — two quote
    // pitches back-to-back reads as a pushy bot that isn't listening
    // (Jul 13 Palm Springs church transcript).
    // Broadened (Aug 19): ANY quote talk in the reply — an offer, a quote just
    // emailed ("Your quote L… has been emailed"), or the collection questions —
    // means a second pitch is wrong (it created a duplicate quote on Aug 18).
    var aiAlreadyOffersQuote = /\bquote\b/i.test(contextText || '');
    var linkStyle = 'color:#0071E3;text-decoration:underline;font-weight:600;display:block;padding:3px 0';
    // color is EXPLICIT: the shop widget is dark-themed (white text) and the
    // card background is light — inherited text would be invisible.
    var html =
      '<div class="pvi-offer-card" style="margin-top:6px;padding:10px 12px;background:#f0f7ff;border-left:3px solid #0071E3;border-radius:6px;font-size:0.95em;color:#1d1d1f">' +
        '<div style="margin-bottom:6px;font-weight:600">Click here to see this solution:</div>' +
        '<a href="' + abs + '" target="_blank" rel="noopener" style="' + linkStyle + '">\u2192 ' + pviEscapeHtml(label) + '</a>';
    var cat = pviCategoryFor(abs, contextText || '');
    if (cat) {
      html += '<a href="' + cat.url + '" target="_blank" rel="noopener" style="' + linkStyle + '">\u2192 ' + pviEscapeHtml(cat.label) + '</a>';
    }
    if (!isVoice && !aiAlreadyOffersQuote) {
      html += '<div style="margin-top:8px">' + pviEscapeHtml(PVI_QUOTE_OFFER_TEXT) + '</div>';
    }
    html += '</div>';
    appendMessage('ai', html);
    if (!isVoice && !aiAlreadyOffersQuote) {
      // Make the quote offer part of the AI's history, so a "yes" reply is
      // understood by the worker and starts the quote-gathering flow.
      chatHistory.push({ role: 'assistant', content: PVI_QUOTE_OFFER_TEXT });
      pviSaveSession();
    }
    scrollToBottom();
    return true;
  }
  // TEXT mode: after an AI reply, offer the most relevant product. Prefer the
  // product the AI itself linked ([label](/products/handle) — its chosen "most
  // relevant"); if it linked none, fall back to keyword-scanning the reply.
  // Never in support context (a product offer is a pre-sales action).
  // When the card is shown, the AI's generic trailing "Would you like more
  // details…?" question is removed from the bubble — the card replaces it.
  function pviTextMaybeOffer(text, bubbleEl) {
    if (!text) return;
    var actuallySupport = (chosenPersona === 'support') || (pviCfg.persona === 'support') || /tech-support/i.test(location.pathname);
    if (actuallySupport) return;
    // Support triage / discontinued-product replies never get an offer card,
    // and neither does a conversation where the customer is reporting a
    // problem with a unit they own (see notes at PVI_OFFER_SUPPRESS_REPLY_RE).
    if (PVI_OFFER_SUPPRESS_REPLY_RE.test(text)) return;
    var lastCustomerMsg = '';
    for (var h = chatHistory.length - 1; h >= 0; h--) {
      if (chatHistory[h] && chatHistory[h].role === 'user') { lastCustomerMsg = chatHistory[h].content || ''; break; }
    }
    if (PVI_OFFER_SUPPRESS_PROBLEM_RE.test(lastCustomerMsg)) return;
    // Offer the product mentioned EARLIEST in the reply — that is the AI's
    // primary recommendation. (A later product may carry the markdown link
    // while the first mention is only bolded — text position wins, not link.)
    var best = null; // { pos, label, url }
    var m = text.match(/\[([^\]]+)\]\(([^)]*\/products\/[^)\s]+)\)/);
    if (m) best = { pos: text.indexOf(m[0]), label: m[1], url: m[2] };
    // Keyword scan on 1:1-normalized text (dashes→spaces, same length), so
    // match positions are directly comparable with the markdown-link position.
    var normLower = text.toLowerCase().replace(/[\u2010-\u2015\-]/g, ' ');
    for (var i = 0; i < voiceAutoLinks.length; i++) {
      var item = voiceAutoLinks[i];
      for (var k = 0; k < item.keywords.length; k++) {
        var kw = item.keywords[k].toLowerCase().replace(/[\u2010-\u2015\-]/g, ' ');
        var pos = normLower.indexOf(kw);
        if (pos !== -1 && (!best || pos < best.pos)) {
          best = { pos: pos, label: item.label, url: item.url };
        }
      }
    }
    var shown = false;
    if (best) shown = pviShowProductOffer(best.label, best.url, text);
    if (shown && bubbleEl) {
      try {
        bubbleEl.innerHTML = bubbleEl.innerHTML.replace(
          /(?:<br\s*\/?>\s*)*Would you like (?:more )?(?:details|info|information)[^<]*\?\s*$/i, '');
      } catch (_) {}
    }
  }

  function injectVoiceLinks(transcript) {
    if (!transcript) return;
    if (rtResponseCount <= 1) return; // never inject links on the greeting
    var lower = transcript.toLowerCase();
    // Hyphen/whitespace-insensitive matching. Official product names use hyphens
    // ("VeCASTER 4K-PRO", "MINIMOD-2+", "RACK-2", "12G-SDI") and the voice AI is told
    // to say the EXACT name, so the transcript reads "4k-pro" while the keyword table
    // uses "4k pro" — a raw substring check silently misses it and the promised link
    // never appears. Normalize all dashes -> spaces (and collapse spaces) on BOTH sides.
    var normLower = lower.replace(/[\u2010-\u2015\-]/g, ' ').replace(/\s+/g, ' ');
    var kwHit = function (kw) {
      return normLower.indexOf(kw.replace(/[\u2010-\u2015\-]/g, ' ').replace(/\s+/g, ' ')) !== -1;
    };
    // Only show support links when we're ACTUALLY in support mode (persona=support
    // or on a tech-support page), NOT based on word matching in the AI response.
    var actuallySupport = (chosenPersona === 'support') ||
      (pviCfg.persona === 'support') ||
      /tech-support/i.test(location.pathname);
    var isSupportContext = actuallySupport && SUPPORT_CONTEXT_RE.test(lower);
    // The AI explicitly PROMISED a link ("let me drop that link", "I'll put the
    // link in the chat"). A promised link MUST appear — bypass the dedupe,
    // otherwise the customer sees a promise and no link.
    var promisedLink = /\blink\b/i.test(lower) &&
      /(drop|put|post|paste|shar|send|add|placing|here is|here's|in the chat)/i.test(lower);

    if (isSupportContext || (actuallySupport && (pviIsSupportPage || promisedLink))) {
      // SUPPORT MODE: show tech support page link. Match by AI response keywords
      // OR by current page URL (if we're already on a support page).
      var supportMatch = null;
      // First try matching from the AI response text
      for (var s = 0; s < voiceSupportPages.length; s++) {
        var sp = voiceSupportPages[s];
        for (var sk = 0; sk < sp.keywords.length; sk++) {
          if (kwHit(sp.keywords[sk])) {
            supportMatch = sp;
            break;
          }
        }
        if (supportMatch) break;
      }
      // If no match from AI text, try matching by current page URL
      if (!supportMatch && pviIsSupportPage) {
        var pathLow = location.pathname.toLowerCase();
        for (var sp2 = 0; sp2 < voiceSupportPages.length; sp2++) {
          if (pathLow.indexOf(voiceSupportPages[sp2].url.replace('/pages/', '').toLowerCase()) !== -1) {
            supportMatch = voiceSupportPages[sp2];
            break;
          }
        }
      }
      if (supportMatch && (promisedLink ||
          (supportMatch.url !== rtLastSupportLinkUrl && !pviLinkShown(supportMatch.url)))) {
        rtLastSupportLinkUrl = supportMatch.url;
        pviMarkLinkShown(supportMatch.url);
        console.log('[PVI Voice] Injecting support page link:', supportMatch.label);
        appendMessage('ai', '<div style="font-size:0.9em;margin-top:6px;padding:8px 12px;background:#f0f7ff;border-left:3px solid #0071E3;border-radius:4px">' +
          '<strong>\uD83D\uDEE0\uFE0F Tech Support Page</strong> \u2014 manuals, quick start guides & software updates:<br>' +
          '<a href="' + supportMatch.url + '" style="color:#0071E3;text-decoration:underline;font-weight:600">' + supportMatch.label + '</a></div>');
        scrollToBottom();
      }
      return; // do NOT show product page links in support context
    }

    // PRE-SALES MODE: only show product page links, never support page links
    var matched = [];
    var seenUrls = {};
    voiceAutoLinks.forEach(function(item) {
      for (var i = 0; i < item.keywords.length; i++) {
        if (kwHit(item.keywords[i]) && !seenUrls[item.url] &&
            (promisedLink || !pviLinkShown(item.url))) {
          seenUrls[item.url] = true;
          matched.push(item);
          break;
        }
      }
    });
    // Ambiguous bare "VeCASTER Pro" (no 4K / HDMI / SDI qualifier) matches no specific
    // model above — "Pro" alone could be the PRO HDMI or the 4K-PRO. If the AI said
    // "VeCASTER" and "Pro" but we matched no VeCASTER product, offer the VeCASTER
    // collection so the customer can choose (instead of a promised link that never shows).
    var matchedVecaster = matched.some(function(m) { return m.url.indexOf('vecaster') !== -1; });
    if (!matchedVecaster && /\bvecaster\b/.test(normLower) && /\bpro\b/.test(normLower)) {
      var vcUrl = '/collections/vecaster-iptv-encoders';
      if (!seenUrls[vcUrl] && (promisedLink || !pviLinkShown(vcUrl))) {
        seenUrls[vcUrl] = true;
        matched.push({ label: 'VeCASTER IPTV Encoders', url: vcUrl });
      }
    }
    // ── PAGE-FOLLOW (restored Jul 30 2026, user decree: "one of the best
    // functions we had"; extended to the WIDGET Jul 31) ── the PAGE follows the
    // sales voice conversation: when Lisa's reply clearly centers on exactly
    // ONE product, open its page once her line finishes playing.
    // - www theme: same-tab navigation (chat + voice survive and resume there).
    // - WIDGET: pviExecutePendingNav is build-patched to window.__pviNav, which
    //   opens the www page in a NEW TAB (popup-blocked → queued for next tap);
    //   the host page and the live voice call stay untouched.
    // This scan runs WITHOUT the link-shown dedupe — a product whose link card
    // already appeared must still be able to pull the page when the customer
    // picks it.
    // NEVER yank the page during active quote/lead collection — the navigation
    // restarts the session at the worst moment (Jul 30: navigated ON the quote
    // recap; even with the transcript handoff, moving the page mid-collection
    // is disorienting). Markers target COLLECTION questions/recaps, not the
    // mere word "quote" (an info reply offering a free quote must still follow).
    var pviCollecting = /\b(recap|shall i (go ahead|send)|what'?s? (the |your )?(best )?(name|email|phone)|name (for|on|i should put on) the quote|how many (units|pieces)|shipping address|billing address|quote number|already in your inbox)\b/i.test(lower);
    if (currentMode === 'voice' && !pviCollecting &&
        !rtPendingNavUrl && !rtPendingPersonaRestart) {
      var navSeen = {};
      var navUrls = [];
      voiceAutoLinks.forEach(function(item) {
        for (var nk = 0; nk < item.keywords.length; nk++) {
          if (kwHit(item.keywords[nk])) {
            if (!navSeen[item.url]) { navSeen[item.url] = true; navUrls.push(item.url); }
            break;
          }
        }
      });
      // Exactly ONE product in the reply = unambiguous focus. Two or more =
      // the customer is still choosing (e.g. "we have the MINIMOD-2+ and the
      // MINIMOD-4K") — stay put.
      if (navUrls.length === 1 && navUrls[0] !== rtLastSalesNavUrl &&
          location.pathname.toLowerCase().indexOf(navUrls[0].toLowerCase()) === -1) {
        rtLastSalesNavUrl = navUrls[0];
        console.log('[PVI Voice] Sales page-follow \u2192', navUrls[0]);
        pviScheduleNavAfterSpeech(navUrls[0]);
      }
    }

    if (matched.length === 0) return;
    // Offer the SINGLE most relevant product (first match) as an explicit
    // "Click here to see this solution" card, instead of raw link chips.
    var offer = matched[0];
    if (offer.url === rtLastLinkKey && !promisedLink) { console.log('[PVI Voice] Skipping duplicate offer'); return; }
    rtLastLinkKey = offer.url;
    console.log('[PVI Voice] Offering product:', offer.label);
    pviShowProductOffer(offer.label, offer.url, transcript);
  }

  // ── Shared mode-update handler ─────────────────────────────────────
  // The WORKER decides the conversation mode (via the AI's
  // set_conversation_mode tool). Text receives it as an SSE event,
  // voice receives it in the /api/voice-tool-call response. The frontend
  // just applies it: persona, support link, auto-navigation.
  // ── Graceful deferred navigation (voice) ───────────────────────────
  // When the voice AI switches support pages, we must NOT cut its speech.
  // The AI says a short transition line ("Got it — let me switch you over
  // to the X support page…"); we navigate only when the audio FINISHES
  // (output_audio_buffer.stopped), with a hard fallback so the customer
  // is never stranded if the event doesn't arrive.
  var rtPendingNavUrl = null;
  var rtPendingNavSetAt = 0;
  var rtPendingNavTimer = null;
  function pviExecutePendingNav() {
    if (!rtPendingNavUrl) return;
    // Fallback fired mid-speech — never cut the transition line; wait for its
    // stopped event with a short re-check net. rtAudioPlaying matters as much as
    // rtAISpeaking: generation ends (response.done) while audio still plays.
    if ((rtAISpeaking || rtAudioPlaying) && (Date.now() - rtPendingNavSetAt) < 15000) {
      if (rtPendingNavTimer) clearTimeout(rtPendingNavTimer);
      rtPendingNavTimer = setTimeout(pviExecutePendingNav, 2000);
      return;
    }
    var u = rtPendingNavUrl;
    rtPendingNavUrl = null;
    if (rtPendingNavTimer) { clearTimeout(rtPendingNavTimer); rtPendingNavTimer = null; }
    // Flush the transcript NOW (keepalive) before we leave — otherwise the
    // pending debounced save is cancelled by the navigation and the AI's turns
    // for this page are lost. final=true emails the complete transcript — only
    // on the www theme, where the page really unloads; on the WIDGET the page
    // stays alive (new tab) and the call continues, so final would email a
    // half-finished conversation.
    try { pviPushTranscript(true, !window.__pviCfg); } catch (_) {}
    // Mark this as an AI-DRIVEN page switch for the next page's resume greeting
    // (Zanus kit semantics: 30s validity, consumed on read). AI nav → walk the
    // customer into the page in CONTINUATION style; manual nav → quiet resume.
    try { sessionStorage.setItem('pvi_ai_nav', JSON.stringify({ at: Date.now(), url: u })); } catch (_) {}
    console.log('[PVI Voice] Navigating to:', u);
    window.location.href = u;
    // WIDGET (Jul 30 2026): on the portable widget the line above is patched to
    // open a NEW TAB — THIS page keeps running, so the voice session never gets
    // the destination-page restart the www theme gets. If the answering persona
    // changed (e.g. Mary → John tech support), restart the session in place so
    // the right colleague actually picks up. On the www theme the page unloads
    // before this timer fires, so it is a harmless no-op there.
    setTimeout(function() {
      if (currentMode === 'voice' && !rtPendingNavUrl && pviActivePersona !== rtSessionPersona) {
        console.log('[PVI Voice] Widget nav kept page alive — restarting for persona', pviActivePersona);
        pviSchedulePersonaRestart();
        pviExecutePersonaRestart();
      } else if (currentMode === 'voice' && !rtPendingNavUrl && pviActivePersona === 'sales' &&
                 rtDataChannel && rtDataChannel.readyState === 'open') {
        // WIDGET sales page-follow (Jul 31): the teaser rule keeps Lisa's
        // pre-nav line SHORT ("let me bring it up for you") and the full pitch
        // is supposed to happen on the product page. On www the destination
        // page's continuation greeting delivers it — but here the page opened
        // in a NEW TAB and THIS session keeps running, so nudge Lisa to give
        // the presentation now. Support navs are excluded: John's doc-reload
        // flow has its own announce.
        console.log('[PVI Voice] Widget sales nav — nudging full presentation');
        rtMicHoldUntilDone = true;
        try {
          rtDataChannel.send(JSON.stringify({
            type: 'response.create',
            response: { instructions:
              'The product page you were bringing up just opened on the customer\'s screen. ' +
              'Now give the full presentation: 2-3 confident sentences walking them through the product, ' +
              'then ONE question to keep the conversation going. Do not mention tabs or windows — continue naturally.' }
          }));
        } catch (err) { console.error('[PVI Voice] Widget nav pitch nudge error:', err); }
      }
    }, 1600);
  }
  function pviScheduleNavAfterSpeech(url) {
    rtPendingNavUrl = url;
    rtPendingNavSetAt = Date.now();
    if (rtPendingNavTimer) clearTimeout(rtPendingNavTimer);
    // NO DEAD AIR (user order Jul 30): cap true silence at ~5s (was 14s). If the
    // transition line is still playing when this fires, execute defers to its end.
    rtPendingNavTimer = setTimeout(pviExecutePendingNav, 5000);
  }

  // ── Live persona transfer on WEB VOICE (Jul 30 2026) ───────────────
  // Dana/John/Mary hand the conversation to another colleague: the current
  // session speaks ONE short transition line, then we restart the Realtime
  // session — the worker picks the new persona's prompt + voice from the
  // session mode (Mary=marin, Lisa=alloy). Mirrors the phone's AI→AI transfer.
  var rtPendingPersonaRestart = false;
  var rtPendingPersonaSetAt = 0;
  var rtPendingPersonaTimer = null;
  var rtJustTransferred = false; // greeting: transfer pickup instead of hello
  var rtSessionPersona = null;   // persona the CURRENT voice session was started as
  function pviExecutePersonaRestart() {
    if (!rtPendingPersonaRestart) return;
    // Fallback fired while the transition line is STILL PLAYING — that is not
    // silence, so let it finish (its stopped event restarts); re-check shortly.
    // rtAudioPlaying is the REAL playback state (rtAISpeaking drops at
    // response.done while the speaker is still talking — Jul 30 truncations).
    if ((rtAISpeaking || rtAudioPlaying) && (Date.now() - rtPendingPersonaSetAt) < 12000) {
      if (rtPendingPersonaTimer) clearTimeout(rtPendingPersonaTimer);
      rtPendingPersonaTimer = setTimeout(pviExecutePersonaRestart, 2000);
      return;
    }
    rtPendingPersonaRestart = false;
    if (rtPendingPersonaTimer) { clearTimeout(rtPendingPersonaTimer); rtPendingPersonaTimer = null; }
    if (currentMode !== 'voice' || rtPendingNavUrl) return;
    console.log('[PVI Voice] Persona transfer restart →', pviActivePersona);
    rtDocInstructions = null;
    rtDocAnnouncePending = false;
    rtJustTransferred = true;
    stopRealtimeVoice();
    setTimeout(function() {
      if (currentMode === 'voice') {
        startRealtimeVoice().catch(function() { setMode('text'); });
      }
    }, 300);
  }
  function pviSchedulePersonaRestart() {
    rtPendingPersonaRestart = true;
    rtPendingPersonaSetAt = Date.now();
    if (rtPendingPersonaTimer) clearTimeout(rtPendingPersonaTimer);
    // NO DEAD AIR (user order Jul 30): cap true silence at ~3s (was 9s). If the
    // transition line is still playing when this fires, execute defers to its end.
    rtPendingPersonaTimer = setTimeout(pviExecutePersonaRestart, 3000);
  }

  function pviApplyModeUpdate(mu, navDelayMs) {
    if (!mu || !mu.mode) return;
    console.log('[PVI] Mode update from worker:', mu.mode, mu.modelKey || '', mu.personaName || '');
    var prevPersona = pviActivePersona;
    var voiceActiveNow = currentMode === 'voice' && rtDataChannel && rtDataChannel.readyState === 'open';
    if (mu.mode === 'service') {
      // Transfer to Mary (customer service): label change + voice restart.
      pviActivePersona = 'service';
      pviRetagStreamingLabel();
      pviSaveSession();
      if (voiceActiveNow && prevPersona !== 'service') pviSchedulePersonaRestart();
      return;
    }
    if (mu.mode === 'support') {
      pviActivePersona = 'support';
      pviRetagStreamingLabel();
      chosenPersona = 'support';
      if (mu.displayName) supportProduct = mu.displayName;
      pviSaveSession();
      if (mu.supportUrl) {
        var alreadyOn = location.pathname.indexOf(mu.supportUrl.replace('/pages/', '')) !== -1;
        if (!pviLinkShown(mu.supportUrl)) {
          pviMarkLinkShown(mu.supportUrl);
          appendMessage('ai', '<div style="font-size:0.9em;margin-top:6px;padding:8px 12px;background:#f0f7ff;border-left:3px solid #0071E3;border-radius:4px">' +
            '<strong>\uD83D\uDEE0\uFE0F Tech Support' + (mu.displayName ? ' — ' + pviEscapeHtml(mu.displayName) : '') + '</strong><br>' +
            (alreadyOn ? '' : 'Taking you to the support page with all the manuals and documentation... ') +
            '<a href="' + mu.supportUrl + '" style="color:#0071E3;text-decoration:underline;font-weight:600">Open the tech support page</a></div>');
          scrollToBottom();
        }
        if (!alreadyOn) {
          var voiceActive = currentMode === 'voice' && rtDataChannel && rtDataChannel.readyState === 'open';
          if (voiceActive) {
            // Wait for the AI's spoken transition to finish, THEN switch
            pviScheduleNavAfterSpeech(mu.supportUrl);
          } else {
            // TEXT navigation: remember the switch so the destination page greets
            // with a product-confirming line and reopens the panel (voice has its
            // own destination greeting via pviBuildVoiceGreeting, so flag text only).
            pviPendingSwitch = { persona: 'support', product: mu.displayName || '', url: mu.supportUrl, ts: Date.now() };
            pviSaveSession();
            setTimeout(function() { window.location.href = mu.supportUrl; }, navDelayMs || 1600);
          }
        } else if (voiceActiveNow && prevPersona !== 'support') {
          // Already on the right page, but another colleague's voice is live
          // (Lisa/Dana/Mary) — restart so John (support) picks up.
          pviSchedulePersonaRestart();
        }
      } else if (voiceActiveNow && prevPersona !== 'support') {
        // Transfer to support with NO page navigation (model not yet known, or
        // no support page): restart so John picks up — from ANY colleague,
        // including Lisa (Jul 30: only Dana/Mary restarted, so a sales voice
        // kept talking after announcing the support transfer).
        pviSchedulePersonaRestart();
      }
    } else {
      chosenPersona = 'info';
      pviActivePersona = 'sales';
      pviRetagStreamingLabel();
      pviSaveSession();
      // Live transfer to Lisa (sales) on web voice: whenever the live voice is
      // a DIFFERENT colleague (Dana, Mary, or John) — restart so Lisa picks up.
      // Jul 30: support was missing from this list, so John said "one moment
      // while I get Lisa" and nobody ever picked up (dead air, then John kept
      // talking and deflected the customer to the phone number).
      if (voiceActiveNow && prevPersona !== 'sales') {
        pviSchedulePersonaRestart();
      }
    }
  }

  // ── Voice transcript snapshots ─────────────────────────────────────
  // Voice conversations never hit /api/chat, so the worker would have no
  // transcript to email. Push a snapshot after each AI reply; the worker
  // cron emails ONE complete transcript per session once it goes quiet.
  var pviTranscriptTimer = null;
  // immediate = POST now (no debounce). isFinal = the conversation ENDED → the
  // worker emails the complete transcript right away (no 5-min cron wait). We
  // always send the full chatHistory so a final flush is one atomic store+send
  // (no race with a concurrent save). keepalive lets the POST survive a page
  // navigation / tab close that used to cancel it and drop the AI's replies.
  function pviPushTranscript(immediate, isFinal) {
    if (pviTranscriptTimer) { clearTimeout(pviTranscriptTimer); pviTranscriptTimer = null; }
    var doPost = function() {
      if (!chatHistory.length) return;
      fetch(API_BASE + '/api/save-transcript', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          session_id: sessionId,
          channel: currentMode === 'voice' ? 'VOICE' : 'TEXT',
          messages: chatHistory.slice(-80),
          product: (product && product.title) || '',
          language: currentLang,
          final: !!isFinal
        }),
        keepalive: true
      }).catch(function() {});
    };
    if (immediate) { doPost(); return; }
    pviTranscriptTimer = setTimeout(doPost, 2500);
  }
  var rtCurrentUserText = ''; // current user transcript being built
  var rtCurrentAITextEl = null;
  var rtCurrentAIText = '';

  function ensureRTAudioEl() {
    if (rtAudioEl) return rtAudioEl;
    rtAudioEl = document.createElement('audio');
    rtAudioEl.autoplay = true;
    rtAudioEl.playsInline = true;
    rtAudioEl.setAttribute('playsinline', '');
    rtAudioEl.setAttribute('webkit-playsinline', '');
    rtAudioEl.style.display = 'none';
    document.body.appendChild(rtAudioEl);

    // iOS audio session resilience — pressing volume buttons / locking screen / changing
    // route can briefly suspend audio. Resume automatically.
    var resumePlay = function() {
      if (rtAudioEl && rtAudioEl.srcObject) {
        rtAudioEl.play().catch(function() {});
      }
    };
    // Safety net for auto-resume after page navigation: if the browser blocks
    // audio-output autoplay on the fresh page (no user gesture yet), resume the
    // AI voice on the customer's first tap/click.
    var pviUnlockAudio = function() {
      if (rtAudioEl && rtAudioEl.srcObject && rtAudioEl.paused) {
        rtAudioEl.play().catch(function() {});
      }
    };
    document.addEventListener('pointerdown', pviUnlockAudio, { passive: true });
    document.addEventListener('touchstart', pviUnlockAudio, { passive: true });

    rtAudioEl.addEventListener('pause', function() {
      if (rtConnected && rtAudioEl.srcObject) {
        setTimeout(resumePlay, 100);
      }
    });
    rtAudioEl.addEventListener('suspend', resumePlay);
    rtAudioEl.addEventListener('stalled', resumePlay);
    rtAudioEl.addEventListener('waiting', resumePlay);
    return rtAudioEl;
  }

  // iOS — when user returns to tab after pressing volume buttons or unlocking,
  // re-check connection and resume audio. Reconnect if WebRTC is dead.
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState !== 'visible') return;
    if (currentMode !== 'voice') return;
    if (rtAudioEl && rtAudioEl.paused && rtAudioEl.srcObject) {
      rtAudioEl.play().catch(function() {});
    }
    if (rtPC && (rtPC.connectionState === 'failed' || rtPC.connectionState === 'disconnected' || rtPC.connectionState === 'closed')) {
      if (Date.now() - rtStartedAt < 5000) return; // too soon after start — not a real disconnect
      console.log('[PVI Voice] Connection died while backgrounded — reconnecting');
      stopRealtimeVoice();
      setTimeout(function() {
        startRealtimeVoice().catch(function() { setMode('text'); });
      }, 200);
    }
  });

  // Release the microphone the instant we start leaving the page. Desktop (esp.
  // Windows) can otherwise hold the device open through the navigation, making the
  // NEXT page's getUserMedia fail with NotReadableError — the reason voice failed
  // to auto-resume on PC while iPhone (faster device release) worked. Guarded with
  // event.persisted so it never interferes with a bfcache restore.
  window.addEventListener('pagehide', function(e) {
    if (e && e.persisted) return;
    if (currentMode !== 'voice') return;
    try { if (rtMicStream) rtMicStream.getTracks().forEach(function(tr) { tr.stop(); }); } catch (_) {}
    try { if (rtPC) rtPC.close(); } catch (_) {}
  });

  // Build an explicit page-aware greeting instruction. The realtime model does
  // NOT reliably follow "say the greeting in your system instructions", so we
  // give it the exact content to say based on the current page.
  var pviIsSupportPage = (pageCtx.page_handle || '').indexOf('tech-support') !== -1;
  // Resolve the support page slug to a SHORT product name. Never feed the raw
  // slug to the voice — "tech-support-for-vumatrix-av-over-ip-..." humanized
  // starts with "For ..." and the voice literally says "is this for your FOUR".
  function pviSupportShortName(handle) {
    var h = String(handle || '').toLowerCase();
    var rules = [
      [/minimod-2-plus/, 'VeCOAX MINIMOD 2+'],
      [/minimod-4k/, 'VeCOAX MINIMOD 4K'],
      [/minimod-2/, 'VeCOAX MINIMOD 2'],
      [/micromod-3-plus-sdi/, 'VeCOAX MICROMOD 3+ SDI'],
      [/micromod-3-plus/, 'VeCOAX MICROMOD 3+'],
      [/micromod-3-sdi/, 'VeCOAX MICROMOD 3 SDI'],
      [/micromod-3/, 'VeCOAX MICROMOD 3'],
      [/ultra-plus/, 'VeCOAX ULTRA+'],
      [/vecoax-ultra/, 'VeCOAX ULTRA'],
      [/rack-2|rack-4/, 'VeCOAX RACK 2/4'],
      [/blade/, 'VeCOAX BLADE'],
      [/infinium/, 'INFINIUM'],
      [/vecaster/, 'VeCASTER'],
      [/vecoder-4k/, 'VeCODER 4K'],
      [/vecoder/, 'VeCODER'],
      [/veplayer-4|veplayer-rack/, 'VePLAYER RACK'],
      [/veplayer/, 'VePLAYER'],
      [/vumatrix/, 'VuMATRIX'],
      [/vecoax-network/, 'VeCOAX NETWORK'],
      [/pixel/, 'VeCOAX PIXEL'],
      [/pro4/, 'VeCOAX PRO4']
    ];
    for (var i = 0; i < rules.length; i++) {
      if (rules[i][0].test(h)) return rules[i][1];
    }
    // Fallback: strip "tech-support" / "page" / "for" prefixes before humanizing
    var rest = h.replace(/^tech-support/, '').replace(/^[-_]+/, '')
      .replace(/^(page|for)[-_]+/, '').replace(/^(page|for)[-_]+/, '');
    return pviHumanize(rest);
  }
  var pviSupportPageProduct = pviIsSupportPage ? pviSupportShortName(pageCtx.page_handle) : '';

  function pviBuildVoiceGreeting() {
    var langName = (I18N[currentLang] && I18N[currentLang].name) || 'English';
    var resuming = chatHistory && chatHistory.length > 0;
    var productName = (product && product.title) ? product.title
      : (pageCtx && pageCtx.page_type === 'product' && pageCtx.page_handle ? pviHumanize(pageCtx.page_handle) : '');
    var who;

    // Mary (customer service) — order status + tracking, any page
    if (pviActivePersona === 'service') {
      who = resuming
        ? 'You are mid-conversation as the customer service colleague. Do NOT re-introduce yourself; just continue helping with the order.'
        : 'Warmly greet the customer: introduce yourself by first name — your name is Mary, say exactly "this is Mary" — as customer service and offer to check an order status or email tracking. Ask for their order number. Two sentences max, then listen.';
      return who + ' Speak in ' + langName + '.';
    }

    if (resuming) {
      // MID-SESSION PAGE CHANGE: the customer navigated to a new page during a conversation.
      // Do NOT re-introduce yourself, do NOT re-ask "info or support?". Just acknowledge the new page briefly.
      // CRITICAL (Jul 30 amnesia bug): the restarted Realtime session has NO
      // memory — the page-follow navigated right on Lisa's quote recap and the
      // new session re-asked the quantity AND re-verified the email. Hand it
      // the recent transcript, exactly like the live-transfer pickup does.
      var resumeRecent = '';
      for (var rh = Math.max(0, chatHistory.length - 8); rh < chatHistory.length; rh++) {
        resumeRecent += (chatHistory[rh].role === 'user' ? 'Customer: ' : 'You (earlier): ') +
          String(chatHistory[rh].content || '').replace(/<[^>]+>/g, '').slice(0, 300) + '\n';
      }
      var resumeCtx = '\nRecent conversation from BEFORE the page change — this is YOUR OWN ongoing conversation, continue it seamlessly:\n' +
        resumeRecent +
        '\nNEVER re-ask anything already answered above (name, email, quantity, product, details) — it is all still valid. ' +
        'If a quote or request was in progress, pick it up EXACTLY where it left off. ';
      // AI-DRIVEN switch vs manual navigation (Zanus kit semantics, Jul 31):
      // when WE moved the page, the customer expects the same voice to keep
      // talking — CONTINUATION style, never announce the switch, never
      // "I see you are looking at". Flag is 30s valid, consumed on read.
      var pviAiNav = null;
      try {
        pviAiNav = JSON.parse(sessionStorage.getItem('pvi_ai_nav') || 'null');
        sessionStorage.removeItem('pvi_ai_nav');
      } catch (_) {}
      if (!(pviAiNav && (Date.now() - pviAiNav.at) < 30000)) pviAiNav = null;
      if (pviIsSupportPage) {
        var spName = pviSupportPageProduct || 'this product';
        who = pviAiNav
          ? ('You just switched the customer\'s page to the ' + spName + ' tech support page — it is NOW on their screen. ' + resumeCtx +
            'Continue talking as if you never stopped, in CONTINUATION style — e.g. "So — here we are on the ' + spName + ' support page. ..." ' +
            'NEVER say "I see you are looking at", never mention that the page switched or that you switched it, never re-greet. ' +
            'If they ALREADY described a problem above, address THAT problem right now; otherwise ask ONE short question about their issue.')
          : ('The customer just switched to tech support and landed on the ' + spName + ' support page. ' + resumeCtx +
            'In ONE short line, confirm the product and continue — say something like "Here is the ' + spName + ' tech support page. How can I help you with it?" ' +
            'If they ALREADY described a problem above, acknowledge the product and address THAT problem instead of re-asking. ' +
            'Do NOT re-introduce yourself. Do NOT repeat any previous greeting. Then listen.');
      } else if (productName) {
        who = pviAiNav
          ? ('You just switched the customer\'s page to the ' + productName + ' page — it is NOW on their screen. ' + resumeCtx +
            'Continue talking as if you never stopped, in CONTINUATION style — e.g. "So — this is the ' + productName + '. ..." — 2-3 confident sentences walking them into what they are seeing, then ONE question to keep the conversation going. ' +
            'NEVER say "I see you are looking at", never mention that the page switched or that you switched it, never re-greet.')
          : ('The customer just navigated to the ' + productName + ' page. ' + resumeCtx +
            'Briefly acknowledge the page in ONE sentence — like "I see you\'re now looking at the ' + productName + '." — then continue the pending conversation from above (e.g. finish the quote recap and ask for the final YES). ' +
            'Do NOT re-introduce yourself. Do NOT re-ask "info or support?". Do NOT repeat any previous greeting.');
      } else {
        who = 'The customer navigated to a new page. ' + resumeCtx +
          'Do NOT say anything unless they speak first. Stay silent and listen; when they speak, continue the conversation above.';
      }
    } else if (pviIsSupportPage) {
      var spName2 = pviSupportPageProduct || 'this product';
      who = 'Warmly greet the customer. You can see they are on the tech support page for ' + spName2 + '. ' +
        'Ask: "Is this for your ' + spName2 + ', or do you need help with a different product?" ' +
        'Keep it brief — two sentences max, then listen.';
    } else if (productName) {
      who = 'Warmly greet the customer. You can see they are looking at our ' + productName + '. ' +
        'Ask: "Would you like some information about this product, or do you need tech support on a unit you already have?" ' +
        'Keep it brief — two sentences max, then listen.';
    } else if (pageCtx && pageCtx.page_type === 'collection') {
      who = 'Warmly greet the customer and mention you can see they are browsing our ' + (pageCtx.page_title || 'products') + '. ' +
        'Ask how you can help — whether they need product info or tech support. Two sentences max, then listen.';
    } else {
      // Neutral page (homepage, contact, cart...) — Lisa answers directly.
      // NO Dana on the web (Jul 30 2026). The name is pinned here because the
      // model once invented "Alex" when told only "introduce yourself".
      who = 'Warmly greet the customer, welcome them to Pro Video Instruments. Introduce yourself by first name — your name is Lisa, say exactly "this is Lisa". ' +
        'Ask if they are looking for product information or need tech support on a unit they already have. Two sentences max, then listen.';
    }

    return who + ' Speak in ' + langName + '.';
  }

  // getUserMedia with a short retry. After a page navigation the previous page's
  // microphone may not be fully released yet (common on Windows desktop), causing
  // a transient NotReadableError/AbortError. Retrying briefly is what lets the PC
  // auto-resume voice the same way mobile already does. Permission denials are NOT
  // retried (no point) so we still fail fast when the user truly blocks the mic.
  function pviGetMic(attempt) {
    return navigator.mediaDevices.getUserMedia({
      audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true }
    }).catch(function(err) {
      var n = err && err.name;
      var transient = n === 'NotReadableError' || n === 'AbortError' || n === 'NotFoundError';
      if (transient && attempt < 3) {
        console.log('[PVI Voice] Mic busy (' + n + ') — retry ' + (attempt + 1));
        return new Promise(function(res) { setTimeout(res, 350 + attempt * 350); })
          .then(function() { return pviGetMic(attempt + 1); });
      }
      throw err;
    });
  }

  function startRealtimeVoice() {
    if (rtStarting) {
      console.log('[PVI Voice] Already starting — skipping duplicate');
      return Promise.resolve();
    }
    rtStarting = true;
    rtResponseCount = 0;
    rtLastLinksInjected = '';
    rtLastLinkKey = '';
    if (!rtDocInstructions) rtDocModelLoaded = null;
    rtDocLoading = false;
    return new Promise(function(resolve, reject) {
      var micStream = null;

      pviGetMic(0).then(function(stream) {
        micStream = stream;
        rtMicStream = stream;

        // Create peer connection
        rtPC = new RTCPeerConnection();
        ensureRTAudioEl();

        rtPC.ontrack = function(e) {
          if (rtAudioEl && e.streams && e.streams[0]) {
            rtAudioEl.srcObject = e.streams[0];
            rtAudioEl.play().catch(function() {});
          }
        };

        rtPC.onconnectionstatechange = function() {
          console.log('[PVI Voice] PC state:', rtPC && rtPC.connectionState);
          if (!rtPC) return;
          var s = rtPC.connectionState;
          if (s === 'failed' || s === 'disconnected') {
            if (currentMode === 'voice') {
              setTimeout(function() {
                if (currentMode !== 'voice') return;
                if (rtPC && rtPC.connectionState === 'connected') return;
                if (Date.now() - rtStartedAt < 5000) return; // too soon — not a real disconnect
                console.log('[PVI Voice] Reconnecting after disconnect');
                stopRealtimeVoice();
                setTimeout(function() {
                  startRealtimeVoice().catch(function() { setMode('text'); });
                }, 200);
              }, 1500);
            }
          }
        };

        // Add mic track (starts muted to prevent echo during greeting)
        stream.getTracks().forEach(function(track) {
          track.enabled = false;
          rtPC.addTrack(track, stream);
        });

        // Data channel
        rtDataChannel = rtPC.createDataChannel('oai-events');
        rtDataChannel.onmessage = handleRealtimeEvent;
        rtDataChannel.onopen = function() {
          rtConnected = true;
          rtStarting = false;
          rtStartedAt = Date.now();
          rtSessionPersona = pviActivePersona; // who answers THIS session
          rtAISpeaking = true;
          if (chatTextarea) chatTextarea.placeholder = t().listening;
          if (micBtn) micBtn.classList.add('pvi-mic-active');
          console.log('[PVI Voice] Connected — sending greeting');
          try {
            var greetingInstr;
            var wasTransfer = rtJustTransferred;
            if (rtJustTransferred) {
              // LIVE TRANSFER PICKUP: the new persona has NO session history —
              // hand it the recent transcript so it continues seamlessly.
              rtJustTransferred = false;
              var xferLangName = (I18N[currentLang] && I18N[currentLang].name) || 'English';
              var xferRecent = '';
              for (var xh = Math.max(0, chatHistory.length - 6); xh < chatHistory.length; xh++) {
                xferRecent += (chatHistory[xh].role === 'user' ? 'Customer: ' : 'Colleague: ') +
                  String(chatHistory[xh].content || '').replace(/<[^>]+>/g, '').slice(0, 300) + '\n';
              }
              // PIN THE NAME. "Introduce yourself by first name" alone makes the
              // model INVENT one ("Emma", Jul 30 9:43 PM session — same class as
              // the "Alex" bug). Every greeting that introduces a persona must
              // state the exact name to say.
              var xferName = pviActivePersona === 'support' ? 'John'
                : pviActivePersona === 'service' ? 'Mary' : 'Lisa';
              greetingInstr = 'LIVE TRANSFER: a colleague just handed this customer to you. Recent conversation:\n' +
                xferRecent +
                '\nYour name is ' + xferName + ' — introduce yourself in ONE short warm line saying exactly "this is ' + xferName + '" (NEVER any other name) and continue seamlessly from the customer\'s pending request above — never re-ask anything they already said. Speak in ' + xferLangName + '.';
            } else if (rtDocInstructions) {
              // MEMORY, not amnesia: this restart happens MID-conversation (a
              // procedure may be in progress). "Ask what they need help with"
              // here made John forget a reset he was walking the customer
              // through (Jul 31 VuMATRIX session). Embed the recent turns and
              // continue the pending request instead.
              var docRecent = '';
              for (var dh = Math.max(0, chatHistory.length - 6); dh < chatHistory.length; dh++) {
                docRecent += (chatHistory[dh].role === 'user' ? 'Customer: ' : 'You (earlier): ') +
                  String(chatHistory[dh].content || '').replace(/<[^>]+>/g, '').slice(0, 300) + '\n';
              }
              greetingInstr = 'You just loaded the full technical documentation for the product being discussed. ' +
                'Recent conversation (YOUR own ongoing conversation — continue it):\n' + docRecent +
                '\nIf a question or procedure is pending above, continue it RIGHT NOW from the documentation — pick up exactly where it left off, never re-ask what they need or anything already answered. ' +
                'If nothing is pending, say ONE short line that the documentation is ready. Do not greet again.';
            } else {
              greetingInstr = pviBuildVoiceGreeting();
            }
            // This greeting was not prompted by the customer speaking — hold the
            // mic muted for its whole duration so the AI can't hear/interrupt
            // itself (the "Hi… Hi…" restart) before echo cancellation locks on.
            rtMicHoldUntilDone = true;
            var pviSendGreeting = function() {
              try {
                rtDataChannel.send(JSON.stringify({
                  type: 'response.create',
                  response: { instructions: greetingInstr }
                }));
              } catch(err2) { console.error('[PVI Voice] Greeting send error:', err2); }
            };
            if (wasTransfer) {
              // TRANSFER PICKUP: let the audio path settle first — requesting the
              // greeting the instant the channel opens ate John's first words
              // (Jul 30 stutter report). ~700ms is imperceptible after a transfer.
              setTimeout(pviSendGreeting, 700);
            } else {
              pviSendGreeting();
            }
          } catch(err) { console.error('[PVI Voice] Greeting error:', err); }
        };

        // Create offer
        return rtPC.createOffer();
      }).then(function(offer) {
        return rtPC.setLocalDescription(offer).then(function() { return offer; });
      }).then(function(offer) {
        // Single round trip: send SDP + params to our worker
        var fd = new FormData();
        fd.append('sdp', offer.sdp);
        var callParams = {
          product_title: product.title || '',
          product_handle: product.handle || '',
          page_type: pageCtx.page_type || '',
          page_title: pageCtx.page_title || '',
          collection_handle: pageCtx.collection_handle || '',
          page_handle: pageCtx.page_handle || '',
          voice: selectedVoice,
          speed: selectedSpeed,
          // Persona is sent ONLY when explicitly established — never a default
          // guess. The worker state machine owns the mode. 'service' rides on
          // pviActivePersona (set by a mode_update transfer to Mary).
          persona: pviActivePersona === 'service' ? 'service'
            : (chosenPersona === 'support' ? 'support' : (chosenPersona === 'info' ? 'sales' : (pviCfg.persona === 'support' ? 'support' : ''))),
          session_id: sessionId,
          // Mid-session reconnect (page navigation): the worker strips the
          // "Hi!" opening greeting from the voice prompt so the AI never
          // re-introduces itself like a tape machine.
          has_interacted: chatHistory.length > 0,
          language: currentLang
        };
        if (rtDocInstructions) {
          callParams.enriched_instructions = rtDocInstructions;
        }
        fd.append('params', JSON.stringify(callParams));
        return fetch(API_BASE + '/api/realtime-call', { method: 'POST', body: fd });
      }).then(function(r) {
        if (!r.ok) return r.text().then(function(txt) { throw new Error('Call failed: ' + txt); });
        return r.text();
      }).then(function(answerSdp) {
        return rtPC.setRemoteDescription({ type: 'answer', sdp: answerSdp });
      }).then(resolve).catch(function(err) {
        rtStarting = false;
        console.error('Realtime voice error:', err);
        appendMessage('ai', '<em>Voice mode unavailable. Please use text mode.</em>');
        reject(err);
      });
    });
  }

  function stopRealtimeVoice() {
    rtConnected = false;
    rtStarting = false;
    if (rtDataChannel) {
      try { rtDataChannel.close(); } catch(e) {}
      rtDataChannel = null;
    }
    if (rtPC) {
      try { rtPC.close(); } catch(e) {}
      rtPC = null;
    }
    if (rtMicStream) {
      rtMicStream.getTracks().forEach(function(track) { track.stop(); });
      rtMicStream = null;
    }
    if (rtAudioEl) {
      try { rtAudioEl.pause(); rtAudioEl.srcObject = null; } catch(e) {}
    }
    if (micBtn) micBtn.classList.remove('pvi-mic-active');
    if (chatTextarea) chatTextarea.placeholder = t().placeholder;
  }

  // Product model names the user might say by voice — used to trigger doc loading.
  var VOICE_MODEL_KEYWORDS = [
    'vecaster', 'vecoder', 'veplayer', 'vumatrix', 'infinium',
    'minimod', 'micromod', 'ultra plus', 'ultra+', 'rack 2', 'rack 4', 'blade',
    'ip mod', 'ip-mod', 'ipmod', 'ip modulator', 'pixel'
  ];
  

  var rtDocInstructions = null; // enriched prompt from /api/voice-support-docs

  // Which product keyword was detected in the current transcript
  function pviDetectMentionedModel(lower) {
    for (var i = 0; i < VOICE_MODEL_KEYWORDS.length; i++) {
      if (lower.indexOf(VOICE_MODEL_KEYWORDS[i]) !== -1) return VOICE_MODEL_KEYWORDS[i];
    }
    return null;
  }

  // Track the "current product context" so we can detect switches
  var rtCurrentProductKeyword = null;

  // Doc-reload restart coordination — see pviVoiceMaybeLoadDocs
  var rtDocRestartPending = false;
  var rtDocAnnouncePending = false;
  var rtToolCallInFlight = false;
  // Docs were swapped into the LIVE session (no restart) — tell the AI to
  // continue the pending question with them, without re-greeting the customer.
  function pviDoDocAnnounce() {
    rtDocAnnouncePending = false;
    if (currentMode !== 'voice' || !rtDataChannel || rtDataChannel.readyState !== 'open') return;
    rtMicHoldUntilDone = true;
    try {
      rtDataChannel.send(JSON.stringify({
        type: 'response.create',
        response: { instructions:
          'You just received the FULL technical documentation for the product being discussed. ' +
          'If the customer has a pending question or a procedure in progress (reset, setup, troubleshooting), continue it RIGHT NOW from the documentation — pick up exactly where you left off, never re-ask what they need. ' +
          'If nothing is pending, say ONE short line that you have the full documentation ready. Do not greet again.' }
      }));
    } catch (err) { console.error('[PVI Voice] Doc announce error:', err); }
  }
  function pviDoDocRestart() {
    // A live persona transfer is about to restart the session anyway — the doc
    // enrichment can re-trigger afterwards on the new session if still needed.
    if (rtPendingPersonaRestart) return;
    rtDocRestartPending = false;
    rtDocAnnouncePending = false;
    if (rtPendingNavUrl || currentMode !== 'voice') return;
    console.log('[PVI Voice] Restarting Realtime with enriched prompt');
    stopRealtimeVoice();
    setTimeout(function() {
      if (currentMode === 'voice') {
        startRealtimeVoice().catch(function() { setMode('text'); });
      }
    }, 300);
  }

  // Buy/price vs support intent — mirrors the worker's BUY_INTENT_RE /
  // SUPPORT_INTENT_RE so voice flips support→sales the same way text does.
  var PVI_VOICE_BUY_RE = /(\b(want|like|need|looking|trying|wish|planning|hoping)\s+to\s+(buy|purchase|order|acquire)\b|\b(buy|purchase|order)\s+(a|an|one|some|the|new|another)\b|\bplace\s+an?\s+order\b|\bhow\s+much\b|\bwhat'?s?\s+the\s+(price|cost|msrp)\b|\bprice\b|\bpriced\b|\bpricing\b|\bquote\b)/i;
  var PVI_VOICE_SUPPORT_RE = /\b(tech\s*support|troubleshoot|stopped\s+working|not\s+working|doesn'?t\s+work|won'?t\s+(work|turn|power)|is\s+broken|factory\s+reset|firmware|no\s+signal|ip\s*address|log\s?in|password|web\s*interface)\b/i;
  function pviVoiceMaybeLoadDocs(transcript) {
    if (!transcript || rtDocLoading) return;
    // Mary (customer service) never troubleshoots — the doc loader must NOT
    // hijack her session into tech support just because the customer mentions
    // a product name (Jul 30 2026 shop-widget call: Mary was mid-tracking and a
    // doc restart yanked the call to John). A REAL transfer to support sets
    // pviActivePersona='support' first, after which docs load normally.
    if (pviActivePersona === 'service' || pviActivePersona === 'reception') return;
    var lower = transcript.toLowerCase();

    // Check current transcript AND recent chat history for model + support context
    var recentContext = '';
    for (var rc = Math.max(0, chatHistory.length - 6); rc < chatHistory.length; rc++) {
      recentContext += ' ' + (chatHistory[rc].content || '');
    }
    var combinedLower = (recentContext + ' ' + transcript).toLowerCase();

    var mentionedModel = pviDetectMentionedModel(lower) || pviDetectMentionedModel(combinedLower);
    if (!mentionedModel) return;

    // Detect if this is a DIFFERENT product than what we're currently discussing
    var isSwitchingProduct = rtCurrentProductKeyword && mentionedModel !== rtCurrentProductKeyword;

    if (isSwitchingProduct) {
      console.log('[PVI Voice] Product switch: ' + rtCurrentProductKeyword + ' → ' + mentionedModel + ' — letting AI re-qualify');
      rtCurrentProductKeyword = mentionedModel;
      return;
    }

    // PRICE / BUY intent in the customer's latest words is a SALES signal — NOT
    // a request for support manuals. Do NOT load docs (which would re-pin the
    // session to support and inject the wrong content). Let the worker flip the
    // session to sales and let the AI answer with the price.
    if (PVI_VOICE_BUY_RE.test(lower) && !PVI_VOICE_SUPPORT_RE.test(lower)) {
      console.log('[PVI Voice] Buy/price intent — skipping support doc load (sales signal)');
      rtCurrentProductKeyword = mentionedModel;
      return;
    }

    // STRICT: docs are loaded ONLY when the session is confirmed in support
    // mode (worker state via set_conversation_mode, or a tech-support page).
    // No keyword guessing — a sales question about multicast must NOT load
    // support docs. The worker enforces this too.
    var hasSupportContext = pviIsSupportPage || chosenPersona === 'support';

    if (rtDocModelLoaded && rtDocModelLoaded === mentionedModel) return;

    if (!hasSupportContext) {
      rtCurrentProductKeyword = mentionedModel;
      return;
    }

    // On a support page, the worker already baked this page's docs into the
    // session prompt at connection time — restarting to "load" them again
    // would only interrupt the conversation for nothing.
    if (pviIsSupportPage) {
      var kwSlug = mentionedModel.replace(/[ +]+/g, '-');
      if (location.pathname.toLowerCase().indexOf(kwSlug) !== -1) {
        rtCurrentProductKeyword = mentionedModel;
        return;
      }
    }

    rtCurrentProductKeyword = mentionedModel;
    var allText = chatHistory.map(function(m) { return m.content || ''; }).join(' ');
    rtDocLoading = true;
    console.log('[PVI Voice] Product + support context confirmed — fetching KV docs...');

    fetch(API_BASE + '/api/voice-support-docs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        transcript: allText,
        product_title: (product && product.title) || '',
        product_handle: (product && product.handle) || '',
        page_type: pageCtx.page_type || '',
        page_title: pageCtx.page_title || '',
        collection_handle: pageCtx.collection_handle || '',
        page_handle: pageCtx.page_handle || '',
        session_id: sessionId,
        latest_user: transcript,
        persona: chosenPersona === 'support' ? 'support' : '',
        language: currentLang
      })
    }).then(function(resp) { return resp.json(); })
      .then(function(data) {
        rtDocLoading = false;
        // Worker flipped us to sales (price/buy intent) — drop support context so
        // we don't keep trying to load manuals; the AI now answers with pricing.
        if (data && data.mode === 'sales') {
          chosenPersona = 'sales';
          rtDocModelLoaded = null;
          rtDocInstructions = null;
          try { pviSaveSession(); } catch (_) {}
          return;
        }
        if (!data || !data.modelKey || !data.instructions) return;
        if (rtDocModelLoaded === data.modelKey) {
          if (rtDataChannel && rtDataChannel.readyState === 'open') {
            rtDataChannel.send(JSON.stringify({
              type: 'session.update',
              session: { instructions: data.instructions }
            }));
          }
          return;
        }
        rtDocModelLoaded = data.modelKey;
        rtDocInstructions = data.instructions;
        // NEVER restart the session mid-speech or while a page switch is
        // pending — tearing down WebRTC while the AI is talking (e.g. right
        // after a set_conversation_mode tool call) sounds like a CRASH.
        if (rtPendingNavUrl) {
          console.log('[PVI Voice] Docs ready but navigation pending — new page will load them');
          return;
        }
        // Session already speaking AS JOHN (support persona = same voice): no
        // restart needed — swap the instructions into the LIVE session and
        // continue. The old teardown+restart here caused ~5-10s of dead air
        // plus an amnesia greeting ("what do you need help with?" while a
        // reset procedure was mid-step — Jul 31 VuMATRIX session). A restart
        // is only required when the VOICE must change (e.g. Lisa's session
        // loading support docs = John must pick up).
        if (rtSessionPersona === 'support' && rtDataChannel && rtDataChannel.readyState === 'open') {
          console.log('[PVI Voice] Docs ready — session already support, swapping in place (no restart)');
          try {
            rtDataChannel.send(JSON.stringify({
              type: 'session.update',
              session: { instructions: data.instructions }
            }));
          } catch (err) { console.error('[PVI Voice] Doc session.update error:', err); }
          if (rtAISpeaking || rtAudioPlaying || rtToolCallInFlight) {
            rtDocAnnouncePending = true;
          } else {
            pviDoDocAnnounce();
          }
          return;
        }
        if (rtAISpeaking || rtAudioPlaying || rtToolCallInFlight) {
          console.log('[PVI Voice] Docs ready — deferring restart until AI finishes speaking');
          rtDocRestartPending = true;
          return;
        }
        pviDoDocRestart();
      }).catch(function(err) {
        rtDocLoading = false;
        console.error('[PVI Voice] Doc fetch failed:', err);
      });
  }

  function handleRealtimeEvent(e) {
    var event;
    try { event = JSON.parse(e.data); } catch(_) { return; }

    switch (event.type) {
      case 'session.created':
      case 'session.updated':
        console.log('[PVI Voice]', event.type);
        break;

      case 'response.created':
        rtAISpeaking = true;
        if (rtMicHoldUntilDone) {
          // Programmatic greeting/confirmation the customer did NOT prompt. Keep
          // the mic MUTED for the whole response so the AI never hears its own
          // greeting (residual speaker echo) and interrupts + repeats itself.
          // Barge-in is irrelevant here — the customer just triggered this and
          // it's one short line. The mic re-opens on response.done.
          if (rtMicStream) {
            rtMicStream.getAudioTracks().forEach(function(track) { track.enabled = false; });
          }
          console.log('[PVI Voice] Greeting/confirmation — mic held muted (no self-interrupt)');
        } else if (rtEchoSafe) {
          // ECHO-SAFE MODE: speaker echo was self-interrupting the AI (car
          // Bluetooth / speakerphone). Mute the mic for the whole answer; it
          // reopens when the audio playback finishes (output_audio_buffer.stopped).
          if (rtMicStream) {
            rtMicStream.getAudioTracks().forEach(function(track) { track.enabled = false; });
          }
          console.log('[PVI Voice] AI speaking — mic muted (echo-safe mode)');
        } else {
          // Real answer: mic STAYS LIVE while the AI speaks so the customer can
          // interrupt (barge-in). Echo is handled by the mic's echo cancellation
          // + server VAD; the server's interrupt_response truncates the AI the
          // moment genuine speech is detected.
          if (rtMicStream) {
            rtMicStream.getAudioTracks().forEach(function(track) { track.enabled = true; });
          }
          console.log('[PVI Voice] AI speaking — mic live for barge-in');
        }
        break;

      case 'output_audio_buffer.started':
        rtAudioPlaying = true;
        break;

      case 'output_audio_buffer.cleared':
        // Barge-in: the customer interrupted and the buffered audio was dropped.
        rtAudioPlaying = false;
        break;

      case 'output_audio_buffer.stopped':
        rtAudioPlaying = false;
        // ECHO-SAFE MODE: audio playback truly finished — now it is safe to
        // reopen the mic (response.done fires while audio may still be playing,
        // which is exactly when echo re-triggers the loop).
        if (rtEchoSafe) {
          setTimeout(function() {
            try { rtDataChannel.send(JSON.stringify({ type: 'input_audio_buffer.clear' })); } catch(ex) {}
            if (rtMicStream && !rtAISpeaking) {
              rtMicStream.getAudioTracks().forEach(function(track) { track.enabled = true; });
              console.log('[PVI Voice] Mic back ON (echo-safe, audio finished)');
            }
          }, 800);
        }
        // AI audio playback finished. If a page switch is pending, go now —
        // but only if the transition sentence had time to play (>2s), so we
        // don't navigate on the tail end of the PREVIOUS response's audio.
        if (rtPendingNavUrl && (Date.now() - rtPendingNavSetAt) > 2000) {
          setTimeout(pviExecutePendingNav, 350);
          break;
        }
        // Live persona transfer: the transition line finished playing — bring
        // the new colleague (voice) on the line now.
        if (rtPendingPersonaRestart && (Date.now() - rtPendingPersonaSetAt) > 1500) {
          setTimeout(pviExecutePersonaRestart, 350);
          break;
        }
        // EARLY stop (= tail of the PREVIOUS reply; the transition line has not
        // played yet): re-arm a SHORT net so we never sit in silence. If the
        // transition line starts, its own stopped event restarts; if nothing
        // plays, the new colleague picks up in ~1.8s.
        if (rtPendingPersonaRestart) {
          if (rtPendingPersonaTimer) clearTimeout(rtPendingPersonaTimer);
          rtPendingPersonaTimer = setTimeout(pviExecutePersonaRestart, 1800);
          break;
        }
        rtToolCallInFlight = false;
        // Audio is idle — safe to apply a deferred doc-reload restart now
        if (rtDocRestartPending && !rtPendingNavUrl) {
          setTimeout(function() {
            if (rtDocRestartPending && !rtAISpeaking && !rtPendingNavUrl) pviDoDocRestart();
          }, 500);
        }
        // Docs were swapped in place while the AI was talking — continue the
        // pending question now that the audio is idle.
        if (rtDocAnnouncePending && !rtPendingNavUrl) {
          setTimeout(function() {
            if (rtDocAnnouncePending && !rtAISpeaking && !rtAudioPlaying) pviDoDocAnnounce();
          }, 500);
        }
        break;

      case 'response.done':
        rtAISpeaking = false;
        var wasGreetingOrConfirm = rtMicHoldUntilDone;
        rtMicHoldUntilDone = false;
        rtLastResponseDone = Date.now();
        rtResponseCount++;
        // AUTHORITATIVE capture of the AI's spoken turn.
        if (event.response && event.response.output) {
          var rtDoneText = '';
          event.response.output.forEach(function(item) {
            if (item.content) {
              item.content.forEach(function(part) {
                if (part.transcript) rtDoneText += part.transcript;
                else if (part.type === 'text' && part.text) rtDoneText += part.text;
              });
            }
          });
          rtDoneText = (rtDoneText || '').trim();
          if (rtDoneText) {
            injectVoiceLinks(rtDoneText);
            var rtLastMsg = chatHistory.length ? chatHistory[chatHistory.length - 1] : null;
            if (!(rtLastMsg && rtLastMsg.role === 'assistant' && rtLastMsg.content === rtDoneText)) {
              chatHistory.push({ role: 'assistant', content: rtDoneText });
              pviVoiceCheckQuoteConfirm(rtDoneText);
              pviSaveSession();
            }
            pviPushTranscript(true, false);
          }
        }
        try { rtDataChannel.send(JSON.stringify({ type: 'input_audio_buffer.clear' })); } catch(ex) {}
        // After a GREETING or programmatic confirmation the customer did NOT prompt,
        // wait longer (2.5s) before unmuting the mic so the browser's echo canceller
        // can fully lock on. At 1s, residual speaker audio leaks into the mic → the
        // server VAD fires → Whisper hallucinated "support" / "minimod" from noise →
        // the AI jumped to tech support unprompted. For REAL answers (customer-prompted)
        // 1s is fine because echo cancellation is already running and the customer
        // expects the mic to be responsive.
        // ECHO-SAFE MODE: do NOT unmute here — response.done fires while the
        // audio is often STILL PLAYING, and unmuting into playing audio is what
        // feeds the echo loop. output_audio_buffer.stopped reopens the mic, with
        // an 8s safety net below in case that event never arrives.
        if (rtEchoSafe) {
          setTimeout(function() {
            if (rtMicStream && !rtAISpeaking) {
              rtMicStream.getAudioTracks().forEach(function(track) { track.enabled = true; });
            }
          }, 8000);
          break;
        }
        var micDelay = wasGreetingOrConfirm ? 2500 : 1000;
        setTimeout(function() {
          try { rtDataChannel.send(JSON.stringify({ type: 'input_audio_buffer.clear' })); } catch(ex) {}
          if (rtMicStream) {
            rtMicStream.getAudioTracks().forEach(function(track) { track.enabled = true; });
          }
          // Extra buffer clear 500ms after unmute — catches any residual audio that
          // leaked in the instant the mic tracks were re-enabled.
          setTimeout(function() {
            try { rtDataChannel.send(JSON.stringify({ type: 'input_audio_buffer.clear' })); } catch(ex) {}
          }, 500);
          console.log('[PVI Voice] Mic back ON (delay=' + micDelay + 'ms)');
        }, micDelay);
        break;

      case 'conversation.item.input_audio_transcription.completed':
        if (event.transcript) {
          // Echo-loop detection: a REAL transcript (more than a couple words of
          // actual speech) within 6s of a barge-in proves it was the customer.
          // Whisper renders speaker echo as empty or a 1-word hallucination
          // ("you", "thank you") — those do NOT clear the strike.
          if (!rtBargeGotTranscript && (Date.now() - rtLastBargeAt) < 6000 &&
              event.transcript.trim().length >= 10) {
            rtBargeGotTranscript = true;
          }
          // Reject echo: only during/after the GREETING (rtResponseCount <= 1).
          // Whisper transcription is SLOWER than response generation, so by the
          // time the user's real words arrive as a transcript the AI is already
          // speaking its reply (rtAISpeaking = true). We must NOT drop those —
          // they are the user's actual words, not echo. Echo is only a risk
          // right after the greeting when the echo canceller hasn't locked on.
          // Aug 11 2026 fix: the window used to drop EVERYTHING — a customer who
          // answered during/right after the greeting vanished from the transcript
          // (the AI still heard them server-side, so the log showed the AI
          // "talking to itself"). Echo has a signature: a SHORT Whisper
          // hallucination ("you", "thank you") or a fragment of the AI's OWN
          // words picked up from the speaker. Only drop THOSE — keep real speech.
          if (rtResponseCount <= 1) {
            var echoWindow = 2500;
            if (rtAISpeaking || (Date.now() - rtLastResponseDone < echoWindow)) {
              var pviNormEcho = function (s) {
                return String(s || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
              };
              var echoT = pviNormEcho(event.transcript);
              var aiRecentSpeech = pviNormEcho(rtCurrentAIText);
              for (var ehi = chatHistory.length - 1; ehi >= 0 && ehi >= chatHistory.length - 3; ehi--) {
                if (chatHistory[ehi].role === 'assistant') aiRecentSpeech += ' ' + pviNormEcho(chatHistory[ehi].content);
              }
              var pviIsEcho = echoT.length < 12 || aiRecentSpeech.indexOf(echoT) !== -1;
              if (pviIsEcho) {
                console.log('[PVI Voice] Ignoring echo transcript (greeting window):', event.transcript);
                break;
              }
              console.log('[PVI Voice] Keeping real customer speech in greeting window:', event.transcript);
            }
          }
          appendMessage('user', event.transcript);
          chatHistory.push({ role: 'user', content: event.transcript });

          // NO keyword guessing here. The conversation mode is decided by the
          // worker state machine: the AI asks the qualification question and
          // calls set_conversation_mode — handled in the function_call branch
          // below, which also performs the support-page auto-navigation.
          pviSaveSession();
          pviPushTranscript();
          pviVoiceMaybeLoadDocs(event.transcript);
        }
        break;

      case 'response.audio_transcript.delta':
        if (!rtCurrentAITextEl) {
          rtCurrentAITextEl = appendMessage('ai', '');
          rtCurrentAIText = '';
        }
        rtCurrentAIText += event.delta || '';
        if (rtCurrentAITextEl) rtCurrentAITextEl.innerHTML = formatMessage(rtCurrentAIText);
        scrollToBottom();
        break;

      case 'response.audio_transcript.done':
        if (rtCurrentAIText) {
          chatHistory.push({ role: 'assistant', content: rtCurrentAIText });
          pviSaveSession();
          injectVoiceLinks(rtCurrentAIText);
          pviVoiceCheckQuoteConfirm(rtCurrentAIText);
          pviPushTranscript();
        }
        rtCurrentAITextEl = null;
        rtCurrentAIText = '';
        break;

      case 'input_audio_buffer.speech_started':
        if (suggestions) suggestions.style.display = 'none';
        if (rtAISpeaking) {
          // BARGE-IN: the customer started talking while the AI was speaking.
          // Mark the AI as no longer holding the floor so their upcoming transcript
          // is accepted (not treated as echo), and let the server's interrupt_response
          // truncate the AI's audio. We do NOT pause the audio element here — the
          // live WebRTC track goes silent on its own when the server truncates, and
          // pausing would fight the iOS audio auto-resume listener.
          console.log('[PVI Voice] Barge-in — customer interrupted, yielding the floor');
          rtAISpeaking = false;
          rtCurrentAITextEl = null;
          rtCurrentAIText = '';
          // Echo-loop detection: if no real user transcript follows this
          // interruption within 4s, it was the AI's own voice echoing back.
          rtLastBargeAt = Date.now();
          rtBargeGotTranscript = false;
          setTimeout(pviEchoStrike, 4000);
        } else {
          console.log('[PVI Voice] User speaking');
        }
        break;

      case 'response.function_call_arguments.done':
        // The voice AI called a function. Two kinds:
        //   set_conversation_mode → worker updates session state, frontend
        //     applies persona/link/navigation. NOT a lead.
        //   quote/ticket/callback → lead capture (KV save + email).
        console.log('[PVI Voice] Function call:', event.name, event.arguments);
        // Block doc-reload session restarts until the post-tool spoken response
        // finishes (cleared on output_audio_buffer.stopped, 20s safety net).
        rtToolCallInFlight = true;
        setTimeout(function() { rtToolCallInFlight = false; }, 20000);
        // Mark lead tools submitted IMMEDIATELY to prevent pviVoiceCheckQuoteConfirm duplicates.
        // Knowledge/service retrievals and Mary's service actions (lookup_manual, lookup_order,
        // email_tracking, check_stock, lookup_customer, check_reseller_discount, reset_customer_login,
        // verify_order_for_address_change, update_shipping_address) are NOT lead submissions — never flag them.
        if (event.name !== 'set_conversation_mode' && event.name !== 'lookup_manual' &&
            event.name !== 'lookup_order' && event.name !== 'email_tracking' && event.name !== 'check_stock' &&
            event.name !== 'lookup_customer' && event.name !== 'check_reseller_discount' && event.name !== 'reset_customer_login' &&
            event.name !== 'verify_order_for_address_change' && event.name !== 'update_shipping_address') pviVoiceQuoteSubmitted = true;
        try {
          var toolArgs = JSON.parse(event.arguments);
          var toolPayload = {
            tool_name: event.name,
            arguments: toolArgs,
            product_title: (product && product.title) || '',
            product_handle: (product && product.handle) || '',
            page_handle: pageCtx.page_handle || '',
            session_id: sessionId,
            transcript: chatHistory.slice(-20),
            language: currentLang
          };
          fetch(API_BASE + '/api/voice-tool-call', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(toolPayload)
          }).then(function(resp) { return resp.json(); }).then(function(data) {
            console.log('[PVI Voice] Tool call processed:', data.success, data.key || data.mode_update);
            // Worker REJECTED the lead (missing name/email/phone): nothing was
            // submitted, so clear the submitted flag — a later, complete call
            // must still go through.
            var rejected = (data.success === false);
            if (rejected && event.name !== 'set_conversation_mode' && event.name !== 'lookup_manual') pviVoiceQuoteSubmitted = false;
            // Send the tool result back to the Realtime API so the AI can confirm
            // (or, on rejection, collect the missing details and retry).
            if (rtDataChannel && rtDataChannel.readyState === 'open') {
              rtDataChannel.send(JSON.stringify({
                type: 'conversation.item.create',
                item: {
                  type: 'function_call_output',
                  call_id: event.call_id,
                  output: JSON.stringify({ success: !rejected, message: data.result || (rejected ? 'Not submitted.' : 'Submitted successfully.') })
                }
              }));
              // The spoken confirmation for a mode switch or a lead submission is
              // a short, programmatic line the customer did NOT prompt — hold the
              // mic so the AI doesn't hear/interrupt itself (the "Hi… Hi…" bug
              // when switching to support). lookup_manual / lookup_order /
              // email_tracking / lookup_customer / reset_customer_login / the address-change
              // tools are real answers, so they keep the mic live for barge-in.
              if (event.name !== 'lookup_manual' && event.name !== 'lookup_order' && event.name !== 'email_tracking' &&
                  event.name !== 'lookup_customer' && event.name !== 'check_reseller_discount' && event.name !== 'reset_customer_login' &&
                  event.name !== 'verify_order_for_address_change' && event.name !== 'update_shipping_address') rtMicHoldUntilDone = true;
              rtDataChannel.send(JSON.stringify({ type: 'response.create' }));
            }
            // Mode switch: apply persona + support link + auto-navigation.
            // Longer delay so the AI's spoken confirmation can start first;
            // the voice session restarts on the support page with the right docs.
            if (data.mode_update) {
              pviApplyModeUpdate(data.mode_update, 2500);
            }
          }).catch(function(err) {
            console.error('[PVI Voice] Tool call error:', err);
            if (rtDataChannel && rtDataChannel.readyState === 'open') {
              rtDataChannel.send(JSON.stringify({
                type: 'conversation.item.create',
                item: {
                  type: 'function_call_output',
                  call_id: event.call_id,
                  output: JSON.stringify({ success: false, message: 'Submission failed, please try again.' })
                }
              }));
              if (event.name !== 'lookup_manual') rtMicHoldUntilDone = true;
              rtDataChannel.send(JSON.stringify({ type: 'response.create' }));
            }
          });
        } catch(parseErr) {
          console.error('[PVI Voice] Tool call parse error:', parseErr);
        }
        break;

      case 'response.cancelled':
        console.log('[PVI Voice] Response cancelled (likely barge-in)');
        rtCurrentAITextEl = null;
        rtCurrentAIText = '';
        break;

      case 'error':
        console.error('[PVI Voice] Realtime error:', event);
        break;
    }
  }

  // ════════════════════════════════════════════════════════
  // MODE TOGGLE
  // ════════════════════════════════════════════════════════
  function updateModeToggleUI() {
    if (!modeToggle || !modeToggleLabel) return;
    if (currentMode === 'voice') {
      modeToggle.classList.remove('pvi-mode-text');
      modeToggle.classList.add('pvi-mode-voice');
      modeToggleLabel.textContent = t().textMode;
    } else {
      modeToggle.classList.remove('pvi-mode-voice');
      modeToggle.classList.add('pvi-mode-text');
      modeToggleLabel.textContent = t().voiceMode;
    }
  }

  function setMode(mode) {
    currentMode = mode;
    updateModeToggleUI();
    if (mode === 'voice') {
      if (micBtn) micBtn.style.display = 'flex';
      if (suggestions) suggestions.style.display = 'none';
      stopAudio();
      if (!rtPC) {
        startRealtimeVoice().catch(function() { setMode('text'); });
      }
    } else {
      if (micBtn) micBtn.style.display = 'none';
      if (chatTextarea) chatTextarea.placeholder = t().placeholder;
      stopAudio();
      stopRealtimeVoice();
    }
    pviSaveSession();
  }

  if (modeToggle) {
    modeToggle.addEventListener('click', function() {
      setMode(currentMode === 'voice' ? 'text' : 'voice');
    });
  }

  if (voiceSelect) {
    voiceSelect.addEventListener('change', function() {
      selectedVoice = voiceSelect.value;
      if (currentMode === 'voice' && rtPC) {
        stopRealtimeVoice();
        setTimeout(function() {
          startRealtimeVoice().catch(function() { setMode('text'); });
        }, 200);
      }
    });
  }

  if (speedSelect) {
    speedSelect.addEventListener('change', function() {
      selectedSpeed = parseFloat(speedSelect.value) || 1.0;
      if (currentMode === 'voice' && rtPC) {
        stopRealtimeVoice();
        setTimeout(function() {
          startRealtimeVoice().catch(function() { setMode('text'); });
        }, 200);
      }
    });
  }

  function switchLanguage(newLang) {
    if (!I18N[newLang] || newLang === currentLang) return;
    currentLang = newLang;
    try { localStorage.setItem('pvi-lang', newLang); } catch(_) {}
    if (langSelect) langSelect.value = newLang;
    renderWelcomeAndChips();
    if (currentMode === 'voice' && rtPC) {
      stopRealtimeVoice();
      setTimeout(function() {
        startRealtimeVoice().catch(function() { setMode('text'); });
      }, 200);
    }
  }

  if (langSelect) {
    langSelect.addEventListener('change', function() {
      switchLanguage(langSelect.value);
    });
  }

  // Mic button: in voice mode, toggle to mute/unmute the local mic track
  if (micBtn) {
    micBtn.addEventListener('click', function() {
      if (currentMode !== 'voice') return;
      if (!rtMicStream) return;
      var tracks = rtMicStream.getAudioTracks();
      if (!tracks.length) return;
      var enabled = !tracks[0].enabled;
      tracks.forEach(function(track) { track.enabled = enabled; });
      if (enabled) {
        micBtn.classList.add('pvi-mic-active');
        if (chatTextarea) chatTextarea.placeholder = t().listening;
      } else {
        micBtn.classList.remove('pvi-mic-active');
        if (chatTextarea) chatTextarea.placeholder = '\uD83D\uDD07 ' + t().placeholder;
      }
    });
  }

  // ════════════════════════════════════════════════════════
  // AUTO-EXPAND TEXTAREA
  // ════════════════════════════════════════════════════════
  if (chatTextarea) {
    chatTextarea.addEventListener('input', function() {
      chatTextarea.style.height = 'auto';
      chatTextarea.style.height = Math.min(chatTextarea.scrollHeight, 120) + 'px';
    });
    chatTextarea.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
    });
  }
  if (chatSend) {
    chatSend.addEventListener('click', function() { sendMessage(); });
  }

  // ════════════════════════════════════════════════════════
  // SUGGESTION CHIPS
  // ════════════════════════════════════════════════════════
  if (suggestions) {
    suggestions.addEventListener('click', function(e) {
      var chip = e.target.closest && e.target.closest('.pvi-chat-chip');
      if (!chip) return;
      if (chip.tagName === 'A') return;
      var lang = chip.getAttribute('data-lang');
      if (lang) {
        e.preventDefault();
        switchLanguage(lang);
        return;
      }
      var prompt = chip.getAttribute('data-prompt');
      if (prompt) {
        e.preventDefault();
        // One-shot department hint riding on THIS message only (consumed by
        // the next /api/chat call) — deterministic routing in every language.
        pviChipPersonaHint = chip.getAttribute('data-persona') || '';
        sendMessage(prompt);
      }
    });
  }

  // ════════════════════════════════════════════════════════
  // SEND MESSAGE
  // ════════════════════════════════════════════════════════
  var activeAbort = null;

  function sendMessage(forcedText) {
    var text = forcedText || (chatTextarea ? chatTextarea.value.trim() : '');
    if (!text) return;

    chatGeneration++;
    stopAudio();
    if (activeAbort) { try { activeAbort.abort(); } catch(e) {} }
    isStreaming = false;

    if (chatTextarea && !forcedText) { chatTextarea.value = ''; chatTextarea.style.height = 'auto'; }
    if (suggestions) suggestions.style.display = 'none';

    appendMessage('user', text);
    chatHistory.push({ role: 'user', content: text });

    // NO keyword guessing here. The worker state machine decides the mode:
    // the AI asks the qualification question when needed and calls
    // set_conversation_mode — delivered back as a mode_update SSE event
    // (handled in streamChat), which applies persona + link + navigation.
    pviSaveSession();
    streamChat();
  }

  // ════════════════════════════════════════════════════════
  // APPEND MESSAGE
  // ════════════════════════════════════════════════════════
  function appendMessage(role, content) {
    if (!chatMessages) return null;
    // Persona name label — printed once whenever the answering colleague
    // CHANGES (Dana → Lisa/John/Mary), like a real office chat handoff.
    if (role !== 'user' && pviActivePersona && PVI_PERSONA_LABELS[pviActivePersona] && pviActivePersona !== pviLastLabeledPersona) {
      var plbl = document.createElement('div');
      plbl.className = 'pvi-chat-persona-label';
      plbl.style.cssText = 'font-size:11px;font-weight:600;color:#8a8a8a;margin:10px 0 2px 40px;';
      plbl.textContent = PVI_PERSONA_LABELS[pviActivePersona];
      chatMessages.appendChild(plbl);
      pviLastLabeledPersona = pviActivePersona;
    }
    var div = document.createElement('div');
    div.className = 'pvi-chat-msg pvi-chat-msg-' + (role === 'user' ? 'user' : 'ai');
    if (role !== 'user') {
      var av = document.createElement('div');
      av.className = 'pvi-chat-msg-avatar';
      av.innerHTML = '<span class="pvi-ai-sparkle">✦</span>';
      div.appendChild(av);
    }
    var bubble = document.createElement('div');
    bubble.className = 'pvi-chat-msg-bubble';
    bubble.innerHTML = content;
    div.appendChild(bubble);
    chatMessages.appendChild(div);
    scrollToBottom();
    return bubble;
  }
  // Retro-label the IN-FLIGHT streaming bubble after a mid-stream persona
  // switch (store-project bug report Jul 30 2026): the worker's mode_update
  // arrives WHILE the AI reply is streaming, i.e. after appendMessage already
  // stamped the label from the OLD persona — so Mary's first message rendered
  // under "Dana · Reception". Swap (or insert) the label on the last AI bubble.
  function pviRetagStreamingLabel() {
    if (!isStreaming || !chatMessages) return;
    var lbl = pviActivePersona && PVI_PERSONA_LABELS[pviActivePersona];
    if (!lbl || pviLastLabeledPersona === pviActivePersona) return;
    var msgs = chatMessages.querySelectorAll('.pvi-chat-msg-ai');
    var target = msgs.length ? msgs[msgs.length - 1] : null;
    if (!target) return;
    var prev = target.previousElementSibling;
    if (prev && prev.className === 'pvi-chat-persona-label') {
      prev.textContent = lbl;
    } else {
      var el = document.createElement('div');
      el.className = 'pvi-chat-persona-label';
      el.style.cssText = 'font-size:11px;font-weight:600;color:#8a8a8a;margin:10px 0 2px 40px;';
      el.textContent = lbl;
      chatMessages.insertBefore(el, target);
    }
    pviLastLabeledPersona = pviActivePersona;
  }
  var _streamScrollDone = false;
  function scrollToBottom() { if (chatBody) chatBody.scrollTop = chatBody.scrollHeight; }
  function scrollPinAIResponse(msgDiv) {
    if (!chatBody || !msgDiv || _streamScrollDone) return;
    _streamScrollDone = true;
    var offset = msgDiv.offsetTop - chatBody.offsetTop - 40;
    chatBody.scrollTop = Math.max(0, offset);
  }

  // ════════════════════════════════════════════════════════
  // STREAM CHAT + SENTENCE-BY-SENTENCE TTS
  // ════════════════════════════════════════════════════════
  function streamChat() {
    isStreaming = true;
    updateSendButton(true);

    _streamScrollDone = false;
    var bubble = appendMessage('ai', '<span class="pvi-typing"><span></span><span></span><span></span></span>');
    var aiBubbleDiv = bubble ? bubble.parentElement : null;
    var firstChunk = true;
    var fullText = '';
    var spokenTo = 0;
    var myGen = chatGeneration;
    var abortCtrl = new AbortController();
    activeAbort = abortCtrl;

    function stale() { return myGen !== chatGeneration; }

    function trySpeakSentences() {
      if (currentMode !== 'voice' || stale()) return;
      while (true) {
        var rest = fullText.slice(spokenTo);
        var m = rest.match(/^(.*?[.!?])\s/);
        if (!m) break;
        var sentence = m[1].trim();
        if (sentence.length >= 3) {
          queueTTS(sentence);
        }
        spokenTo += m[0].length;
      }
    }

    function speakRemaining() {
      if (currentMode !== 'voice' || stale()) return;
      var rest = fullText.slice(spokenTo).trim();
      if (rest.length >= 2) {
        queueTTS(rest);
        spokenTo = fullText.length;
      }
    }

    // Consume the one-shot chip department hint (set by the chip click
    // handler) — it must ride on exactly this request and never linger.
    var chipHint = pviChipPersonaHint || '';
    pviChipPersonaHint = '';

    fetch(API_BASE + '/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: abortCtrl.signal,
      body: JSON.stringify({
        messages: chatHistory.slice(-20),
        product_title: product.title || '',
        product_handle: product.handle || '',
        page_type: pageCtx.page_type || '',
        page_title: pageCtx.page_title || '',
        collection_handle: pageCtx.collection_handle || '',
        page_handle: pageCtx.page_handle || '',
        session_id: sessionId,
        // Persona only when EXPLICITLY established — otherwise the worker
        // keeps the mode 'unset' and the AI qualifies the customer first.
        // 'service' rides on pviActivePersona (mode_update transfer to Mary).
        persona: pviActivePersona === 'service' ? 'service'
          : (chosenPersona === 'support' ? 'support' : (chosenPersona === 'info' ? 'sales' : (pviCfg.persona === 'support' ? 'support' : ''))),
        // One-shot chip department (set by the chip click handler, consumed
        // here) — the worker routes on it deterministically in any language.
        persona_hint: chipHint,
        has_interacted: hasInteracted,
        language: currentLang
      })
    }).then(function(resp) {
      if (!resp.ok) return resp.json().then(function(e) { throw new Error(e.error || 'fail'); });

      var reader = resp.body.getReader();
      var decoder = new TextDecoder();
      var buf = '';

      function read() {
        reader.read().then(function(r) {
          if (r.done) { finish(); return; }
          buf += decoder.decode(r.value, { stream: true });
          var lines = buf.split('\n');
          buf = lines.pop() || '';
          for (var i = 0; i < lines.length; i++) {
            var ln = lines[i].trim();
            if (!ln.startsWith('data: ')) continue;
            var d = ln.slice(6).trim();
            if (d === '[DONE]') { finish(); return; }
            try {
              var p = JSON.parse(d);
              if (p.content) {
                fullText += p.content;
                if (bubble) bubble.innerHTML = formatMessage(pviMaybeHidePrices(fullText));
                if (firstChunk) { firstChunk = false; scrollPinAIResponse(aiBubbleDiv); }
                trySpeakSentences();
              }
              if (p.mode_update) {
                // Worker confirmed a mode switch (AI called set_conversation_mode)
                pviApplyModeUpdate(p.mode_update, 1800);
              }
            } catch(e) {}
          }
          read();
        }).catch(function() { finish(); });
      }
      read();
    }).catch(function(err) {
      if (err.name === 'AbortError') return;
      if (bubble && !stale()) {
        bubble.innerHTML = 'Connection issue. Call <a href="tel:4077206101" style="color:#0071E3">407-720-6101</a>';
      }
      isStreaming = false; activeAbort = null; updateSendButton(false);
    });

    function finish() {
      isStreaming = false; activeAbort = null; updateSendButton(false);
      if (fullText && !stale()) {
        chatHistory.push({ role: 'assistant', content: fullText });
        pviSaveSession();
        speakRemaining();
        pviCheckForLeadTag(fullText);
        // Text mode only — voice offers are handled by injectVoiceLinks.
        if (currentMode !== 'voice') pviTextMaybeOffer(fullText, bubble);
      }
    }
  }

  // ── Price suppression (shop widget, TEXT chat only) ────────────────
  // Showing prices upfront bounces customers. Prices are shown ONLY if the
  // customer asked for them (any of their messages mentions price/cost/etc.).
  // Otherwise $-amounts are removed from the DISPLAYED reply — the customer
  // clicks the offered link and sees pricing on the product page.
  // (Voice is untouched: we cannot unspeak what the AI says aloud.)
  var PVI_PRICE_ASK_RE = /\b(price|prices|priced|pricing|cost|costs|how much|quote|quotation|estimate|discount|cheap|cheaper|expensive|affordable|budget|deal|deals|msrp|dollars?)\b|\$|how many dollars|cu[aá]nto cuesta|quanto costa/i;
  function pviCustomerAskedPrice() {
    for (var i = 0; i < chatHistory.length; i++) {
      if (chatHistory[i].role === 'user' && PVI_PRICE_ASK_RE.test(chatHistory[i].content || '')) return true;
    }
    return false;
  }
  function pviMaybeHidePrices(t) {
    if (!t || t.indexOf('$') === -1) return t;
    if (currentMode === 'voice') return t;      // spoken audio can't be filtered
    if (pviCustomerAskedPrice()) return t;
    // 1) Drop parentheticals that contain a $amount: "(4-channel: $2,449, ...)"
    var s = t.replace(/\s*\([^()]*\$\s?\d[^()]*\)/g, '');
    // 2) Drop any remaining sentence/line fragment containing a $amount.
    s = s.replace(/[^.!?\n]*\$\s?\d[\d,]*(?:\.\d+)?[^.!?\n]*[.!?]?/g, '');
    // 3) Tidy up: bullets left empty, doubled blank lines/spaces.
    s = s.replace(/^[ \t]*[-\u2022*][ \t]*$/gm, '');
    s = s.replace(/\n{3,}/g, '\n\n').replace(/[ \t]{2,}/g, ' ');
    return s;
  }

  function formatMessage(t) {
    var s = t.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    s = s.replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>');
    // PRODUCT links are presented via the explicit offer card (shop widget), so
    // render a product NAME as bold text here — never an inline link. (Non-product
    // links like /pages/ or /collections/ stay clickable, handled below.)
    s = s.replace(/\[([^\]]+)\]\([^)]*\/products\/[^)]*\)/g, '<strong>$1</strong>');
    s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, function(_,txt,url) {
      var isPVI = /provideoinstruments\.com/i.test(url);
      return '<a href="' + url + '"' + (isPVI ? '' : ' target="_blank" rel="noopener"') + ' style="color:#0071E3;text-decoration:underline">' + txt + '</a>';
    });
    s = s.replace(/\[([^\]]+)\]\((\/[^)]+)\)/g,'<a href="$2" style="color:#0071E3;text-decoration:underline">$1</a>');
    s = s.replace(/(^|[\s>])(https?:\/\/[^\s<"']+)/g, function(m,pre,url) {
      var isPVI = /provideoinstruments\.com/i.test(url);
      return pre + '<a href="' + url + '"' + (isPVI ? '' : ' target="_blank" rel="noopener"') + ' style="color:#0071E3;text-decoration:underline">' + url + '</a>';
    });
    s = s.replace(/\n\n/g,'<br><br>').replace(/\n/g,'<br>');
    return s;
  }
  function updateSendButton(on) { if (chatSend) { chatSend.disabled = on; chatSend.style.opacity = on ? '0.4' : '1'; } }

  // ── Business Hours ───────────────────────────────────
  function pviCheckHours() {
    var btn = document.getElementById('pviTalkHuman');
    if (!btn) return;
    var now = new Date();
    var ct = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    btn.style.display = (ct.getDay() >= 1 && ct.getDay() <= 5 && ct.getHours() >= 9 && ct.getHours() < 17) ? 'flex' : 'none';
  }
  window.pviCheckHours = pviCheckHours;
  pviCheckHours();

  // ── Init ─────────────────────────────────────────────
  setMode('text');

})();

// ── YouTube Video Embed ────────────────────────────────
function pviLoadVideo(sectionId, youtubeId, startAt) {
  var c = document.getElementById('pviVideoContainer-' + sectionId);
  if (!c) return;
  var imgs = c.querySelectorAll('img, div[onclick]');
  imgs.forEach(function(el) { el.style.display = 'none'; });
  var iframe = document.createElement('iframe');
  iframe.id = 'pvi-video-' + sectionId;
  iframe.src = 'https://www.youtube-nocookie.com/embed/' + youtubeId +
    '?rel=0&modestbranding=1&autoplay=1' + (startAt > 0 ? '&start=' + startAt : '');
  iframe.title = 'Product Video';
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.allowFullscreen = true;
  iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none';
  c.appendChild(iframe);
}
function pviSeekVideo(sectionId, youtubeId, seconds) {
  var iframe = document.getElementById('pvi-video-' + sectionId);
  if (iframe) {
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + youtubeId + '?rel=0&modestbranding=1&autoplay=1&start=' + seconds;
  } else { pviLoadVideo(sectionId, youtubeId, seconds); }
  var el = document.getElementById('pviVideoContainer-' + sectionId);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

/** Add 1 of variant to cart and open the quick cart drawer (+1 each click if already in cart). */
function pviAddToCart(variantId) {
  var cart = document.querySelector('cart-drawer');
  if (!variantId) {
    var mainForm = document.querySelector('#MainProduct product-form input[name="id"], #MainProduct input[name="id"]');
    var fallback = document.querySelector('product-form input[name="id"]');
    var input = mainForm || fallback;
    if (!input || !input.value) return;
    variantId = parseInt(input.value, 10);
  }
  if (!variantId) return;

  var sections = '';
  if (cart && typeof cart.getSectionsToRender === 'function') {
    sections = cart.getSectionsToRender().map(function(s) { return s.id; }).join(',');
  }

  var payload = { items: [{ id: variantId, quantity: 1 }] };
  if (sections) {
    payload.sections = sections;
    payload.sections_url = window.location.pathname;
  }

  var addUrl = (window.routes && window.routes.cart_add_url)
    ? window.routes.cart_add_url.replace(/\/cart\/add\/?$/, '/cart/add.js')
    : '/cart/add.js';

  return fetch(addUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  })
    .then(function(r) { return r.json(); })
    .then(function(response) {
      if (response.status) {
        console.error(response.description || response.message);
        return;
      }
      if (cart && response.sections) {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
      } else if (cart) {
        cart.open();
      } else if (window.routes && window.routes.cart_url) {
        window.location.href = window.routes.cart_url;
      }
    })
    .catch(function(err) {
      console.error(err);
      if (window.routes && window.routes.cart_url) window.location.href = window.routes.cart_url;
    });
}

document.addEventListener('click', function(e) {
  var buyBtn = e.target.closest('.pvi-pill-buy');
  if (!buyBtn || buyBtn.closest('product-form')) return;
  e.preventDefault();
  pviAddToCart(buyBtn.getAttribute('data-pvi-buy-variant'));
});

function pviPatchUltraAccessories() {
  if (window.location.pathname.indexOf('/products/vecoax-ultra') === -1) return;
  var section = document.querySelector('.pvi-accessories-wrapper');
  if (!section || section.getAttribute('data-pvi-ultra-accessories') === '1') return;
  var grid = section.querySelector('.pvi-accessories-grid');
  if (!grid) return;

  var subtitle = section.querySelector('.pvi-section-subtitle');
  if (subtitle) {
    subtitle.textContent = 'Everything you need to combine ULTRA+ units and add 4-channel, 8-channel, 4K, rack-mounted HD, and SDI sources.';
  }

  var cards = [
    {
      title: 'Coax Combiner / Splitter (13-Port)',
      description: 'Combine ULTRA+ units with other modulators onto one clean coax distribution line.',
      image: 'https://cdn.shopify.com/s/files/1/0788/6359/7604/files/vecoax-rack-4-4-channel-hdmi-rf-modulator-16-related-coax-combiner-splitter-13-port-tv-coax.png?v=1780520501',
      url: '/products/coax-combiner-splitter',
      variant: '44216996724772',
      price: '$95.00',
      compare: '$105.00',
      save: '$10.00'
    },
    {
      title: 'VeCOAX ULTRA+ 4 Channel',
      description: 'Four-channel HDMI RF modulator chassis for hotels, venues, bars, schools, and commercial coax systems.',
      image: 'https://cdn.shopify.com/s/files/1/0788/6359/7604/files/vecoax-ultra-plus-8-channel-hdmi-rf-modulator-rack-mount-coax-distribution.jpg?v=1781876837',
      url: '/products/vecoax-ultra?variant=44217077465124',
      variant: '44217077465124',
      price: '$2,449.00',
      compare: '$2,890.00',
      save: '$441.00'
    },
    {
      title: 'VeCOAX ULTRA+ 8 Channel',
      description: 'Eight-channel HDMI RF modulator chassis for larger multi-source TV distribution over existing coax.',
      image: 'https://cdn.shopify.com/s/files/1/0788/6359/7604/files/vecoax-ultra-plus-8-channel-hdmi-rf-modulator-rack-mount-coax-distribution.jpg?v=1781876837',
      url: '/products/vecoax-ultra?variant=44217077530660',
      variant: '44217077530660',
      price: '$3,950.00',
      compare: '$5,290.00',
      save: '$1,340.00'
    },
    {
      title: 'MINIMOD-4K Ultra HD',
      description: 'Add a true 4K HDMI channel alongside your ULTRA+ HD channels.',
      image: 'https://cdn.shopify.com/s/files/1/0788/6359/7604/files/vecoax-minimod-4k-uhd-hdmi-rf-modulator-main-features.jpg?v=1780497829',
      url: '/products/vecoax-minimod-4k',
      variant: '44217054101540',
      price: '$1,495.00',
      compare: '$1,950.00',
      save: '$455.00'
    },
    {
      title: 'MINIMOD 2+ HDMI Modulator',
      description: 'Add one independent HD HDMI channel anywhere in the same coax system.',
      image: 'https://cdn.shopify.com/s/files/1/0788/6359/7604/files/hdmi-modulator-front-panel.jpg?v=1780088931',
      url: '/products/vecoax-minimod-2-plus',
      variant: '44177637408804',
      price: '$445.00',
      compare: '$495.00',
      save: '$50.00'
    },
    {
      title: '1RU Rack Panel for MINIMOD Units',
      description: 'Mount up to four MINIMOD modulators in one clean 1RU rack space with front-panel access.',
      image: 'https://cdn.shopify.com/s/files/1/0788/6359/7604/files/rack-panel-1ru-hdmi-modulator.png?v=1780164344',
      url: '/products/1ru-rack-panel-hdmi-modulator',
      variant: '44217002754084',
      price: '$99.00',
      compare: '$105.00',
      save: '$6.00'
    },
    {
      title: 'MICROMOD-3 SDI',
      description: 'Add 3G-SDI, HDMI, AV, closed captions, and analog inputs as another RF TV channel.',
      image: 'https://cdn.shopify.com/s/files/1/0788/6359/7604/files/vecoax-micromod-3-sdi-rf-modulator-01-micromod-3-plus-sdi-front.png?v=1780173968',
      url: '/products/vecoax-micromod-3-sdi',
      variant: '44217313230884',
      price: '$995.00',
      compare: '$1,295.00',
      save: '$300.00'
    }
  ];

  grid.innerHTML = cards.map(function(card, index) {
    return [
      '<div class="pvi-accessory-card">',
      '<a href="' + card.url + '" class="pvi-accessory-image-wrap">',
      '<img src="' + card.image + '" alt="' + card.title.replace(/"/g, '&quot;') + '" class="pvi-accessory-image" loading="lazy" width="600" height="434">',
      '</a>',
      '<h3>' + card.title + '</h3>',
      '<p>' + card.description + '</p>',
      '<div class="pvi-accessory-price">',
      '<span class="pvi-accessory-price-was">' + card.compare + '</span>',
      '<span class="pvi-accessory-price-now">' + card.price + '</span>',
      '<span class="pvi-you-save">You save ' + card.save + '</span>',
      '</div>',
      '<div class="pvi-accessory-buttons">',
      '<button type="button" class="pvi-btn-add-cart" data-pvi-ultra-accessory-variant="' + card.variant + '"><span>Add to Cart</span></button>',
      '<a href="' + card.url + '" class="pvi-btn-view">View &#8594;</a>',
      '</div>',
      '</div>'
    ].join('');
  }).join('');
  section.setAttribute('data-pvi-ultra-accessories', '1');
}

document.addEventListener('DOMContentLoaded', pviPatchUltraAccessories);
document.addEventListener('shopify:section:load', pviPatchUltraAccessories);
setTimeout(pviPatchUltraAccessories, 500);

document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-pvi-ultra-accessory-variant]');
  if (!btn) return;
  e.preventDefault();
  pviAddToCart(btn.getAttribute('data-pvi-ultra-accessory-variant'));
});

/* ════════════════════════════════════════════════════════════════════
   PVI GLOBAL GALLERY SYNC
   Keeps the thumbnail strip in sync with the hero slider when you swipe
   or use the big-picture arrows (Dawn's native slideChanged sync is
   unreliable with our scroll-snap layout). Runs on every product page.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  function initGallery(gallery) {
    if (!gallery || gallery.__pviGallerySynced) return;
    var viewer = gallery.querySelector('.pvi-gallery-slider');
    if (!viewer) return;
    var slides = Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item'));
    if (slides.length < 2) { gallery.__pviGallerySynced = true; gallery.setAttribute('data-pvi-synced', '1'); return; }

    var thumbsList = gallery.querySelector('[id^="Slider-Thumbnails"]');
    var lastIdx = 0;

    /* The hero is a horizontal scroll-snap flex row showing ALL slides, so the
       row would otherwise grow as tall as the TALLEST slide (a portrait shot),
       leaving big dead bands above/below the wide landscape hero images.
       Fix: pin the viewer height to the ACTIVE slide so the frame hugs each
       image — no gap above, thumbnails sit right underneath. */
    function setHeight(slide) {
      var box = slide.querySelector('.product-media-container') || slide;
      var h = box.getBoundingClientRect().height;
      if (h > 0) viewer.style.height = Math.round(h) + 'px';
    }

    function setActive(idx) {
      idx = Math.max(0, Math.min(slides.length - 1, idx));
      var slide = slides[idx];
      if (!slide) return;
      lastIdx = idx;
      var mediaId = slide.getAttribute('data-media-id');

      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', slides[i] === slide);
      }

      setHeight(slide);

      if (!thumbsList) return;
      var items = thumbsList.querySelectorAll('[data-target]');
      for (var j = 0; j < items.length; j++) {
        var item = items[j];
        var btn = item.querySelector('button');
        var on = item.getAttribute('data-target') === mediaId;
        if (btn) {
          if (on) { btn.setAttribute('aria-current', 'true'); }
          else { btn.removeAttribute('aria-current'); }
        }
        if (on) {
          var outLeft = item.offsetLeft < thumbsList.scrollLeft;
          var outRight = (item.offsetLeft + item.clientWidth) > (thumbsList.scrollLeft + thumbsList.clientWidth);
          if (outLeft || outRight) {
            thumbsList.scrollTo({ left: Math.max(0, item.offsetLeft - 8), behavior: 'smooth' });
          }
        }
      }
    }

    var raf;
    viewer.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = viewer.clientWidth || 1;
        setActive(Math.round(viewer.scrollLeft / w));
      });
    }, { passive: true });

    // On resize/orientation change: instantly snap to the current active slide
    // without any visible scrolling animation.
    var rzr;
    var suppressScroll = false;
    viewer.style.scrollSnapType = 'x mandatory';
    window.addEventListener('resize', function () {
      if (rzr) cancelAnimationFrame(rzr);
      rzr = requestAnimationFrame(function () {
        setHeight(slides[lastIdx] || slides[0]);
        suppressScroll = true;
        viewer.style.scrollSnapType = 'none';
        viewer.style.scrollBehavior = 'auto';
        viewer.scrollLeft = lastIdx * (viewer.clientWidth || 1);
        viewer.style.scrollSnapType = 'x mandatory';
        viewer.style.scrollBehavior = '';
        setTimeout(function () { suppressScroll = false; }, 50);
      });
    }, { passive: true });

    gallery.__pviGallerySynced = true;
    gallery.setAttribute('data-pvi-synced', '1');
    // Sync once on init (first non-Google image)
    setActive(Math.round((viewer.clientWidth ? viewer.scrollLeft / viewer.clientWidth : 0)));
    // Re-pin height after images finish loading (aspect boxes settle).
    setTimeout(function () { setHeight(slides[lastIdx] || slides[0]); }, 400);
    window.addEventListener('load', function () { setHeight(slides[lastIdx] || slides[0]); });
  }

  function initAll() {
    var galleries = document.querySelectorAll('.pvi-gallery');
    for (var i = 0; i < galleries.length; i++) initGallery(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  // Variant changes make product-info.js re-render & REPLACE the media-gallery
  // DOM after our first init runs (the replacement has no sync attached, so the
  // height never gets pinned and the gaps come back — this raced badly on
  // mobile). A MutationObserver re-inits whenever a fresh slider is inserted.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      var pending = document.querySelector('media-gallery.pvi-gallery:not([data-pvi-synced]) .pvi-gallery-slider');
      if (pending) initAll();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
  // Belt-and-suspenders: re-pin after late renders settle.
  setTimeout(initAll, 600);
  setTimeout(initAll, 1600);
  setTimeout(initAll, 3000);
})();

/* ════════════════════════════════════════════════════════════════════
   PVI MOBILE ZOOM: PAN + PINCH + TAP-TO-CLOSE
   Full touch-driven image viewer for the product media modal on mobile.
   - One finger: pan (translate)
   - Two fingers: pinch zoom (scale) + pan
   - Double-tap: toggle between fit and 2x zoom
   - Single tap (no drag): close modal
   Desktop is unaffected (pointer: fine guard).
   ════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var scale = 1, posX = 0, posY = 0;
  var startX, startY, startDist, startScale, startPosX, startPosY;
  var media = null, moved = false, tapTime = 0;

  function dist(t) {
    var dx = t[0].clientX - t[1].clientX;
    var dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function apply() {
    if (!media) return;
    media.style.transform = 'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')';
  }

  function reset() { scale = 1; posX = 0; posY = 0; if (media) media.style.transform = ''; media = null; }

  function getMedia(modal) {
    return modal.querySelector('.product-media-modal__content > .active .media') ||
           modal.querySelector('.product-media-modal__content > .active');
  }

  document.addEventListener('touchstart', function (e) {
    var modal = e.target.closest && e.target.closest('.product-media-modal[open]');
    if (!modal) return;
    if (e.target.closest('.product-media-modal__toggle')) return;
    media = getMedia(modal);
    if (!media) return;
    moved = false;
    var t = e.touches;
    startPosX = posX; startPosY = posY; startScale = scale;
    if (t.length === 1) {
      startX = t[0].clientX; startY = t[0].clientY;
    } else if (t.length === 2) {
      startX = (t[0].clientX + t[1].clientX) / 2;
      startY = (t[0].clientY + t[1].clientY) / 2;
      startDist = dist(t);
    }
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var modal = e.target.closest && e.target.closest('.product-media-modal[open]');
    if (!modal || !media) return;
    e.preventDefault();
    moved = true;
    var t = e.touches;
    if (t.length === 1) {
      posX = startPosX + (t[0].clientX - startX);
      posY = startPosY + (t[0].clientY - startY);
    } else if (t.length === 2) {
      var d = dist(t);
      scale = Math.max(0.5, Math.min(5, startScale * (d / startDist)));
      var cx = (t[0].clientX + t[1].clientX) / 2;
      var cy = (t[0].clientY + t[1].clientY) / 2;
      posX = startPosX + (cx - startX);
      posY = startPosY + (cy - startY);
    }
    apply();
  }, { passive: false });

  document.addEventListener('touchend', function (e) {
    var modal = e.target.closest && e.target.closest('.product-media-modal[open]');
    if (!modal) return;
    if (e.target.closest('.product-media-modal__toggle')) return;
    if (!moved) {
      var now = Date.now();
      if (now - tapTime < 300) {
        // Double tap: toggle zoom
        if (scale > 1.2) { scale = 1; posX = 0; posY = 0; }
        else { scale = 2.5; posX = 0; posY = 0; }
        apply();
        tapTime = 0;
      } else {
        tapTime = now;
        // Single tap: close after short delay (if no second tap)
        setTimeout(function () {
          if (tapTime === now) {
            var toggle = modal.querySelector('.product-media-modal__toggle');
            if (toggle) { reset(); toggle.click(); }
          }
        }, 320);
      }
    }
  }, { passive: true });

  // When modal opens in landscape, start at 2x zoom
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.attributeName === 'open' && m.target.classList.contains('product-media-modal')) {
        if (m.target.hasAttribute('open')) {
          media = getMedia(m.target);
          if (window.innerHeight < 500 && window.innerWidth > window.innerHeight) {
            scale = 2; posX = 0; posY = 0; apply();
          } else {
            scale = 1; posX = 0; posY = 0;
          }
        } else {
          reset();
        }
      }
    }
  });
  obs.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
})();

/* ════════════════════════════════════════════════════════════════════
   PVI ARROW CLICK GUARD
   Prevents arrow clicks from bubbling UP to the modal-opener, while
   still letting Dawn's own slider-button handlers fire (they listen
   directly on the button elements). We attach on the .slider-buttons
   container in BUBBLE phase so Dawn's button handler fires first,
   then we kill propagation before it reaches the image/modal-opener.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  function guardArrows() {
    document.querySelectorAll('.pvi-gallery .slider-buttons').forEach(function (btns) {
      if (btns.dataset.pviGuarded) return;
      btns.dataset.pviGuarded = '1';
      btns.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });
  }
  guardArrows();
  document.addEventListener('DOMContentLoaded', guardArrows);
  if (window.MutationObserver) {
    new MutationObserver(guardArrows).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ════════════════════════════════════════════════════════════════════
   PVI DESKTOP ZOOM: MOUSE WHEEL + DRAG-TO-PAN + CLICK-TO-CLOSE
   Only activates on desktop (pointer: fine). Inside the zoom modal:
   - Mouse wheel: zoom in/out centered on cursor position
   - Hold left button + drag: pan around the zoomed image
   - Click (without dragging): close the modal
   - X button: also closes
   ════════════════════════════════════════════════════════════════════ */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var scale = 1, posX = 0, posY = 0;
  var dragging = false, startX, startY, startPosX, startPosY, hasDragged = false;
  var img = null;
  var activeModal = null;
  var clickedMediaId = '';
  var enforcerTimer = null;

  /* Track which gallery image the user clicked (before modal opens) */
  document.addEventListener('click', function (e) {
    var mediaItem = e.target.closest && e.target.closest('.product__media-item, [data-media-id]');
    if (mediaItem && !e.target.closest('.product-media-modal')) {
      clickedMediaId = mediaItem.getAttribute('data-media-id') || '';
    }
  }, true);

  /* Single source of truth for which modal item should be shown.
     Priority: Dawn's own .active (set from the opener's data-media-id),
     then the gallery's is-active slide, then the last-clicked thumb, then first. */
  function getActiveItem(modal) {
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return null;
    var items = content.children;
    if (!items.length) return null;
    var i;
    for (i = 0; i < items.length; i++) {
      if (items[i].classList.contains('active')) return items[i];
    }
    var slide = document.querySelector('.product__media-item.is-active');
    var slideId = slide ? slide.getAttribute('data-media-id') : '';
    if (slideId) {
      for (i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-media-id') === slideId) return items[i];
      }
    }
    if (clickedMediaId) {
      for (i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-media-id') === clickedMediaId) return items[i];
      }
    }
    return items[0];
  }

  function findImg(modal) {
    var item = getActiveItem(modal);
    if (item) {
      // In Dawn's modal, image items ARE the <img> element itself (not a wrapper)
      if (item.tagName === 'IMG') return item;
      var im = item.querySelector('img');
      if (im) return im;
    }
    return modal.querySelector('.product-media-modal__content img');
  }

  function apply() {
    if (!img) return;
    img.style.transform = 'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')';
    img.style.transformOrigin = 'center center';
  }

  function reset() {
    scale = 1; posX = 0; posY = 0;
    if (img) { img.style.transform = ''; img.style.cursor = ''; }
    img = null; dragging = false;
  }

  function updateCursor() {
    if (!img) return;
    img.style.cursor = scale > 1.05 ? 'grab' : 'zoom-in';
  }

  function enforceOneImage(modal) {
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;
    var items = content.children;
    if (!items.length) return;

    var target = getActiveItem(modal);
    if (!target) return;

    /* Use setProperty (NOT cssText) so we never wipe the zoom transform that
       lives on the active <img>. Dawn's image items ARE the <img> elements. */
    for (var i = 0; i < items.length; i++) {
      if (items[i] === target) {
        items[i].style.setProperty('display', 'block', 'important');
        items[i].style.setProperty('max-width', '80vw');
        items[i].style.setProperty('max-height', '80vh');
        items[i].style.setProperty('margin', 'auto');
        items[i].classList.add('active');
      } else {
        items[i].style.setProperty('display', 'none', 'important');
        items[i].classList.remove('active');
      }
    }

    modal.style.overflow = 'hidden';
    content.style.overflow = 'visible';
    content.style.display = 'flex';
    content.style.alignItems = 'center';
    content.style.justifyContent = 'center';
    content.style.maxWidth = '80vw';
    content.style.maxHeight = '80vh';

    var dialog = modal.querySelector('.product-media-modal__dialog');
    if (dialog) {
      dialog.style.overflow = 'visible';
      dialog.style.maxWidth = '80vw';
      dialog.style.maxHeight = '80vh';
      dialog.style.margin = 'auto';
    }
  }

  function startEnforcer(modal) {
    enforceOneImage(modal);
    var runs = 0;
    if (enforcerTimer) clearInterval(enforcerTimer);
    enforcerTimer = setInterval(function () {
      if (!modal.hasAttribute('open') || runs > 20) {
        clearInterval(enforcerTimer);
        enforcerTimer = null;
        return;
      }
      enforceOneImage(modal);
      runs++;
    }, 50);
  }

  /* WHEEL ZOOM — re-finds the active image fresh on every event so it works
     for ANY image, not just the first. Centered on the cursor. */
  document.addEventListener('wheel', function (e) {
    var modal = e.target.closest && e.target.closest('.product-media-modal[open]');
    if (!modal) return;
    e.preventDefault();
    e.stopPropagation();

    img = findImg(modal);
    if (!img) return;

    var rect = img.getBoundingClientRect();
    var cx = e.clientX - rect.left - rect.width / 2;
    var cy = e.clientY - rect.top - rect.height / 2;

    var oldScale = scale;
    var factor = e.deltaY > 0 ? 0.88 : 1.14;
    scale = Math.max(0.5, Math.min(8, scale * factor));

    var ratio = scale / oldScale;
    posX = posX * ratio - cx * (ratio - 1);
    posY = posY * ratio - cy * (ratio - 1);

    apply();
    updateCursor();
  }, { capture: true, passive: false });

  /* DRAG-TO-PAN via POINTER events (mouse only). Dawn closes the modal on
     `pointerup`, which fires BEFORE mouseup — so we MUST handle the drag with
     pointer events and suppress that exact pointerup when a drag happened. */
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var modal = e.target.closest && e.target.closest('.product-media-modal[open]');
    if (!modal) return;
    if (e.target.closest('.product-media-modal__toggle')) return;

    img = findImg(modal);
    if (!img) return;

    dragging = true;
    hasDragged = false;
    startX = e.clientX;
    startY = e.clientY;
    startPosX = posX;
    startPosY = posY;
    img.style.cursor = 'grabbing';
    e.preventDefault();
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!dragging || !img) return;
    var dx = e.clientX - startX;
    var dy = e.clientY - startY;
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) hasDragged = true;
    posX = startPosX + dx;
    posY = startPosY + dy;
    apply();
  }, true);

  /* Capture-phase pointerup at document level fires BEFORE Dawn's bubble-phase
     pointerup listener on the modal. If the user dragged, we kill the event so
     Dawn never runs hide(). A plain click (no drag) is left alone, so Dawn's
     own pointerup closes the modal — exactly the behaviour we want. */
  document.addEventListener('pointerup', function (e) {
    if (!dragging) return;
    var didDrag = hasDragged;
    dragging = false;
    updateCursor();
    if (didDrag) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.attributeName === 'open' && m.target.classList.contains('product-media-modal')) {
          var modalEl = m.target;
          if (modalEl.hasAttribute('open')) {
            activeModal = modalEl;
            startEnforcer(modalEl);
            scale = 1; posX = 0; posY = 0;
            setTimeout((function (md) {
              return function () {
                img = findImg(md);
                if (img) { img.style.transform = ''; updateCursor(); }
              };
            })(modalEl), 120);
          } else {
            if (enforcerTimer) { clearInterval(enforcerTimer); enforcerTimer = null; }
            reset();
            activeModal = null;
          }
        }
      }
    }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }
})();
